export const allCards = [
  "Brilliant Fairy",
  "Noxious Elf",
  "Aerin, Forever Brilliant",
  "Flower Fox",
  "King of Vines",
  "Blast Fairy",
  "Wellspring Elf Princess",
  "Aqua Fairy",
  "Lily, Crystalian Conductor",
  "Coldhearted Dark Elf",
  "Fairy Bringer",
  "Wily Puck",
  "Dungeoncrawl Fairy",
  "Seed Barrage",
  "Victorious Blader",
  "Golden Warrior",
  "Armelize, Opulent Strategist",
  "Assault Knight",
  "Fangblade Slayer",
  "Claymore Master",
  "Axe Pirate",
  "Armed Butler",
  "Shield Phalanx",
  "Calculating Captain",
  "Suave Bandit",
  "Sword-Swinging Bandit",
  "Resplendent Knight",
  "Wandering Knight",
  "Chrono Witch",
  "Pursuer Golem",
  "Levi, Wizard of Ages",
  "Witching Moggy",
  "Great Magician",
  "Lazuli, Gateway Homunculus",
  "Elina, Winged Evangelist",
  "Parasol Witch",
  "Carnelia, Servant of Darkness",
  "Blade Mage",
  "Frost Golem",
  "Iceshard Beast",
  "Golem Assault",
  "Mirrored Summoning",
  "Ignis Dragon",
  "Brutal Dragonewt",
  "Giselle, Ocean Star",
  "Noir & Blanc, Brothers",
  "Bejeweled Dragon",
  "Ethica, Firebrand Claw",
  "Coral Spirit",
  "Shield Dragon",
  "Piercing Roar",
  "Hailwyrm",
  "Ironscale Serpent Drake",
  "Electrodrake",
  "Breath of the Salamander",
  "Canyon of the Dragons",
  "Skeleton Raider",
  "Dark Emperor",
  "Cernunnos",
  "Suzy, Hexcaster",
  "Dog of the Dead",
  "Goblin Reaper",
  "Scarlet Vampire",
  "Deathcat Reaper",
  "Huginn & Muninn",
  "Thunderbolt Fiend",
  "Lurching Corpse",
  "Goblin Zombie",
  "Bubbly Reaper",
  "Undead Stampede",
  "God of Curses",
  "Holy Saber",
  "Aether, Guardian of Light",
  "Sacred Lion",
  "Cursed Maiden",
  "Garuda, Winged Sentinel",
  "Carmia, Miracle Optimist",
  "Ascended Prism Priestess",
  "Sonia, Protector of Hope",
  "Holy Kitty",
  "Sacred Ice-Crusher",
  "Tender Rabbit Healer",
  "Khonsu",
  "Forbidden Ritual",
  "Goblin Emperor",
  "Advent of Peace",
  "Feena, Super Cute Hunter",
  "Goblin Leader",
  "Goblin Mage",
  "Haru Urara [I'll Win Someday!]",
  "Oguri Cap [Surging Beast]",
  "Nephi Nela",
  "Cleuru",
  "Lily",
  "Construct of Truth and Being",
  "Chellerific Carnival",
  "Until We Meet Again",
  "Prank Proclamation",
  "Kuka",
  "Demonic Salvation: Infinity",
  "Clear",
  "Threading Snare",
  "Amped on Acorns",
  "Lyrael",
  "Ever-Lively Table",
  "Kokkoro [Princess Form]",
  "Pecorine [Princess Form]",
  "Karyl [Princess Form]",
  "Sheffy [Princess Form]",
  "Hiyori [Princess Form]",
  "Rei [Princess Form]",
  "Yui [Princess Form]",
  "Castelle, Budding Mage",
  "Lyelth, Immaculate Idol",
  "Titania, Queen of Fairies",
  "Cleaver Cat",
  "Cynthia, Chivalrous Elf",
  "Dwarven Lumberjack",
  "Elven Farmhand",
  "Fauna Handler",
  "Fairy Funfact",
  "Bladebunny",
  "Vanguard Tigress",
  "Flying Mistletoe Squirrel",
  "Spiritelementalist",
  "Wild Profusion",
  "Lecia & Nano, Twilight Trainees",
  "Galdr, Heroic Headmaster",
  "Yurius, Levin Authority",
  "Agile Twinblader",
  "Weiss, Discerning Professor",
  "Twilight and Silver",
  "Tony, Plucky Polliwog",
  "Deadeye Trainee",
  "Sharp Strategist",
  "Kitty Sergeant",
  "Fervent Fist-Fighter",
  "Levin Archer",
  "Aggressive Advance",
  "Lieutenant's Report",
  "Amaryllis, the Princess",
  "Anne, Brilliant Mage",
  "Ceridwen, Eternal Duality",
  "Grea, Crimson Promise",
  "Mysterian Exchange Party",
  "Mystic Rune",
  "Gruinne, Leonardian Provost",
  "Leeds, Pining Witch",
  "Bell Witch",
  "Wolf Whisperer",
  "Evamia, Spinner of Threads",
  "Arcane Instruction",
  "Aqueous Sphere",
  "Binding Ritual",
  "Lilium, the Wyrmwitch",
  "Coach Joe, Fiery Counselor",
  "Lumiore, Prestigious Gold",
  "Grand Slam Tamer",
  "Dion, Scarlet Scion",
  "Argente, Purest Silver",
  "Dragonborn Striker",
  "Gunbein, Lofty Dragonewt",
  "Charlotte, Dragonewt",
  "Ipupiara",
  "Megalorca Rider",
  "Augite Wyrm",
  "Stormscale",
  "Dragon Hunt",
  "Cornelius, the Corpse King",
  "Galom, Empress Fist",
  "Vulgus, Infernal Headmistress",
  "Arka, Sin Spinner",
  "Exella, Nocturnal General",
  "Bad-Girl Life",
  "Mach-Speed Maron",
  "Demon-Eyed Gangster",
  "Noble Demoness",
  "Bonebreaker Bladesman",
  "Denan, Big Bad Boss",
  "Malicious Blader",
  "Serenading Succubus",
  "Spirit Invasion",
  "Verdilia, Rogue Professor",
  "Elluvia, Graceful Lady",
  "Wilbert, Desolate Paladin",
  "Lou, Lady-in-Training",
  "Kira, Resilient Maiden",
  "Orchid's Examination Hall",
  "Pureflame Lady",
  "Kyrie, Fragment of Hope",
  "Pureflower Maiden",
  "Zlatorog",
  "Aqua Priestess",
  "Holy Armored Cheetah",
  "Hierophant's Implements",
  "Sublime Talisman",
  "Lucius, Travelled Trainer",
  "Gretina, Champion Fighter",
  "Arriet, Luxvoice Learner",
  "Lainecrest Academy",
  "Goblin Genius",
  "Goblin's Gratitude",
  "miroir",
  "Princess Knight",
  "Izudia, Annihilation Manifest",
  "Krulle, Heir to Unkilling",
  "Plumeria, Serene Goddess",
  "Windbloom Sylph",
  "Congregrant of Unkilling",
  "Eradicating Arrow",
  "Supplicant of Unkilling",
  "Greatwood Warrior",
  "Hamlet of Unkilling",
  "Bearer of the Fairy Blade",
  "Devotee of Unkilling",
  "Ageless Bystander",
  "Cutie Cat",
  "Bestial Swipe",
  "Octrice, Hollowness Manifest",
  "Sinciro, Heir to Usurpation",
  "Aurelia, Glorious Saber",
  "Congregant of Usurpation",
  "Fearful Fighter",
  "Returning Slash",
  "Peppy Scout",
  "Supplicant of Usurpation",
  "Lair of Usurpation",
  "Comrade of the Swordmaster",
  "Devotee of Usurpation",
  "Mercurial Mercenary",
  "Palace Knight",
  "Shield Bash",
  "Lishenna, Melody Manifest",
  "Velharia, Heir to Truth",
  "Axia, Heir to Destruction",
  "Raio, Elimination Manifest",
  "Congregant of Destruction",
  "Devastating Soprano",
  "Congregant of Truth",
  "Supplicant of Destruction",
  "Illusory Conjuration",
  "Devotee of Destruction",
  "Supplicant of Truth",
  "Devotee of Truth",
  "Ascetic of Wuxing",
  "Wasteland of Destruction",
  "Galmieux, Ardor Manifest",
  "Azurifrit, Heir to Disdain",
  "Dagon, Lord of the Seas",
  "Spoiled Mermanager",
  "Congregant of Disdain",
  "Ferocious Flame",
  "Supplicant of Disdain",
  "Encounter from the Deep",
  "Nation of Disdain",
  "Snowstorm Dragonewt",
  "Devotee of Disdain",
  "Militant Mermaid",
  "Ocean Rider",
  "Raging Lightning",
  "Rulenye & Valnareik",
  "Sham-Nacha, Heir to Entwining",
  "Diabolus Hedone",
  "Congregant of Entwining",
  "Hervör",
  "Screaming and Loathing",
  "Spirited Gravekeeper",
  "Supplicant of Entwining",
  "Castle of Entwining",
  "Ephemeral Demon Princess",
  "Devotee of Entwining",
  "Wicked Collector",
  "Nemean Lion",
  "March of the Brutes",
  "Marwynn, Despair Manifest",
  "Himeka, Heir to Repose",
  "Holy Serpent's Blessing",
  "Congregant of Repose",
  "Sacred Sheep",
  "Shining Disenchantment",
  "Supplicant of Repose",
  "Temple of Repose",
  "Winged Lion Statue",
  "Knight of the Holy Order",
  "Devotee of Repose",
  "Featherfolk Courier",
  "Peckish Al-mi'raj",
  "Blinding Faith",
  "Mjerrabaine, Great Manifest",
  "Gilnelise, Voracity Manifest",
  "Dogged One",
  "Inspirational One",
  "Tablet of Tribulations",
  "Apostle of Voracity",
  "Greatness Ascended",
  "Magachiyo, Barbed Convict",
  "Wimael, Redolent Enforcer",
  "Zwei, Symphonic Heart",
  "Verdant Lieutenant",
  "Warden of Balms",
  "Synchronous Hearts",
  "Budding Initiate",
  "Leafshade Assassin",
  "Puppet Workout",
  "Beast Lancer",
  "Merchant of the Wood",
  "Rogue Puppeteer",
  "Support Troop Elf",
  "Galepierce",
  "Barbaros, Briny Convict",
  "Radiel, Valorous Enforcer",
  "Gildaria, Anathema of Peace",
  "Warden of Honor",
  "Tidal Gunner",
  "Prim, Princess's Picnic",
  "Storm-Wracked First Mate",
  "Deep-Sea Scout",
  "Return from the Brink",
  "Felpurr Maid",
  "Knightly Thief",
  "Heavy Warrior",
  "Ninja Onslaught",
  "Cannon Volley",
  "Sephie, Depraved Convict",
  "Simael, Cleansing Enforcer",
  "Kyrzael, Killshot Enforcer",
  "Obsessive Scholar",
  "Warden of the Trigger",
  "Warden of the Arcane",
  "Devoted Researcher",
  "Volunteer Test Subject",
  "Astral Dancer",
  "Electrokitty",
  "Outdoorsmage",
  "Ultramarine Witch",
  "Feline Magic",
  "Meandering Bolt",
  "Antemaria, Huntress Convict",
  "Drazael, Ravening Enforcer",
  "Masamune, One-Eyed Dragon",
  "Scorched-Earth Tyrant",
  "Neptune, Arbiter of Tides",
  "Warden of the Adamant Claw",
  "Hotheaded Marauder",
  "Razor-Clawed Thief",
  "Seasoned Merman",
  "Dancing Crab",
  "Mermaid Songstress",
  "Dark Mermaid",
  "Dragonewt's Might",
  "Call of the Megalorca",
  "Istyndet, Soul Convict",
  "Garodeth, Insurgent Convict",
  "Zeronua, Demon of Domination",
  "Abyssal Colonel",
  "Myroel, Death Enforcer",
  "Genomuel, Wyrm Enforcer",
  "Underworld Lieutenant",
  "Warden of Corpses",
  "Raging Commander",
  "Vicious Blitzer",
  "Fallen Sergeant",
  "Steamrolling Tank",
  "Howling Scream",
  "Prison of Pain",
  "Erralde, Troth Convict",
  "Uneriel, Winged Enforcer",
  "Zoe, Queen of Hope",
  "Warden of the Wings",
  "Executor of the Oath",
  "Meus Gourmand",
  "Agent of the Commandments",
  "Follower of the Precepts",
  "Sacrosanct Temple",
  "Sacred Tiger",
  "Avaricious Altruist",
  "Sword Al-mi'raj",
  "Luminescent Gem",
  "Holybeast Ruins",
  "Cutthroat, Discord Convict",
  "Eudie, Maiden Reborn",
  "Zerael, Regent of Rebirth",
  "Ironforged Right Hand",
  "Azvaldt",
  "Smeltwork Bodyguard",
  "Warden of Recurrence",
  "Blackrust Underling",
  "Kokkoro",
  "Eris",
  "Nephi=Nela",
  "Shiori",
  "Anemone",
  "Makoto",
  "Rino",
  "Kururu",
  "Nea",
  "Lima",
  "Aoi",
  "Nebbia",
  "Suzuna",
  "Aurora Healing",
  "Pecorine",
  "Christina",
  "Labyrista",
  "Jun",
  "Riri",
  "Creditta",
  "Tomo",
  "Shizuru",
  "Ruka",
  "Tamaki",
  "Mitsuki",
  "Matsuri",
  "Ninon",
  "Princess Strike",
  "Karyl",
  "Yuni",
  "Neneka",
  "Maho",
  "Precia",
  "The Shared Illusion of Truth and Existence",
  "Kyoka",
  "Chieru",
  "Chloe",
  "Yuki",
  "Hatsune",
  "Nanaka",
  "Cheru Cheru☆Carnival",
  "Dark Eclipse",
  "Sheffy",
  "Homare",
  "Muimi",
  "Kaya",
  "Hiyori",
  "Someday, We'll Meet Again in the Future",
  "Inori",
  "Lind",
  "Wyrm",
  "Mifuyu",
  "Kaori",
  "Ayane",
  "Dragon's End Fist",
  "Prank Declaration",
  "Illya",
  "Ranpha",
  "Violet",
  "Shinobu",
  "Grace",
  "Rei",
  "Yori",
  "Akari",
  "Miyako",
  "Misaki",
  "Kuuka",
  "Io",
  "Eriko",
  "Infinite Break - Code: Null",
  "Saren",
  "Nozomi",
  "Akino",
  "Yui",
  "Quria",
  "Yukari",
  "Chika",
  "Misato",
  "Capture String",
  "Mimi",
  "Suzume",
  "Mahiru",
  "Kurumi",
  "Donguri Charge",
  "Omniscient Kaiser",
  "Misora",
  "Lailael",
  "Ameth",
  "Croce",
  "Kasumi",
  "Call of the Guild",
  "Ayumi",
  "Yuni, Chloe & Chieru",
  "Ranpha & Misora",
  "Nozomi, Chika & Tsumugi",
  "Rolo Rone, Verdant Purifier",
  "Kyou, Verdant Path Shepherd",
  "Tia, Crystalian Noble",
  "Verdant Authority Caretaker",
  "May, Eager Elf",
  "Sprouting Retribution",
  "Verdant City Pugilist",
  "Blossoming Lunerian",
  "Sowing Paradise",
  "Verdant Law Supplicant",
  "Milolo, Li'l Mountain Lass",
  "Rayne, Elf Smith",
  "Furious Mountain Deity",
  "Airbound Barrage",
  "Shinra, All-Discerning",
  "Gamma, Canine Mediator",
  "Gawain, Oath to Glory",
  "Bird's-Eye Investigator",
  "Darksaber Melissa",
  "Gigabyte Blade",
  "Cold Case Analyst",
  "Lucius, Sellsword",
  "Unorthodox Assistance",
  "Blind Spot Surveyor",
  "Monika, Cloudhall Admiral",
  "Princess Teena",
  "Holy Bear Knight",
  "Luminous Standard",
  "Mana, Sterling Luster",
  "Francoise, Bejeweled Manager",
  "Ginger, Accursed Word",
  "Bejeweled Supermodel",
  "Aleister, Argenteum Astrum",
  "Brilliant Cut",
  "Bejeweled Advisor",
  "Mari, Card Conjurer",
  "Clandestine Dealings",
  "Bejeweled Bouncer",
  "Carbuncle of Mysteria",
  "Illusionist",
  "Enchanted Sword",
  "Authoring Tomorrow",
  "El, Destructive Dragon",
  "Tenka, Hot-Blooded Vice-Prez",
  "Fafnir, Cunning Wyrm",
  "Dragon-Eyed Secretary",
  "Prophetic Dragon",
  "After-School Break",
  "Neon-Tailed Prefect",
  "Ian, Dragon Buster",
  "Red-Winged Admissions Gift",
  "Lightning-Clawed Loafer",
  "Serpent Drake",
  "Draconic Mercenary",
  "Estrella Beast",
  "Orca Run",
  "Ilze & Urze, Centennial Reapers",
  "Vedd, Burial Wolf",
  "Vania, Crimson Majesty",
  "Covetous Serpent",
  "Veight, Twilit Highborn",
  "Crescent Moon of Centennial Death",
  "Exhumation Crow",
  "Full Moon of Centennial Demise",
  "Vampire Queen's Castle",
  "Gnawing Rat",
  "Beryl, Dreameater",
  "Prince Catacomb",
  "Bloodthirsty Hamster",
  "Nightscreech",
  "Seishiro, Admonishing Faith",
  "Tenmei, Insatiable Adjudicator",
  "Elana, Purest Prayer",
  "Conferrer of Vows",
  "Imina, Mad Eidolon",
  "Unshakable Prayer",
  "Deliverer of Punishment",
  "Lorena, Iron-Willed Priest",
  "Guiding Words",
  "Votary of Contemplation",
  "Mugnier, Purifying Light",
  "Armed Al-mi'raj",
  "Heavenly Hound",
  "Golden Bell",
  "Bansai Suzuki, Deacon Shinobi",
  "Saito, Mao Ward Officer",
  "Warped Progress",
  "Togh Keyoh, Neometropolis",
  "Stunfist Assassin",
  "A-Class Pyromancy",
  "Cyberglasses Criminal",
  "Third-Class Officer",
  "Rin Shibuya [Cinderella Girl]",
  "Uzuki Shimamura [Cinderella Girl]",
  "Eve Santaclaus [Cinderella Girl]",
  "Evil-Eye Princess, Euryale",
  "Marlone, Light of Balance",
  "Miyu Mifune [Rouge Couture]",
  "Psychic☆Maiden",
  "Sapphire Priestess",
  "T. M. Opera O",
  "Asuka Ninomiya [Sweet & Charming]",
  "Lelouch, Righteous Emperor",
  "Nephthys",
  "Ranko Kanzaki [Cinderella Girl]",
  "Silvernail Markswoman",
  "Akari Tsujino [Twice as Lovely]",
  "Aqua Nereid",
  "BRIGHT:LIGHTS",
  "Garyu, Supreme Dragonkin",
  "Gattling Claw Dragon",
  "Iron Tail Dragon",
  "Riamu Yumemi [Party Night]",
  "Slaughtering Dragonewt",
  "Agnes Digital",
  "Daria, Dimensional Witch",
  "Hagoromo Komachi",
  "Mika Jougasaki [My★Style]",
  "Multipart Experiment",
  "Prophetess of Creation",
  "Yuuki Otokura [Together with Me]",
  "* (Asterisk)",
  "Aiko Takamori [Handmade Happiness]",
  "Cheshire Cat",
  "Grand Archer Selwyn",
  "Minami Nitta [Water's Edge Bride]",
  "Otoha Umeki",
  "Yuki Himekawa [Full Swing☆Cheer]",
  "#UNICUS",
  "Close-Knit Ambitions",
  "Drive Point",
  "Harbinger of the Night",
  "Ms. Tart Man",
  "Tazuna Hayakawa [Tracen Reception]",
  "New Year's Soul Devil",
  "Baalt, King of the Elves",
  "Sparkling☆Days",
  "Riamu's Reverie",
  "Sweet Sentiments",
  "Evolution Point",
  "Super-Evolution Point",
  "Airi Totoki [Anniversary Princess]",
  "Anastasia [All-Out Vacation]",
  "Miku Maekawa [Summer Cat Rendezvous]",
  "Summer Sea Breeze",
  "Miho Kohinata [Summer Firsts]",
  "Mio Honda [Mermaid Star]",
  "Beachside Memories",
  "Summer Encounter",
  "Pulsefire Assault",
  "Albert, Levin Saber",
  "Genesis of Legend",
  "Wingy, Chirpy Gemstone",
  "Fervent Machine Soldier",
  "Unicorn Dancer Unica",
  "Jabberwock",
  "Grand Summoning",
  "Dragonrend Quake",
  "Regal Wildcat",
  "Mithra, Daybreak Deity",
  "Serpent Wrath",
  "Colette, Holy Gunner",
  "Slade, Blossoming Wolf",
  "Biofabrication",
  "Godsent Stride",
  "Spinaria, Wavering Will",
  "Sammy, Wizard's Apprentice",
  "Magic Missile",
  "Tsubaki",
  "Arisa, Evergreen Arrow",
  "Ladica, Verdant Claw",
  "Setus, Sunlit Hero",
  "Lococo, Little Puppeteer",
  "Friendly Embrace",
  "Forest Guardian's Bow",
  "Beastfolk Harvester",
  "Heroic Resolve",
  "Inverted Manipulation",
  "Blossom Treant",
  "Sköll Lookout",
  "Elf Sorcerer",
  "Threadsnipper Puppet",
  "Heroic Fairy Champion",
  "Erika, Loyal Swordsavant",
  "Mistolina & Bayleon",
  "Leod, Moonlit Executioner",
  "Frenzied Corpsmaster",
  "Sunny Day Encounter",
  "Killer Instincts",
  "Valhorean Dealer",
  "Bladerights Lieutenant",
  "Shadowed Memories",
  "Fox Lancer",
  "Stone Merchant",
  "Victorious Grappler",
  "Countersolari Survivor",
  "Brothers United",
  "Isabelle, Intrepid Mage",
  "Eleanor, Glorious Flower",
  "Belphomet, Ultimate Creator",
  "Tetra, Serene Sapphire",
  "Mega Enforcer",
  "Nefarious Invasion",
  "Marie, Flowery Magician",
  "Enforcer",
  "Fruits of Wisdom",
  "Awakened Robot",
  "Covenant Mage",
  "Jetbroom Witch",
  "Panacea Alchemist",
  "Mysterian Wisdom",
  "Rowen, Dragon Lance",
  "Valdain, Forest Shadow",
  "Disrestan, Ocean Harbinger",
  "Djeana, the Stouthearted",
  "Verdant Rebirth",
  "Dragonslayer Spear",
  "Forestclaw Sentinel",
  "Rock Whale",
  "Newfound Allies",
  "Shark Warrior",
  "Poisonous Dilophosaurus",
  "Mánagarmr Scout",
  "Mermaid Archer",
  "Touching Thoughts",
  "Luna, Soul Keeper",
  "Urias, Final Vampire",
  "Mono, Immortal Garnet",
  "Aenea, Creative Amethyst",
  "Nicola, Enduring Steward",
  "Steeled Hopes",
  "Amy, Psychopomp Guide",
  "Roly-Poly Mk II",
  "Allure of Shadows",
  "Rouge Vampire",
  "Vampiric Bloodbinder",
  "Trampling Terror",
  "Soul Commander",
  "Midnight Gossip",
  "Eris, Atoned Priestess",
  "Yuwan, Dimensional Avenger",
  "Meowskers, Fluffy Consul",
  "Marlone, Peace Advocate",
  "Vice, Death Grip",
  "Automachina Maiden",
  "Aerial Craft",
  "Balance and Obliteration",
  "Unlikely Fellowship",
  "Steelwing",
  "Technomancer",
  "Android Artisan",
  "Mark Unleashed",
  "Unicorn Altar",
  "Maisha, Purgation's Vessel",
  "Great Mother's Embrace",
  "Hoverboard Mercenary",
  "Cosmic Angel",
  "Guild Assembly",
  "Naterra's Future",
  "Unnamed Determination",
  "Aiolon's Remains",
  "Anastasia [Seize the Light]",
  "Hajime Fujiwara [Pink Blossom Dream]",
  "Minami Nitta [Goddess by the Sunlit Sea]",
  "Yuki Himekawa [Challengers' Cheer]",
  "Riina Tada [Wannabe Legend]",
  "Hinako Kita [True Dream]",
  "Miku Maekawa [Meownderful World]",
  "Blossoms' Advance",
  "Rin & Mio",
  "Mio Honda [Cinderella Girl]",
  "Uzuki Shimamura [Magical New Me]",
  "Karen Hojo [Cinderella Girl]",
  "Airi Totoki [Cinderella Girl]",
  "Mayu Sakuma [Love-Laden Gift]",
  "Chieri Ogata [Happiness Tune]",
  "Nagi Hisakawa [Everyday Fairy Tale]",
  "Miho Kohinata [Youthful Romance]",
  "Dancing in the Rain",
  "Syuko Shiomi [Cinderella Girl]",
  "Mika & Rika",
  "Yuuki Otokura [Ripples of My Heart]",
  "Glitz & Glam☆Parade",
  "Sae Kobayakawa [Dancing Flowers]",
  "Hiromi Seki [Twinkle in My Eye]",
  "Shiki Ichinose [Mystic Elixir]",
  "Kanade Hayami [Faraway Reflection]",
  "Tomoe Murakami [Crimson Fighter]",
  "Fumika Sagisawa [Cinderella Girl]",
  "Akira Sunazuka [Online Life]",
  "Akari & Akira",
  "Riamu Yumemi [Shout It to the World]",
  "Yui Ohtsuki [Lollipop Darling]",
  "Hotaru Shiragiku [Unbreakable]",
  "Star of the Show",
  "Ranko Kanzaki [Princess in White]",
  "Syoko Hoshi [individuals]",
  "Mirei Hayasaka [individuals]",
  "Nono Morikubo [individuals]",
  "Asuka Ninomiya [Gentle Evening]",
  "Chitose Kurosaki [Memento Mori]",
  "Natsuki Kimura [Scarlet Love Song]",
  "Takumi Mukai [No One Can Stop Me]",
  "Koume Shirasaka [Haunted Gown]",
  "Self-Proclaimed Fan Favorite",
  "Nana Abe [Cinderella Girl]",
  "Kaede Takagaki [Cinderella Girl]",
  "Eve Santaclaus [Holy Night Miracle]",
  "Miyu Mifune [Parfum Géranium]",
  "Kako Takafuji [Lady Luck]",
  "Kotoka Saionji [Pure Euphoria]",
  "Haru Yuuki [Secret Blue Rose]",
  "Natalia [One Thousand and One Nights]",
  "A Sweet Romantic Summer",
  "Curtain Call of Smiles",
  "Aria, Lady of the Woods",
  "Orchis, Newfound Heart",
  "Nazuri, Bestial Innkeeper",
  "Glade, Fragrantwood Ward",
  "Lily, Crystalian Innocence",
  "Liam, Crazed Creator",
  "Aerin, Crystalian Frostward",
  "Bayle, Luxglaive Warrior",
  "Godwood Staff",
  "Fairy Tamer",
  "Good Fairy of the Pond",
  "Fay Twinkletoes",
  "Baby Carbuncle",
  "Fragrantwood Whispers",
  "Amelia, Silver Captain",
  "Albert, Levin Stormsaber",
  "Ginne, Bewitching Courtesan",
  "Zirconia, Ironcrown Ward",
  "Amalia, Luxsteel Paladin",
  "Ravening Tentacles",
  "Luminous Commander",
  "Luminous Magus",
  "Rusty, Luxcard Trickster",
  "Jeno, Levin Axeraider",
  "Flashstep Quickblader",
  "Luminous Lancetrooper",
  "Lyrala, Luminous Potionwright",
  "Ignominious Samurai",
  "Ironcrown Majesty",
  "Anne & Grea, Mysterian Duo",
  "Lilanthim, Anathema of Edacity",
  "Zizdvend, Fate's Arbiter",
  "Edelweiss, Sagelight Ward",
  "Juno, Visionary Alchemist",
  "Homework Time!",
  "Penelope, Potions Prodigy",
  "Ms. Miranda, Adored Academic",
  "Snowman Army",
  "Starry-Eyed Penguin Wizard",
  "Emmylou, Witch of Wonder",
  "William, Mysterian Student",
  "Sagelight Teachings",
  "Truth Summons",
  "Forte, Blackwing Dragoon",
  "Burnite, Anathema of Flame",
  "Nirle, Draconic Prodigy",
  "Liu Feng, Goldennote Ward",
  "Genesis Dragon Reborn",
  "Fan of Otohime",
  "Eyfa, Windrider",
  "Marion, Ravishing Dragonewt",
  "Kit, Luxfang Champion",
  "Zahar, Stormwave Dragoon",
  "Little Dragon Nanny",
  "Zell, Windreader",
  "Silvercloud Dragonrider",
  "Swordsnout Trencher",
  "Goldennote Melody",
  "Cerberus, Hellfire Unleashed",
  "Aragavy, Eternal Hunter",
  "Gold Rush Ghost",
  "Mukan, Shadowcrypt Ward",
  "Balto, Dusk Bounty Hunter",
  "Ceres, Blue Rose Maiden",
  "Orthrus, Hellhound Blader",
  "Yuna, Occult Hunter",
  "Soul Predation",
  "Vlad, Impaler",
  "Aryll, Moonstruck Vampire",
  "Mino, Shrewd Reaper",
  "Beryl, Nightmare Incarnate",
  "Shadowcrypt Memorial",
  "Lapis, Shining Seraph",
  "Rodeo, Anathema of Judgment",
  "Rana, Dual Cannon Abbess",
  "Ronavero, Darkhaven Ward",
  "Salefa, Guardian of Water",
  "Pact of the Beast Princess",
  "Angelic Prism Priestess",
  "Reno, Luxwing Featherfolk",
  "Serene Sanctuary",
  "Ironfist Priest",
  "Maeve, Guardian of Earth",
  "Holy Shieldmaiden",
  "Mainyu, Darkdweller",
  "Darkhaven Grace",
  "Olivia, Heroic Dark Angel",
  "Ruler of Cocytus",
  "Phildau, Lionheart Ward",
  "Alouette, Doomwright Ward",
  "Leah, Bellringer Angel",
  "Apollo, Heaven's Envoy",
  "Divine Thunder",
  "Doomwright Resurgence",

  "Izudia, Unkilling Annihilation",
  "Amataz, Reverse Blader",
  "Piercye, Queen of Frost",
  "Inauspicious Puppeteer",
  "Erosive Annihilation",
  "Rejuvenating Resurrection",
  "Cryptid Keeper",
  "Adherent of Annihilation",
  "Fairy Healer",
  "Hermit of Unkilling",
  "Horned Beastie",
  "Bouquet Fairy",
  "Emerald Wildfox",
  "Wind Fairy",

  "Octrice, Hollow Usurpation",
  "Kagemitsu, Lost Samurai",
  "Ralmia, Astrowing",
  "Arsène Lupin",
  "Ultimate Hollow",
  "Supersonic Breakthrough",
  "Adherent of Hollowness",
  "Sword General",
  "Serration Wave",
  "Penguin Guardian",
  "Hermit of Usurpation",
  "Chivalrous Bandit",
  "Flying Messenger Squirrel",
  "Brave Buccaneer",

  "Raio, Truthful Elimination",
  "Lishenna, Melodious Destruction",
  "Kuon, Wuxing Master",
  "Acid Golem",
  "Melody's Return",
  "Secrets of Onmyodo",
  "Adherent of Elimination",
  "Adherent of Melody",
  "Elimination Unleashed",
  "Scroll Wizard",
  "Hermit of Truth",
  "Hermit of Destruction",
  "Crystal Witch",

  "Twinblade Mage",
  "Galmieux, Ardent Disdain",
  "Filene, Blizzardous Heart",
  "Celestial Dragoon",
  "Mermaid of Punishment",
  "Ardent Torch",
  "Whitefrost Blizzard",
  "Adherent of Ardor",
  "Windswept Dragonewt",
  "Tropical Mermaid",
  "Tiniest Dragon",
  "Hermit of Disdain",
  "Beginner Dragoon",
  "Orbed Cancer",

  "Whimsical Mermaid",
  "Valnareik, Lustful Desire",
  "Rulenye, Screaming Silence",
  "Ginsetsu, Terror Banquet",
  "Yuzuki, Bloodlord",
  "Spiteful Screams",
  "A Hellish Banquet",
  "Adherent of Desire",
  "Loathing Desire",
  "Crimson Virtue",
  "Adherent of Screams",
  "Hermit of Lust",
  "Hermit of Silence",
  "Krampus",

  "Astral Projection",
  "Marwynn, Repose of Despair",
  "Wilbert, Luminous Paladin",
  "Sarissa, Luxflash Spear",
  "Shiro, Cursed Wings",
  "Cyclical Fate",
  "Perpetual Despair",
  "Adherent of Despair",
  "Zeno, Paradoxical Shield",
  "Crusader's Rallying Cry",
  "Temple Healer",
  "Hermit of Repose",
  "Hardplume Warrior",
  "Caladrius",

  "Sacred Gavel",
  "Mjerrabaine, Great One",
  "Gilnelise, Ravenous Craving",
  "Arael",
  "Thunder God of the Tempest",
  "Resolve of the Fallen",
  "Mechanical Analyzer",
  "Messenger of the Skies",
  "Merciless Voiding",
  "Nomadic Conductor",
  "Mountain Gigas",
  "Fluffy Angel",

  "Hozumi, Enchanting Hostess",
  "Levon, Scentbound Sword",
  "Bastion of Seasons",
  "Spirit of the Spring",
  "Illusions of Comfort",
  "Elven Waitress",
  "Tinkering Shopkeeper",
  "Craftsman's Pride",
  "Karakuri Servant",
  "Fairylight Guide",
  "Woodland Pest Control",
  "Windswept Lancer",
  "Elven Craftsmanship",

  "Taketsumi, Aconite Paladin",
  "Mars, Belligerent Flame",
  "Jiemon, Thief Lord",
  "Bumpkin Recruit",
  "Hero of the Hunt",
  "Masterful Musician",
  "War Hero",
  "Noble Shieldmaiden",
  "Front Desk Frog",
  "Violent Soldier",
  "Hasty Axeman",
  "Night on the Town",
  "Haggler's Gambit",

  "Yukishima, Master Biographer",
  "Riley, Astral Shaman",
  "Bergent, Layered Sorceress",
  "Arctic Chimera",
  "Story of a Lifetime",
  "Orchestral Mage",
  "Tempestuous Alchemist",
  "Dream Come True",
  "Chakram Wizard",
  "Owl Receptionist",
  "Earthen Fist",
  "Magical Reserves",
  "Grand Spire",

  "Si Long, Draconic God-Queen",
  "Sacred Springs Dragon",
  "Frostbite Dragon",
  "Dragonskull Bludgeoner",
  "Soothing Dragonspring",
  "Dragonfolk Stoker",
  "Leviathan, the Furious",
  "March of the Dragonspring",
  "Dragon Breeder",
  "Dragon-Drawn Carriage",
  "Loyal Sea Serpent",
  "Mermaid Song",
  "Aquatic Authority",

  "Itsurugi, Eager Admirer",
  "Paracelise, Demon of Greed",
  "Anisage, Lost Forsaken",
  "Frigid Necromancer",
  "Eternal Contract",
  "Briared Vampire",
  "Room Service Demon",
  "Undying Resolve",
  "Silvernail Blaster",
  "Parkour Werewolf",
  "Bat Usher",
  "Creeping Malice",
  "Full Moon Leap",

  "All-Feeling Divine",
  "Shion, Immortal Aegis",
  "Nekhbet",
  "Impious Bishop",
  "Chamber of Cleansing",
  "Winged Gatekeeper",
  "Boomerang Sister",
  "Spiritual Blow",
  "Twinblade Featherfolk",
  "Fox of Fortune",
  "Pegasus Knight",
  "Al-mi'raj Defender",
  "White Eagle Baptism",

  "Magna Saber",
  "Flame and Glass, Duality",
  "Glistering Angel",
  "Angel's Blessing",
  "Magna Transformation",
  "Gunslinger Automaton",
  "Ogre Weaponmaster",
  "Stay in Paradise",
  "Brave Goblin",
  "Torchbearing Guide",
  "Goblin Assault",

  "Hokko Tarumae",
  "Sakura Laurel",
  "Sounds of Earth",
  "Haru Urara [Sunny Passion ♪]",
  "Yamanin Zephyr",
  "Sakura Bakushin O",
  "Mihono Bourbon",
  "A MORE MARVELOUS WORLD! ☆",

  "Gentildonna",
  "Symboli Rudolf [Enchaînement]",
  "Sirius Symboli [Escorte Étoile]",
  "Aston Machan",
  "Symboli Kris S",
  "Tap Dance City",
  "Biwa Hayahide",
  "Teio-Oo-Oo!!!",

  "Cheval Grand",
  "Tanino Gimlet",
  "Narita Top Road [Peachy Silhouette]",
  "Verxina",
  "Vivlos",
  "Daitaku Helios",
  "Sweep Tosho",
  "Lucky Star in the Sky",

  "Neo Universe",
  "Mr. C.B.",
  "Katsuragi Ace",
  "Super Creek [Piece of Mind]",
  "Tsurumaru Tsuyoshi",
  "El Condor Pasa",
  "Nishino Flower",
  "Pious Flame, Heavens Scorcher",

  "Hishi Miracle",
  "Daiichi Ruby",
  "Duramente",
  "Matikanetannhauser [Machitan☆Adventure]",
  "K.S.Miracle",
  "Air Shakur",
  "Manhattan Cafe",
  "TT Ignition!",

  "Satono Crown",
  "Mejiro Ramonu",
  "Jungle Pocket",
  "Wonder Acute",
  "Mejiro Ardan [Hopeful Petals Dancing in the Night]",
  "Matikanefukukitaru",
  "Mejiro Palmer [Moonlit Devil ♪]",
  "Bring 'Em Home, Please!",

  "Progenitors and Guides",
  "Balliamo?",
  "Ryoka Tsurugi",

  "Sekka, Fatebound Fox",
  "Aria, Miasma Fairy",
  "Nelcha, Fashion Hazard",
  "Spinaria, Keeper of the End",
  "Resolve of the Nine-Tailed Fox",
  "Sunbright Elf",
  "Wildwood Warrior",
  "Tree of Wonders",
  "Fairy Slugger",
  "Edgy Elf",
  "Gazania Fox",
  "Tower Root Giant",
  "Feybolt Archer",

  "Albert, Thunderous Doom",
  "Magna Zero",
  "Sera, Maiden of the Dawn",
  "Homebound Infantryman",
  "Levin Justice",
  "Lounes, Levin Apprentice",
  "Jeno, Fanged Tyrant",
  "Cat Admiral",
  "Mina, Levin Vice Leader",
  "Mona, Levin Mage",
  "Mena, Levin Duelist",
  "Icyclone",
  "Meet the Levin Sisters!",

  "Anne, Mysterian Imperatrix",
  "Ghios, Sparkling Prism",
  "Mileka, Celestial Seer",
  "Grea, Scorching Fury",
  "Whims of Chaos",
  "Grimoire Sorcerer",
  "Hurricane Golem",
  "Riven Earth",
  "Magical Squirrel",
  "Art Society Magus",
  "Cat Summoner",
  "Arcane Duplication",
  "Sacrifice",

  "Drache, Fiery Dragonlord",
  "Forte, Sovereign Supreme",
  "Godfire Phoenix",
  "Roy, Dragonreaver",
  "Howling Conflagration",
  "Flame Pillar Dragonewt",
  "Empyreal Dragon",
  "Scalebound Plight",
  "Margarite Mermaid",
  "Earthen Dragonewt",
  "Twinblade Dragonfolk",
  "Coral Shark",
  "Beating of the Dragonwings",

  "Aluzard, Timeworn Vampire",
  "Laura, Crimson Strife",
  "Ceres, Bride of the Night",
  "Kagero, Swordbound Soul",
  "Chris, Beyond the Patch",
  "Liberté, Unchained Wolf",
  "Silversteel Blader",
  "Soulstrike",
  "Linkstaff Necromancer",
  "Noble Phantom",
  "Bandage Connoisseur",
  "Ghastly Banishment",
  "Sanguine Necklace",

  "Jeanne, Despair's Maiden",
  "Jatelant, God of Prosperity",
  "Lunerian Paladin",
  "Absolute Tolerance",
  "Westmuenster Abbey",
  "Pyne, Twisted Justice",
  "Thornclad Arbiter",
  "Gods' Loving Smite",
  "Charitable Al-mi'raj",
  "Prismawing Featherfolk",
  "Turquoise Sister",
  "Sacred Groundskeeper",
  "Sealed Tome",

  "Sahaquiel & Israfil",
  "Planetary Fracture",
  "Miriam, Mutinous Being",
  "Grimnir, Voidwrought Wind",
  "Frostfire",
  "Managrocer",
  "Goddess of Rebirth",
  "Dogged Detective",
  "Armored Goblin",
  "Fallen Harpist",
  "Retracing the Past",

  "Awakened Gaia",
  "Elf Queen of Abundant Life",
  "Carbuncle, Immortal Jewel",
  "Irene, Harvest Defender",
  "Intertwined Resolve",
  "Forest Defender",
  "Windfall Fay",
  "Aria's Whirlwind",
  "Forest Hatcheteer",
  "Springleaf Sprite",
  "Elven Pikeman",
  "Fairy Officer",
  "Fairy Menhir",

  "Patrick, Rhiceros Knight",
  "Lecia, Sky Saber",
  "Ironfist Beast Warrior",
  "Alwida, Pirate Queen",
  "Stroke of Conviction",
  "Nano, the Dawnblade",
  "Panther Scout",
  "King's Welcome",
  "Lilje, Butler of the Mists",
  "Sheena, Maid of the Mists",
  "Wolf Fang Swordsman",
  "Splendid Fencer",
  "Ivory Sword Dance",

  "Belphomet, Worldreaver",
  "Daria, Infinity Witch",
  "Regalore, Steel Chimera",
  "Melvie, Princess Witch",
  "Sorcery in Solidarity",
  "Chaos Wielder",
  "Rebel Against Fate",
  "Arcane Item Shop",
  "Gigahand Golem",
  "Device Diviner",
  "Mechabook Sorcerer",
  "Chain Lightning",
  "Mystic Absorption",

  "Shipsbane Plesiosaurus",
  "Jerva, Wyrm Transcendent",
  "Steelcap Pachycephalosaurus",
  "Giselle, Mermaid Healer",
  "Cursed Furor",
  "Assault Dragoon",
  "Petalspine Stegosaurus",
  "Phoenix Howl",
  "Dragoon Medic",
  "Rockback Ankylosaurus",
  "Ruinous Dragon",
  "Dragon Aficionado",
  "Overwhelming Crush",

  "Neun, Daybreak Vampire",
  "Gremory, Death Teller",
  "Jackshovel Gravedigger",
  "Medusa, Evil-Eyed Serpent",
  "Friends Forever",
  "Liberté, Werewolf Pup",
  "Hellfire Hound",
  "Garnet Waltz",
  "Bloodstained Berserker",
  "Roly-Poly Mk I",
  "Mechasaw Deathbringer",
  "Ghoul",
  "Viper Lash",

  "Rola, Inferno Dragoon",
  "Charaton, Iceflame Priest",
  "Gullias, Silverbeast Lord",
  "Robowhip Reverend",
  "Major Prayers",
  "Holylight Convert",
  "Smilecure Priest",
  "Salvation Ex Limonia",
  "Sol Sister",
  "Robowing Precant",
  "Fortune Fowl",
  "Pilgrims' Path",
  "Fiery Paean",

  "Natur Al'machinus",
  "Changewing Cherub",
  "Seraphic Blade",
  "Travelers' Respite",
  "Romantic Chanteuse",
  "Giving Gourmet",
  "Goblin Warpack",
  "Plucky Treasure Hunter",
  "Wayfaring Illustrator",
  "We've Got a Case!",

  "Spinaria, Waveing Will",
  "Amelia, Sunny Paladin",
  "Falise, Innocent Sea Spray",
  "Sharon, Seaside Nymph",
  "Queen Vampire, Sultry Evening",
  "Zoe, Shore's Melody",
  "Alice, Golden Afternoon",

  "Loxis, Homestead Pioneer",
  "Shamu & Shama, Posh Felines",
  "Terrorformer",
  "Giant Pastures",
  "Fairy Flowering",
  "Varmint Hunter",
  "Stringmaster",
  "Corrosive Thorns",
  "Lookout Elf",
  "Cactus Cowboy",
  "Nature's Warden",
  "Hornet Strike",
  "Scavenge",
  "Nahtnaught, Cursed Queen",
  "Bunny & Baron, Specter Duo",
  "Reinhardt, the Deathless",
  "Radical Gunslinger",
  "Tyrant's Order",
  "Stalwart Slinger",
  "Outlaw Gunner",
  "Desperados' Shot",
  "Shinobi Tanuki",
  "Naht's Henchman",
  "Frontline Instructor",
  "Bandit Raid",
  "Dramatic Retreat",
  "Vincent, the Peacekeeper",
  "Maiser, Neighborhood Hero",
  "Magical Gunslinger",
  "Transcendent Simulacrum",
  "Words of Judgment",
  "Artistic Arcanist",
  "Golem Marshal",
  "Rapid Fire",
  "Crystal Fencer",
  "Rivaylian Deputy",
  "Mirror Witch",
  "Terra Nova",
  "Scorching Blast",
  "Reggie, Peerless Artisan",
  "Resplendent Phoenix",
  "Georgius",
  "Balefire Wrenchsmith",
  "Dragon-Devouring Dread",
  "Azureflame Dragonewt",
  "Dragonfolk Artificer",
  "Draconic Call",
  "Mermaid Guide",
  "Wyrmfire Engineer",
  "Pumpkin Dragon",
  "Wavecrest Angler",
  "Thunderous Roar",
  "Iceschillendrig, Gilded Autocrat",
  "Illganeau, Horror Astray",
  "Hazhan, Demonblade Knight",
  "Greatpick Corpse",
  "Dead to Rights",
  "Wretch",
  "Gold Mine Necromancer",
  "Wretched Tryst",
  "Redcap",
  "Skeleton Dreamer",
  "Fulminating Berserker",
  "Grudge Teller",
  "Spiderweb Array",
  "Selena, Sugarkiss Assassin",
  "Anvelt, Judgment's Cannon",
  "Vengeful Sniper",
  "Paladin of Clemency",
  "Holy Sanctuary",
  "Set",
  "Shady Priest",
  "Haven Fire",
  "Enchanted Knight",
  "Revolver Eagle",
  "Sacred Stone Apostle",
  "Benevolent Blight",
  "Pure Metamorphosis",
  "Sylvia, Grand Arbiter",
  "Quixotic Adventurer",
  "Goblin Queen",
  "Embodiment of Cocytus",
  "Wandering Chef",
  "Supercharged Guitarist",
  "Titanic Showdown",
  "Rivaylian Bandit",
  "Vagabond Lizard",
  "Spice Shower",

  "Alfred Early",
  "Blaster Blade",
  "Wingal",
  "Knight of Conviction, Bors",
  "Flash Shield, Iseult",
  "Knight of Silence, Gallatin",
  "Little Sage, Marron",
  "Lake Maiden, Lien",
  "Knight of Rose, Morgana",
  "Stardust Trumpeter",

  "Dragonic Overlord",
  "Dragon Monk, Goku",
  "Dragon Knight, Aleph",
  "Berserk Dragon",
  "Wyvern Guard, Barri",
  "Dragon Knight, Nehalem",
  "Embodiment of Armor, Bahr",
  "Chain-Attack Sutherland",
  "Follower, Reas",
  "Lizard Runner, Undeux",

  "Blue Storm Dragon, Maelstrom",
  "Storm Rider, Diamantes",
  "Storm Rider, Basil",
  "Marine General of the Restless Tides, Algos",
  "Hydro Hurricane Dragon",
  "Water General of Wave-Like Spirals, Benedict",
  "Tear Knight, Valeria",
  "Tear Knight, Lazarus",
  "Tear Knight, Theo",
  "Light Signals Penguin Soldier",
  "Tear Knight, Cyprus",
  "Emerald Shield, Paschal",
  "Battleship Intelligence",
  "Pyroxene Communications Sea Otter Soldier",
  "Dolphin Soldier of High Speed Raids",
  "Medical Officer of the Rainbow Elixir",
  "Coral Assault",
  "Battle Siren, Cynthia",
  "Officer Cadet, Erikk",

  "Majesty Lord Blaster",
  "Swordsman of the Explosive Flames, Palamedes",
  "Star Call Trumpeter",
  "High Dog Breeder, Akane",
  "Knight of Loyalty, Bedivere",
  "Solitary Knight, Gancelot",
  "Knight of Friendship, Kay",
  "Barcgal",
  "Miru Biru",
  "Young Pegasus Knight",
  "Toypugal",
  "Pongal",
  "Future Knight, Llew",
  "Margal",
  "Flogal",
  "Yggdrasil Maiden, Elaine",
  "Starlight Unicorn",
  "Knight of Truth, Gordon",
  "Wingal Brave",

  "Silver Thorn Dragon Tamer, Luquier",
  "Nightmare Doll, Alice",
  "Purple Trapezist",
  "Crimson Beast Tamer",
  "Mistress Hurricane",
  "Golden Beast Tamer",
  "Starlight Melody Tamer, Farah",
  "Turquoise Beast Tamer",
  "Dark Metal Bicorn",
  "Nitro Juggler",
  "Midnight Bunny",
  "Hades Hypnotist",
  "Dynamite Juggler",
  "Rainbow Magician",
  "Skyhigh Walker",
  "Candy Clown",
  "Jumping Jill",
  "Skull Juggler",
  "Girl Who Crossed the Gap",

  "Dragonic Overlord the End",
  "Seal Dragon, Blockade",
  "Burning Horn Dragon",
  "Blazing Core Dragon",
  "Dragonic Executioner",
  "Vortex Dragon",
  "Flame of Promise, Aermo",
  "Bellicosity Dragon",
  "Prowling Dragon, Striken",
  "Dragon Monk, Gojo",
  "Demonic Dragon Berserker, Yaksha",
  "Demonic Dragon Mage, Kimnara",
  "Embodiment of Spear, Tahr",
  "Gatling Claw Dragon",
  "Lizard Soldier, Ganlu",
  "Dragon Monk, Genjo",
  "Irontail Dragon",
  "Flame of Hope, Aermo",
  "Lizard Soldier, Conroe",

  "Phantom Blaster Overlord",
  "Phantom Blaster Dragon",
  "Blaster Dark",
  "Skull Witch, Nemain",
  "Knight of Nullity, Masquerade",
  "Darkness Maiden, Macha",
  "Cursed Lancer",
  "Knight of Darkness, Rugos",
  "Black Sage, Charon",
  "Doranbau",
  "Blaster Javelin",
  "Dark Shield, Mac Lir",
  "Grim Reaper",
  "Abyss Freezer",
  "Darkside Trumpeter",
  "Abyss Healer",
  "Witch of Nostrum, Arianrhod",
  "Gururubau",
  "Fullbau",

  "Goddess of the Full Moon, Tsukuyomi",
  "Goddess of the Half Moon, Tsukuyomi",
  "CEO Amaterasu",
  "Silent Tom",
  "Evil-eye Princess, Euryale",
  "Maiden of Libra",
  "Battle Sister, Cocoa",
  "Oracle Guardian, Wiseman",
  "White Hare of Inaba",
  "Goddess of the Crescent Moon, Tsukuyomi",
  "Dark Cat",
  "Battle Sister, Chocolat",
  "Oracle Guardian, Nike",
  "Dream Eater",
  "Emergency Alarmer",
  "Lozenge Magus",
  "Battle Maiden, Tagitsuhime",
  "Luck Bird",
  "Godhawk, Ichibyoshi",

  "Powers Converged",

  "XII. Wolfraud, The Hanged Man",
  "Lucille, Keeper of Relics",
  "Chipper Skipper",
  "Windflower Tiger",
  "Treacherous Reversal",
  "Salvia Panther",
  "Optimistic Beastmaster",
  "Lumbering Carapace",
  "Reclusive Ponderer",
  "Crocus Rat",
  "Blossoming Archer",
  "Deepwood Wolf",
  "Fairy Assault",

  "VII. Oluon, The Chariot",
  "Alyaska, War Hawker",
  "Prudent General",
  "Ilmisuna, Discord Hawker",
  "Aerial Slash",
  "Lightning Kicker",
  "Empress of Serenity",
  "Knight Neilan the Lazy",
  "Honorable Thief",
  "Windslasher",
  "Selfless Noble",
  "Ernesta, Weapons Hawker",
  "Pompous Summons",

  "0. Lhynkal, The Fool",
  "Runie, Resolute Diviner",
  "Imperator of Magic",
  "Checkmate",
  "Scourge of the Omniscient",
  "Juggling Moggy",
  "Gambit",
  "Rite of the Ignorant",
  "Piquant Potioneer",
  "Creative Conjurer",
  "Arcane Auteur",
  "Skewer",
  "Magical Augmentation",

  "XI. Erntz, Justice",
  "Aiela, Devoted Knight",
  "Slaughering Dragonewt",
  "Eternal Whale",
  "Dual Rage",
  "Swiftblade Dragonewt",
  "Heliodragon",
  "Dragon Impact",
  "Springwell Dragon Keeper",
  "Gallant Dragonewt",
  "Dragonclad Lancer",
  "Tropical Grouper",
  "Dragon Spawning",

  "VI. Milteo, The Lovers",
  "XIV. Luzen, Temperance",
  "Deathbringer",
  "Demonium, Clash Devil",
  "Sincere Soul",
  "Ghost Maid",
  "Insatiable Desire",
  "Unselfish Grace",
  "Moonrise Werewolf",
  "Spirit Curator",
  "Silverbolt Hunter",
  "Soul Box",
  "Colossal Grudge",

  "VIII. Sofina, Strength",
  "X. Slaus, Wheel of Fortune",
  "Reverend Adjudicator",
  "Tanzanite Convictor",
  "Somnolent Strength",
  "Topaz Swordian",
  "Puresong Priest",
  "Wheel of Misfortune",
  "Priestess of Foresight",
  "Azurite Maiden",
  "Prismaplume Bird",
  "Stalwart Featherfolk",
  "Holybright Altar",

  "XXI. Zelgenea, The World",
  "Starbright Deity",
  "Fieran, Havensent Wind God",
  "Fallen Shot",
  "One-Winged Traitor",
  "Mind Splitter",
  "Angelic Strike",
  "Pureshot Angel",
  "Corruption Guardian",
  "Winged Courier",

  "Yggdrasil",
  "White Vanara",
  "Paula, Icy Warmth",
  "Greenglen Axeman",
  "Wrath of Nature",
  "Storied Falconer",
  "Owl Man",
  "Blessings of Creation",
  "Grasshopper Conductor",
  "Elf General",
  "Lila, Arborist",
  "Substitution",
  "Flower of Fairies",

  "Celia, Sky Commander",
  "Spartacus",
  "Prim, Innocent Princess",
  "Nonja, Silent Maid",
  "Monochrome Duel",
  "Dario, Demon Count",
  "Queen Hemera the White",
  "Queen Magnus the Black",
  "Axe Princess",
  "Master Samurai",
  "Savage Swordsman",
  "Tycoon",
  "Frontline Ramparts",

  "Ceridwen, Eternity Hunter",
  "Faust, Truthseeker",
  "Anne, Mysterian Prodigy",
  "Grea, Mysterian Dragoness",
  "Mysterian Wyrmist",
  "Snowman King",
  "Owen, Knight of Mysteria",
  "Absolute Zeroblade",
  "Anne's Sorcery",
  "Grea's Ember",
  "Bergent, Onion Patchmaster",
  "Palla, Student Teacher",
  "Vayle, Mysterian Summoner",
  "Mysterian Knowledge",
  "Summoning Drills",
  "Witch of Foresight",
  "Beastfaced Mage",
  "Onion Patch",
  "Tico, Mysterian Spellnerd",
  "Mr. Bertrand, Magic Mentor",
  "Staff of Whirlwinds",

  "Jerva of Draconic Mail",
  "Zirnitra, Dragon's Flame",
  "Romelia, Lightning Striker",
  "Masamune, Raging Dragon",
  "Lindworm",
  "Dragonplate Warrior",
  "Poseidon",
  "Pure-Voiced Dragoon",
  "Force of the Dragonewt",
  "Waters of the Megalorca",
  "Roy, Dragoncleaver",
  "Galua of Two Breaths",
  "Katakura Kojuro",
  "Dragoon Scyther",
  "Gargouille",
  "Heroic Dragonslayer",
  "Dragonclad Blademaster",
  "Drakewing Assassin",
  "Coda, Twilight Dragoon",
  "Hypersonic Dragonewt",
  "Dragon's Handspur",

  "Vania, Nightshade Vampire",
  "Arcus, Spirited Manager",
  "Oldblood King",
  "Darkfeast Bat",
  "Gift for Bloodkin",
  "Big Soul Hunter",
  "Raven, Eventide Vampire",
  "Blood Moon",
  "Orator of the Bones",
  "Raven, Noontide Vampire",
  "Raven, Midnight Vampire",
  "Death the Nyctophile",
  "Poltergeist",

  "Jeanne, Beacon of Salvation",
  "Tutankhamun",
  "Ceryneian Hind",
  "Heavenly Knight",
  "Tenko's Shrine",
  "Jeweled Priestess",
  "Whitefang Temple",
  "Opposing Statues",
  "Lycaon",
  "Holy Fowl of Ivory",
  "Hexed Fowl of Ebon",
  "Deathscythe Nun",
  "Moriae Encomium",

  "Marduk",
  "Moon and Sun",
  "Paradise Vanguard",
  "Amaterasu",
  "Tsukuyomi",
  "Suttungr",
  "Oceanus",
  "Divine Retribution",
  "Valkyrie of Chaos",
  "Valkyrie of Order",
  "Fount of Angels",

  "Forest Oracle Pascale",
  "Orchis, Puppet Girl",
  "Zwei, Murderous Puppet",
  "Lycoris, Poisoner Princess",
  "Lina & Lena, Twin Souls",
  "Michelle, the Mind Reader",
  "Liam, Master of Puppets",
  "Heartless Battle",
  "Junk",
  "Insane Dark Elf",
  "Zealot of Unkilling",
  "Knower of History",
  "Ward of Unkilling",

  "Aether of the Warrior Wing",
  "Dionne, Dancing Blade",
  "Roland the Incorruptible",
  "Swordflash Panther",
  "Durandal the Incorruptible",
  "Azord, Duke of the Mists",
  "Madlance Centaur",
  "Dance of Usurpation",
  "Phantom Assassin",
  "Zealot of Usurpation",
  "Wardog",
  "Mana Pistol Merc",
  "Godsend Stride",

  "Sweet-Tooth Medusa",
  "Prophetless of Creation",
  "Unbodied Witch",
  "Lovely-Heart Monika",
  "Edict of Truth",
  "Elusa, Magic Wunderkind",
  "Morra, Monika's Familiar",
  "Veridic Discovery",
  "Moonshade Mage",
  "Zealot of Truth",
  "Rabbit Mage",
  "Zealot of Destruction",
  "Joy of Destruction",

  "Dragon Empress Otohime",
  "Azi Dahaka",
  "Annerose",
  "Ouroboros",
  "Powerforge",
  "Elios, Loyal Dragoon",
  "Dragonsoul Princess",
  "Vile Violet Dragon",
  "Zealot of Disdain",
  "Righteous Dragoon",
  "Geovore",
  "Draco Marionette",
  "Sneer of Disdain",

  "Crimson Rose Queen",
  "Nepthys",
  "Tartarus, the Tormentor",
  "Vuella, One-Winged Demon",
  "Sonata of Silence",
  "Chris Pumpkinhead",
  "Salome",
  "Kiss of Lust",
  "Arion",
  "Marian the Mummy",
  "Zealot of Silence",
  "Zealot of Lust",
  "Manifest Malice",

  "Holylord Eachtar",
  "Godsworn Alexiel",
  "Eidolon of Madness",
  "Sekhmet",
  "Vengeful Radiance",
  "Collete, Holy Gunner",
  "Battlefield Inquisitor",
  "Manifestation of Repose",
  "Malevolent Al-mi'raj",
  "Zealot of Repose",
  "Temple Windbear",
  "Angel of the Iron Steed",
  "Forgotten Sanctuary",

  "Alterplane Arbiter",
  "Sylvia, the Condemner",
  "Sahaquiel",
  "Tart Man",
  "Slash of the One",
  "Reina, Evolution's Herald",
  "Ephemera, Sword Angel",
  "Treasure Map",
  "Steelclad Minotaur",
  "High Enchantress",
  "Happy Pig",

  "Ladica, the Stoneclaw",
  "Cynthia, the Queen's Blade",
  "Primal Giant",
  "Setus, the Beastblade",
  "Send 'Em Packing",
  "Blossom Spirit",
  "Avatar of Fruition",
  "Divine Smithing",
  "Chesire Cat",
  "Ghastly Treant",
  "Forest Hermit",
  "Marvelously Mad Hatter",
  "Fertile Aether",

  "Bayleon, Sovereign Light",
  "Mistolina, Forest Princess",
  "Tsubaki of the Demon Blade",
  "Leod, the Crescent Blade",
  "King's Might",
  "Troya, Thunder of Hagelberg",
  "Valse, Champion Deadeye",
  "Princess's Strike",
  "Swift Tigress",
  "Lupine Axeman",
  "Dauntless Commander",
  "Tempered Aether",
  "Elegance in Action",

  "Tetra, Sapphire Rebel",
  "Belphomet, Lord of Aiolon",
  "Riley, Hydroshaman",
  "Eleanor, Cosmic Flower",
  "Delta Cannon",
  "Displacer Bot",
  "Mechanized Lifeform",
  "Splendid Conjury",
  "Mechastaff Sorcerer",
  "Prototype Warrior",
  "Magiblade Witch",
  "Presto Chango",
  "Sagacious Core",

  "Valdain, Cursed Shadow",
  "Neptune, Tidemistress",
  "Wildfire Tyrannosaur",
  "Marion, Elegant Dragonewt",
  "Shadow's Corrosion",
  "Bubbleborne Mermaid",
  "Hoarfrost Triceratops",
  "Whirlwind Pteranodon",
  "Dragonewt Needler",
  "Lightning Velociraptor",
  "Doting Dragoneer",
  "Boomfish",
  "Feral Aether",

  "Mono, Garnet Rebel",
  "Kudlak",
  "Aenea, Amethyst Rebel",
  "Doublame, Duke and Dame",
  "Alpha Drive",
  "Nicola, Forbidden Strength",
  "Hellblaze Demon",
  "Forbidden Art",
  "Robozombie",
  "Bone Drone",
  "Berserk Demon",
  "Ghostwriter",
  "Sanguine Core",

  "Limonia, Flawed Saint",
  "Lapis, Glorious Seraph",
  "Father Refinement",
  "Marione, Light of Balance",
  "Augmentation Bestowal",
  "Bunny-Eared Administrator",
  "Robofalcon",
  "Marcotte, Heretical Sister",
  "Ironknuckle Nun",
  "Dark Bishop",
  "Meowskers, Ruff-Tuff Major",
  "Saintly Core",
  "Meowskers Ambush!",

  "Technolord",
  "Viridia Magna",
  "Mechawing Angel",
  "Desert Pathfinder",
  "Maisha, Hero of Purgation",
  "Robogoblin",
  "Colorful Cook",
  "Purgation's Blade",
  "Aldis, Trendsetting Seraph",
  "Mechagun Wielder",
  "Extreme Carrot",

  "Uzuki Shimamura [P.C.S.]",
  "Kyoko Igarashi [P.C.S.]",
  "Miho Kohinata [P.C.S.]",
  "Chika Yokoyama",
  "Momoka Sakurai",
  "Akiha Ikebukuro",
  "Nene Kurihara",
  "Karin Domyoji",

  "Rin Shibuya [Triad Primus]",
  "Nao Kamiya [Over the Rainbow]",
  "Karen Hojo [Song for Life]",
  "Yasuha Okazaki",
  "Yukimi Sajo",
  "Kako Takafuji",
  "Chizuru Matsuo",
  "Seira Mizuki",

  "Mio Honda [Positive Passion]",
  "Aiko Takamori [Handmade Hapiness]",
  "Akane Hino [Positive Passion]",
  "Kaoru Ryuzaki",
  "Suzuho Ueda",
  "Miria Akagi",
  "Miu Yaguchi",
  "Kumiko Matsuyama",

  "Aiko Takamori",
  "Miku Maekawa",
  "Yuzu Kitami",
  "Anastasia",
  "Brand New Beat",
  "Shinobu Kudo",
  "Yumi Aiba",
  "Goddess by the Sunlit Sea",
  "Honoka Ayase",
  "Azuki Momoi",
  "Kana Imai",
  "Otaha Umeki",
  "A Single Vessel",

  "Kyoko Igarashi",
  "Nagi Hisakawa",
  "Rin Shibuya",
  "Mio Honda",
  "Uzuki Shimamura",
  "Anzu Futaba",
  "Karen Hojo",
  "Sparkling Days",
  "Nao Kamiya",
  "Mayu Sakuma",
  "Kirari Moroboshi",
  "Miho Kohinata",
  "Angelic Maid",

  "Mizuki Kawashima",
  "Shiki Ichinose",
  "Syuko Shiomi",
  "Kanade Hayami",
  "Center Street",
  "Hina Araki",
  "Frederica Miyamoto",
  "Precocious Little Devil",
  "Sarina Matsumoto",
  "Rika Jougasaki",
  "Sae Kobayakawa",
  "Tomoe Murakami",
  "Full Bloom Panorama",

  "Akari Tsujino",
  "Yui Ohtsuki",
  "Fumika Sagisawa",
  "Akira Sunazuka",
  "Tsukasa Kiryu",
  "Arisu Tachibana",
  "Yuka Nakano",
  "Unbound Emotion",
  "Tokiko Zaizen",
  "Noriko Shiina",
  "Yukari Mizumoto",
  "Noa Takamine",
  "Mode Estivale",

  "Ranko Kanzaki",
  "Sachiko Koshimizu",
  "Takumi Mukai",
  "Chitose Kurosaki",
  "Whispers of a Dream",
  "Chiyo Shirayuki",
  "Aki Yamato",
  "My Life, My Sounds",
  "Ryo Matsunaga",
  "Mirei Hayasaka",
  "Rina Fujimoto",
  "Syoko Hoshi",
  "Last Daylight",

  "Kaede Takagaki",
  "Shin Sato",
  "Nana Abe",
  "Akane Hino",
  "Classroom Lily",
  "Risa Matoba",
  "Haru Yuuki",
  "Psychic Maiden",
  "Natalia",
  "Shizuku Oikawa",
  "Layla",
  "Sanae Katagiri",
  "Winter Night Prayer",

  "New Generations",
  "New Wave",
  "Master Trainer",
  "Expert Trainer",
  "Trainer",
  "Rookie Trainer",

  "Lymaga, Forest Champion",
  "Amataz, Fairy Blader",
  "Greenbrier Elf",
  "Wildwood Matriarch",
  "Fairy Dragon",
  "Woodland Cleaver",
  "Assault Jaguar",
  "Spiritshine",
  "Greenwood Guardian",
  "Crossbow Sniper",
  "Mallet Monkey",
  "Elven Sentry",
  "Synchronized Slash",

  "Kagemitsu, Matchless Blade",
  "Ralmia, Sonic Racer",
  "Steadfast Samurai",
  "Hero of Antiquity",
  "Courtly Dance",
  "Quickdraw Maven",
  "Twinsword Master",
  "Grand Acquisition",
  "Samurai Outlaw",
  "Adept Thief",
  "Petalwink Paladin",
  "Levin Scholar",
  "Breakneck Draw",

  "Kuon, Founder of Onmyodo",
  "Mysteria, Magic Founder",
  "Curse Crafter",
  "Hulking Giant",
  "Shikigami Summons",
  "Demoncaller",
  "Traditional Sorcerer",
  "Crimson Meteor Storm",
  "Talisman Disciple",
  "Charming Gentlemouse",
  "Passionate Potioneer",
  "Golem's Rampage",
  "Mirror of Truth",

  "Garyu, Surpreme Dragonkin",
  "Filene, Whitefrost Dragonewt",
  "Phoenix Empress",
  "Wyrm God of the Skies",
  "Whitefrost Whisper",
  "Ice Dancing Dragonewt",
  "Jadelong Tactician",
  "Aquascale Stalwart",
  "Swordwhip Dragoon",
  "Dragonblader",
  "Trident Merman",
  "Dragon Chef",
  "Flamewinged Might",

  "Ginsetsu, Great Fox",
  "Aragavy the Berserker",
  "Shuten-Doji",
  "Bear Pelt Warrior",
  "Yuzuki, Righteous Demon",
  "Kasha",
  "Cougar Pelt Warrior",
  "Unleash the Nightmare",
  "Zashiki-Warashi",
  "Antelope Pelt Warrior",
  "Rookie Succubus",
  "Demonic Procession",
  "Berserker's Pelt",

  "Wilbert, Grand Knight",
  "Karula, Arts Master",
  "Saintly Leader",
  "Phantom Blade Wielder",
  "Manifest Devotion",
  "Holy Lancer",
  "Boost Kicker",
  "Feather Sanctuary",
  "Winged Staff Priestess",
  "Gravity Grappler",
  "Barrage Brawler",
  "Holy Counterattack",
  "Focus",

  "Mammoth God's Colosseum",
  "Badb Catha",
  "Mithra, Daybreak Diety",
  "Fall from Grace",
  "Colosseum on High",
  "Chaht, Ringside Announcer",
  "Clash of Heroes",
  "Biofrabrication",
  "Sweet-Tooth Sleuth",
  "Bazooka Goblins",
  "Sentry Gate",

  "Izudia, Omen of Unkilling",
  "Spinaria, Keeper of Enigmas",
  "Apostle of Unkilling",
  "Morton the Manipulator",
  "Fairy Torrent",
  "Disciple of Unkilling",
  "Noah, Vengeful Puppeteer",
  "Mark of the Unkilling",
  "Servant of Unkilling",
  "Mechanical Bowman",
  "Flower Doll",
  "Automaton Soldier",
  "Mark of the Six",

  "Octrice, Omen of Usurpation",
  "Magna Legacy",
  "Apostle of Usurpation",
  "Empyreal Swordsman",
  "Confront Adversity",
  "Disciple of Usurpation",
  "Fervent Maachine Soldier",
  "Geno, Machine Artisan",
  "Servant of Usurpation",
  "Captain Meteo",
  "Gravikinetic Warrior",
  "Usurping Spineblade",
  "Avaritia",

  "Raio, Omen of Truth",
  "Lishenna, Omen of Destruction",
  "Apostle of Truth",
  "Safira, Synthetic Beast",
  "Destructive Refrain",
  "Iron Staff Mechanic",
  "Truth's Adjudication",
  "Monochromatic Destruction",
  "Disciple of Truth",
  "Disciple of Destruction",
  "Servant of Destruction",
  "Honest Cohort",
  "Metaproduction",

  "Galmieux, Omen of Disdain",
  "Electromagical Rhino",
  "Apostle of Disdain",
  "God Bullet Golem",
  "Disdainful Rending",
  "Disciple of Disdain",
  "Cursed Stone",
  "Amethyst Giant",
  "Servant of Disdain",
  "Silver Automaton",
  "Airship Whale",
  "Colossal Construct",
  "Total Domination",

  "Valnareik, Omen of Lust",
  "Rulenye, Omen of Silence",
  "Apostle of Lust",
  "Apostle of Silence",
  "Disciple of Lust",
  "Masked Puppet",
  "Wings of Lust",
  "Silent Purge",
  "Servant of Lust",
  "Servant of Silence",
  "Hamelin",
  "Embracing Wings",
  "Thundering Roar",

  "Marwynn, Omen of Repose",
  "Deus Ex Machina",
  "Apostle of Repose",
  "Hakrabi",
  "Ancient Protector",
  "Disciple of Repose",
  "Unidentified Subject",
  "Silver Cog Spinner",
  "Servant of Repose",
  "Demon's Epitaph",
  "The Saviors",
  "Realm of Repose",
  "Ancient Amplifier",

  "Mjerrabaine, Omen of One",
  "Gilnelise, Omen of Craving",
  "Apostle of Craving",
  "Lyrial, Archer Throne",
  "Feena, Dynamite Daredevil",
  "Rosa, Mech Wing Maiden",
  "Enlightenment",
  "Craving's Splendor",
  "Cat Cannoneer",
  "Steel Demolitionist",
  "Gliesaray",

  "Cassiopeia",
  "C.C., Woodland Witch",
  "Deepwood Anomaly",
  "King Elephant",
  "Fashionista Nelcha",
  "Spring-Green Protection",
  "Inviolable Verdancy",
  "Sukuna, Brave and Small",
  "Dolorblade Demon",
  "Elf Song",
  "Starry Elf",
  "Fita the Gentle Elf",
  "Dryad",
  "Beetle Warrior",
  "Ivy Spellbomb",

  "Mars, Silent Flame General",
  "Gawain of the Round Table",
  "Barbarossa",
  "Perseus",
  "Cyclone Blade",
  "Chivalrous Charge",
  "Shrouded Assassin",
  "Lord General Romeo",
  "Round Table Assembly",
  "Princess Juliet",
  "Flail Knight",
  "Pollux",
  "Tristan of the Round Table",
  "Armor of the Stars",

  "Wordwielder Ginger",
  "Giant Chimera",
  "Star Reader Stella",
  "Europa",
  "Chain of Calling",
  "Noble Instruction",
  "Freshman Lou",
  "Magic Illusionist",
  "Concentration",
  "Show of Loyalty",
  "Dazzling Healer",
  "Mage of Nightfall",
  "Astrologist of the Mist",
  "Magic Owl",
  "Starseer's Telescope",

  "Sibyl of the Waterwyrm",
  "Kallen, Crimson Yaksha",
  "Python",
  "Prime Dragon Keeper",
  "Star Phoenix",
  "Lightning Blast",
  "Guren Revolt",
  "Venomous Pucewyrm",
  "Cetus",
  "Dragonewt Fist",
  "Divine Tiger",
  "Dragonrearer Matilda",
  "Aqua Nerid",
  "Hippocampus",
  "Scaled Berserker",
  "Dragon's Nest",

  "Venomfang Medusa",
  "Howling Demon",
  "Demonlord Eachtar",
  "Lelouch, Leader of the Black Knights",
  "Stheno",
  "Trial of the Gorgons",
  "Fenrir",
  "Euryale",
  "Grave Desecration",
  "Emperor's Command",
  "Demonic Drummer",
  "Castor",
  "Frogbat",
  "Scorpius",
  "Venomous Bite",

  "Aether of the White Wing",
  "Dark Jeanne",
  "Zoe, Princess of Goldenia",
  "Andromeda",
  "Globe of the Starways",
  "Dark Charisma",
  "Star Priestess",
  "Calydonian Boar",
  "Star Torrent",
  "Starchaser Sprite",
  "Sister of Punishment",
  "Mist Shaman",
  "Octobishop",
  "Candelabra of Prayers",

  "Zodiac Demon",
  "Israfil",
  "Grimnir, War Cyclone",
  "Arriet, Soothing Harpist",
  "Staircase to Paradise",
  "Purehearted Singer",
  "Goblin Princess",
  "Mystic Ring",
  "Owlcat",
  "Mr. Full Moon",
  "Night's Way",

  "Beauty and the Beast",
  "Cosmos Fang",
  "Magical Fairy, Lilac",
  "Slade Blossoming Wolf",
  "Elf Twins' Assault",
  "Abby the Axe Girl",
  "Gerbera Bear",
  "Wood of Brambles",
  "Flower Princess",
  "Fen Sprite",
  "Tweedle Dum, Tweedle Dee",
  "Floral Breeze",
  "Woodland Band",
  "Cinderella",
  "Valiant Fencer",
  "Maisy, Red Riding Hood",
  "Amerro, Spear Knight",
  "Castle in the Sky",
  "Young Ogrehunter Momo",
  "Mach Knight",
  "Kiss of the Princess",
  "Rabbit Ear Attendant",
  "Old Man and Old Woman",
  "Bladed Hedgehog",
  "Ironwrought Defender",
  "Heroic Entry",
  "Wizardess of Oz",
  "Witch of Calamity, Millie Parfait",
  "Mystic King",
  "Falise, Leonardian Mage",
  "Milady, Mystic Queen",
  "Check",
  "Mr. Heinlein, Shadow Mage",
  "Magical Knight",
  "Gingerbread House",
  "It's a Sweets Buffet!",
  "Witch of Sweets",
  "Magical Rook",
  "Magical Bishop",
  "Blitz",
  "Witch's Cauldron",
  "The Cauldron of Calamity",
  "Jabberwock U",
  "Lævateinn Dragon",
  "Red Ragewyrm",
  "Draconir, Knuckle Dragon",
  "Tilting at Windmills",
  "Master of Draconic Arts",
  "Hammer Dragonewt",
  "Draconic Smash",
  "Elder Tortoise",
  "Trinity Dragon",
  "Dragon Summoner",
  "Lance Lizard",
  "Armor Burst",
  "Dark Alice",
  "Masquerade Ghost",
  "Odile, Black Swan",
  "Demonium, Punk Devil",
  "Baccherus, Peppy Ghostie",
  "Demon Maestro",
  "Trombone Devil",
  "Furtive Fangs",
  "Pumpkin Necromancer",
  "Parade Raven",
  "Mischievous Zombie",
  "Devilish Flautist",
  "Infernal Orchestration",
  "Princess Snow White",
  "Diamond Master",
  "Odette, White Swan",
  "Wingy Chirpy Gemstone",
  "Alice's Adventure",
  "White Knight",
  "Ruby Falcon",
  "March Hare's Teatime",
  "Tin Soldier",
  "Pinion Prince",
  "Birdkeeping Disciple",
  "Amethyst Lion",
  "Bejeweled Shrine",
  "Alice, Wonderland Explorer",
  "Angel of Chaos",
  "Rapunzel",
  "Seraph of Sin",
  "Garuel, Seraphic Leo",
  "Actress Feria",
  "Humpty Dumpty",
  "Winged Inversion",
  "Angel of Darkness",
  "Harbringer of the Night",
  "Eggsplosion",

  "Tazuna Hayakawa [Traccen Reception]",
  "Riko Kashimoto",
  "Aoi Kiryuin",
  "Silence Suzuka",
  "Smart Falcon",
  "Gold City",
  "Eat Fast! Yum Fast!",
  "Shinko Windy",
  "Eishin Flash",
  "Systematic Squats",
  "Marvelous Sunday",
  "Yukino Bijin",
  "Ines Fujin",
  "Taiki Shuttle",
  "Haru Urara",
  "Tokai Teio",
  "Narita Brian",
  "Winning Ticket",
  "Outrunning the Encroaching Heat",
  "Air Groove",
  "Hishi Amazon",
  "Trial Initiation",
  "Sirius Symboli",
  "Narita Taishin",
  "Symboli Rudolf",
  "Biko Pegasus",
  "Fuji Kiseki",
  "Agnes Tachyon",
  "Daiwa Scarlet",
  "Vodka",
  "Make! Some! NOISE!",
  "Zenno Rob Roy",
  "Agens Digital",
  "Lamplit Training of a Witch-to-Be",
  "Admire Vega",
  "Kawakami Princess",
  "Nakayama Festa",
  "Tosen Jordan",
  "Narita Top Road",
  "Special Week",
  "Oguri Cap",
  "Seiun Sky",
  "Champion's Passion",
  "King Halo",
  "Tamamo Cross",
  "Flowers for You",
  "Bamboo Memory",
  "Yaeno Muteki",
  "Grass Wonder",
  "Super Creek",
  "Hishi Akebono",
  "Maruzensky",
  "Rice Shower",
  "Nice Nature",
  "7 More Centimeters",
  "Fine Motion",
  "Mayano Top Gun",
  "My Solo Drawn to Raindrop Drums",
  "Curren Chan",
  "Twin Turbo",
  "Sakura Chiyono O",
  "Seeking the Pearl",
  "Matikanetannhauser",
  "Mejiro McQueen",
  "Gold Ship",
  "Ikuno Dictus",
  "The Will to Overtake",
  "Meisho Doto",
  "Mejiro Ryan",
  "Fate's Forecast",
  "Inari One",
  "Mejiro Dober",
  "Mejiro Ardan",
  "Mejiro Palmer",
  "T.M Opera O",
  "Riko Kashimoto [Planned Perfection]",
  "Close Knit Ambitions",
  "Take a Jab!",
  "Aoi Kiryuin [Trainers' Teamwork]",
  "Sasami Anshinzawa",
  "Tazuna Hayakawa",

  "Crystalia Tia",
  "White Wolf of Eldwood",
  "Elf Girl Liza",
  "Elf Knight Cynthia",
  "Grand Archer Seiwyn",
  "Crystalia Lily",
  "Baalt King of the Elves",
  "Elven Archery",
  "Dwarf Perfumer",
  "Elf Healer",
  "Forest Gigas",
  "Elf Bard",
  "Rose Deer",
  "Albert Levin Saber",
  "Alexander",
  "Amelia, Silver Paladin",
  "Leonidas",
  "White Paladin",
  "Jeno, Levin Vanguard",
  "Yurius, Levin Duke",
  "Whole-Souled Swing",
  "Swift Infiltrator",
  "Samurai",
  "Avant Blader",
  "Flame Soldier",
  "Gunner Maid Seria",
  "Daria Dimensional Witch",
  "Sun Oracle Pascale",
  "Anne, Belle of Mysteria",
  "Grea the Dragonborn",
  "Rimewind",
  "Remi & Rami, Witchy Duo",
  "Shadow Witch",
  "Multipart Expirement",
  "Craig, Wizard of Mysteria",
  "Grand Gargoyle",
  "Witchbolt",
  "Magical Strategy",
  "Red-Hot Ritual",
  "Imperial Dragoon",
  "Dragonsong Flute",
  "Neptune",
  "Draconic Fervor",
  "Polyphonic Roar",
  "Siegfried",
  "Transmogrified Wyrm",
  "Dracomancer's Rites",
  "Wildfang Dragonewt",
  "Mushussu",
  "Dragontamer",
  "Twin-Headed Dragon",
  "Draconic Armor",
  "Vania, Vampire Princess",
  "Soul Dealer",
  "Underworld Watchman Khawy",
  "Azazel",
  "Vampiric Fortress",
  "Veight, Vampire Noble",
  "Trick Dullahan",
  "Precious Bloodfangs",
  "Mini Soul Devil",
  "Moriana the Bejeweled",
  "Demonic Hedonist",
  "Bone Chimera",
  "Necrocarnival",
  "Heavenly Aegis",
  "Enstatued Seraph",
  "Kaguya",
  "Tribunal of Good and Evil",
  "Elana's Prayer",
  "Radiance Angel",
  "Saphire Priestess",
  "Beastcall Aria",
  "Frog Cleric",
  "Sky Sprite",
  "Soul Collector",
  "Sledgehammer Exorcist",
  "Emerald Maiden",
  "Dark Angel Olivia",
  "Bahamut",
  "Demonic Simulacrum",
  "Archangel Reina",
  "Surefire Bullet",
  "Unicorn Dancer Unicorn",
  "Gourmet Emperor Khaiza",
  "Call of Cocytus",
  "Hamsa",
  "Sektor",
  "Dance of Death",

  "Skullfane",
  "Hare of Illusions",
  "Priest of the Cudgel",
  "Acolyte's Light",
  "Dual Flames",
  "Ardent Nun",
  "Guardian Nun",
  "Pinion Prayer",
  "Beastly Vow",
  "Queen Vampire",
  "Alucard",
  "Playful Necromancer",
  "Midnight Vampire",
  "Night Horde",
  "Lesser Mummy",
  "Lilith",
  "Undying Resentment",
  "Summon Bloodkin",
  "Fafnir",
  "Dragon Oracle",
  "Dragon Warrior",
  "Dragonewt Princess",
  "Dragonguard",
  "Roc",
  "Glint Dragon",
  "Dragonrider",
  "Seabrand Dragon",
  "Mythril Golem",
  "Rune Blade Summoner",
  "Demonflame Mage",
  "Insight",
  "Fire Chain",
  "Penguin Wizard",
  "Sammy Wizard's Apprentice",
  "Magic Missle",
  "Conjure Golem",
  "Tsubasa",
  "Latham, Vanguard Captain",
  "Floral Fencer",
  "Moonlight Assassin",
  "White General",
  "Fencer",
  "Oathless Knight",
  "Quickblader",
  "Unbridled Fury",
  "Aria, Fairy Princess",
  "Titania's Sanctuary",
  "Rose Gardener",
  "Waltzing Fairy",
  "Fairy Caster",
  "Treant",
  "Water Fairy",
  "Elf Wanderer",
  "Sylvan Justice",
  "Rose Queen",
  "Ancient Elf",
  "Rhinoceroach",
  "Robin Hood",
  "Silver Bolt",
  "Homecoming",
  "Elven Princess Mage",
  "Blessed Fairy Dancer",
  "Elf Child May",
  "Fairy Beast",
  "Noble Fairy",
  "Nature's Guidance",
  "Harvest Festival",
  "Elf Metallurgist",
  "Archer",
  "Fairy Whisperer",
  "Okami",
  "Mana Elk",
  "Fairy Circle",
  "Woodkin Curse",
  "Woodland Refuge",
  "Sea Queen Otohime",
  "Aurelia, Regal Saber",
  "Shadowed Assassin",
  "Frontguard General",
  "Alwida's Command",
  "Royal Banner",
  "Maid Leader",
  "Gemstaff Commander",
  "Sage Commander",
  "Swordsman",
  "Pompous Princess",
  "Ninja Master",
  "Arthurian Light",
  "Ninja Trainee",
  "Fervid Soldier",
  "Luminous Knight",
  "Veteran Lancer",
  "Navy Lieutenant",
  "Novice Trooper",
  "Forge Weaponry",
  "Onslaught",
  "Arch Summoner Erasmus",
  "Merlin",
  "Ancient Alchemist",
  "Arcane Enlightenment",
  "Dimension Shift",
  "Juno's Secret Laboratory",
  "Spectral Wizard",
  "Flame Destroyer",
  "Dragonbond Mage",
  "Golem Protection",
  "Alchemical Lore",
  "Fate's Hand",
  "Price of Magic",
  "Runic Guardian",
  "Crafty Warlock",
  "Lightning Shooter",
  "Wind Blast",
  "Sorcery Cache",
  "Fiery Embrace",
  "Alchemist's Workshop",
  "Teachings of Creation",
  "Dark Dragoon Forte",
  "Zirnitra",
  "Aiela, Dragon Knight",
  "Genesis Dragon",
  "Shapeshifting Mage",
  "Phoenix Roost",
  "Wyvern Cavalier",
  "Dragonewt Scholar",
  "Shenlong",
  "Imprisoned Dragon",
  "Conflagration",
  "Serpent's Wrath",
  "Wyrm Spire",
  "Ivory Dragon",
  "Fire Lizard",
  "Ace Dragoon",
  "Mist Dragon",
  "Dread Dragon",
  "Blazing Breath",
  "Dragon Wings",
  "Dragon Emissary",
  "Cerberus",
  "Lord Atomy",
  "Medusa",
  "Righteous Devil",
  "Mordecai the Duelist",
  "Dire Bond",
  "Hell's Unleasher",
  "Crazed Executioner",
  "Dark Summoner",
  "Dark General",
  "Phantom Howl",
  "Death's Breath",
  "Soul Conversion",
  "Skeleton Fighter",
  "Ambling Wraith",
  "Spectre",
  "Spartoi Sergeant",
  "Rabbit Necromancer",
  "Wardrobe Raider",
  "Undead King",
  "Razory Claw",
  "Moon Al-mi'raj",
  "Jeanne d'Arc",
  "Arch Priestess Laelia",
  "Themis's Decree",
  "Chorus of Prayer",
  "Sacred Plea",
  "Temple Defender",
  "Prism Priestess",
  "Cleric Lancer",
  "Shrine Knight Maiden",
  "Blackened Scripture",
  "Dark Offering",
  "Holy Sentinel",
  "Cruel Priestess",
  "Sister Initiate",
  "Mainyu",
  "Snake Priestess",
  "Curate",
  "Hallowed Dogma",
  "Guardian Sun",
  "Death Sentence",
  "Gabriel",
  "Lucifer",
  "Flame and Glass",
  "Urd",
  "Wind God",
  "Gilgamesh",
  "Bellringer Angel",
  "Altered Fate",
  "Path to Purgatory",
  "Lizardman",
  "Goblinmount Demon",
  "Harnessed Flame",
  "Harnessed Glass",
  "Demonic Strike",
  "Execution",
  "Trail of Light",
  "Goblin",
  "Fighter",
  "Goliath",
  "Angelic Sword Maiden",
  "Healing Angel",
  "Angelic Snipe",
  "Angelic Barrage",


];

export const set16 = [
  "Aria, Lady of the Woods",
  "Orchis, Newfound Heart",
  "Nazuri, Bestial Innkeeper",
  "Glade, Fragrantwood Ward",
  "Lily, Crystalian Innocence",
  "Liam, Crazed Creator",
  "Aerin, Crystalian Frostward",
  "Bayle, Luxglaive Warrior",
  "Godwood Staff",
  "Fairy Tamer",
  "Good Fairy of the Pond",
  "Fay Twinkletoes",
  "Baby Carbuncle",
  "Fragrantwood Whispers",

  "Amelia, Silver Captain",
  "Albert, Levin Stormsaber",
  "Ginne, Bewitching Courtesan",
  "Zirconia, Ironcrown Ward",
  "Amalia, Luxsteel Paladin",
  "Ravening Tentacles",
  "Luminous Commander",
  "Luminous Magus",
  "Rusty, Luxcard Trickster",
  "Jeno, Levin Axeraider",
  "Flashstep Quickblader",
  "Luminous Lancetrooper",
  "Lyrala, Luminous Potionwright",
  "Ignominious Samurai",
  "Ironcrown Majesty",

  "Anne & Grea, Mysterian Duo",
  "Lilanthim, Anathema of Edacity",
  "Zizdvend, Fate's Arbiter",
  "Edelweiss, Sagelight Ward",
  "Juno, Visionary Alchemist",
  "Homework Time!",
  "Penelope, Potions Prodigy",
  "Ms. Miranda, Adored Academic",
  "Snowman Army",
  "Starry-Eyed Penguin Wizard",
  "Emmylou, Witch of Wonder",
  "William, Mysterian Student",
  "Sagelight Teachings",
  "Truth Summons",

  "Forte, Blackwing Dragoon",
  "Burnite, Anathema of Flame",
  "Nirle, Draconic Prodigy",
  "Liu Feng, Goldennote Ward",
  "Genesis Dragon Reborn",
  "Fan of Otohime",
  "Eyfa, Windrider",
  "Marion, Ravishing Dragonewt",
  "Kit, Luxfang Champion",
  "Zahar, Stormwave Dragoon",
  "Little Dragon Nanny",
  "Zell, Windreader",
  "Silvercloud Dragonrider",
  "Swordsnout Trencher",
  "Goldennote Melody",

  "Cerberus, Hellfire Unleashed",
  "Aragavy, Eternal Hunter",
  "Gold Rush Ghost",
  "Mukan, Shadowcrypt Ward",
  "Balto, Dusk Bounty Hunter",
  "Ceres, Blue Rose Maiden",
  "Orthrus, Hellhound Blader",
  "Yuna, Occult Hunter",
  "Soul Predation",
  "Vlad, Impaler",
  "Aryll, Moonstruck Vampire",
  "Mino, Shrewd Reaper",
  "Beryl, Nightmare Incarnate",
  "Shadowcrypt Memorial",

  "Lapis, Shining Seraph",
  "Rodeo, Anathema of Judgment",
  "Rana, Dual Cannon Abbess",
  "Ronavero, Darkhaven Ward",
  "Salefa, Guardian of Water",
  "Pact of the Beast Princess",
  "Angelic Prism Priestess",
  "Reno, Luxwing Featherfolk",
  "Serene Sanctuary",
  "Ironfist Priest",
  "Maeve, Guardian of Earth",
  "Holy Shieldmaiden",
  "Mainyu, Darkdweller",
  "Darkhaven Grace",

  "Olivia, Heroic Dark Angel",
  "Ruler of Cocytus",
  "Phildau, Lionheart Ward",
  "Alouette, Doomwright Ward",
  "Leah, Bellringer Angel",
  "Apollo, Heaven's Envoy",
  "Divine Thunder",
  "Doomwright Resurgence",
];

export const setIDOL2 = [
  "Anastasia [Seize the Light]",
  "Hajime Fujiwara [Pink Blossom Dream]",
  "Minami Nitta [Goddess by the Sunlit Sea]",
  "Yuki Himekawa [Challengers' Cheer]",
  "Riina Tada [Wannabe Legend]",
  "Hinako Kita [True Dream]",
  "Miku Maekawa [Meownderful World]",
  "Blossoms' Advance",
  "Rin & Mio",
  "Mio Honda [Cinderella Girl]",
  "Uzuki Shimamura [Magical New Me]",
  "Karen Hojo [Cinderella Girl]",
  "Airi Totoki [Cinderella Girl]",
  "Mayu Sakuma [Love-Laden Gift]",
  "Chieri Ogata [Happiness Tune]",
  "Nagi Hisakawa [Everyday Fairy Tale]",
  "Miho Kohinata [Youthful Romance]",
  "Dancing in the Rain",
  "Syuko Shiomi [Cinderella Girl]",
  "Mika & Rika",
  "Yuuki Otokura [Ripples of My Heart]",
  "Glitz & Glam☆Parade",
  "Sae Kobayakawa [Dancing Flowers]",
  "Hiromi Seki [Twinkle in My Eye]",
  "Shiki Ichinose [Mystic Elixir]",
  "Kanade Hayami [Faraway Reflection]",
  "Tomoe Murakami [Crimson Fighter]",
  "Fumika Sagisawa [Cinderella Girl]",
  "Akira Sunazuka [Online Life]",
  "Akari & Akira",
  "Riamu Yumemi [Shout It to the World]",
  "Yui Ohtsuki [Lollipop Darling]",
  "Hotaru Shiragiku [Unbreakable]",
  "Star of the Show",
  "Ranko Kanzaki [Princess in White]",
  "Syoko Hoshi [individuals]",
  "Mirei Hayasaka [individuals]",
  "Nono Morikubo [individuals]",
  "Asuka Ninomiya [Gentle Evening]",
  "Chitose Kurosaki [Memento Mori]",
  "Natsuki Kimura [Scarlet Love Song]",
  "Takumi Mukai [No One Can Stop Me]",
  "Koume Shirasaka [Haunted Gown]",
  "Self-Proclaimed Fan Favorite",
  "Nana Abe [Cinderella Girl]",
  "Kaede Takagaki [Cinderella Girl]",
  "Eve Santaclaus [Holy Night Miracle]",
  "Miyu Mifune [Parfum Géranium]",
  "Kako Takafuji [Lady Luck]",
  "Kotoka Saionji [Pure Euphoria]",
  "Haru Yuuki [Secret Blue Rose]",
  "Natalia [One Thousand and One Nights]",
  "A Sweet Romantic Summer",
  "Curtain Call of Smiles",
];

export const set17 = [
  "Arisa, Evergreen Arrow",
  "Ladica, Verdant Claw",
  "Setus, Sunlit Hero",
  "Lococo, Little Puppeteer",
  "Friendly Embrace",
  "Forest Guardian's Bow",
  "Beastfolk Harvester",
  "Heroic Resolve",
  "Inverted Manipulation",
  "Blossom Treant",
  "Sköll Lookout",
  "Elf Sorcerer",
  "Threadsnipper Puppet",
  "Heroic Fairy Champion",
  "Erika, Loyal Swordsavant",
  "Mistolina & Bayleon",
  "Leod, Moonlit Executioner",
  "Frenzied Corpsmaster",
  "Sunny Day Encounter",
  "Killer Instincts",
  "Valhorean Dealer",
  "Bladerights Lieutenant",
  "Shadowed Memories",
  "Fox Lancer",
  "Stone Merchant",
  "Victorious Grappler",
  "Countersolari Survivor",
  "Brothers United",
  "Isabelle, Intrepid Mage",
  "Eleanor, Glorious Flower",
  "Belphomet, Ultimate Creator",
  "Tetra, Serene Sapphire",
  "Mega Enforcer",
  "Nefarious Invasion",
  "Marie, Flowery Magician",
  "Enforcer",
  "Fruits of Wisdom",
  "Awakened Robot",
  "Covenant Mage",
  "Jetbroom Witch",
  "Panacea Alchemist",
  "Mysterian Wisdom",
  "Rowen, Dragon Lance",
  "Valdain, Forest Shadow",
  "Disrestan, Ocean Harbinger",
  "Djeana, the Stouthearted",
  "Verdant Rebirth",
  "Dragonslayer Spear",
  "Forestclaw Sentinel",
  "Rock Whale",
  "Newfound Allies",
  "Shark Warrior",
  "Poisonous Dilophosaurus",
  "Mánagarmr Scout",
  "Mermaid Archer",
  "Touching Thoughts",
  "Luna, Soul Keeper",
  "Urias, Final Vampire",
  "Mono, Immortal Garnet",
  "Aenea, Creative Amethyst",
  "Nicola, Enduring Steward",
  "Steeled Hopes",
  "Amy, Psychopomp Guide",
  "Roly-Poly Mk II",
  "Allure of Shadows",
  "Rouge Vampire",
  "Vampiric Bloodbinder",
  "Trampling Terror",
  "Soul Commander",
  "Midnight Gossip",
  "Eris, Atoned Priestess",
  "Yuwan, Dimensional Avenger",
  "Meowskers, Fluffy Consul",
  "Marlone, Peace Advocate",
  "Vice, Death Grip",
  "Automachina Maiden",
  "Aerial Craft",
  "Balance and Obliteration",
  "Unlikely Fellowship",
  "Steelwing",
  "Technomancer",
  "Android Artisan",
  "Mark Unleashed",
  "Unicorn Altar",
  "Maisha, Purgation's Vessel",
  "Great Mother's Embrace",
  "Hoverboard Mercenary",
  "Cosmic Angel",
  "Guild Assembly",
  "Naterra's Future",
  "Unnamed Determination",
  "Aiolon's Remains",
];

export const set15 = [
  "Izudia, Unkilling Annihilation",
  "Amataz, Reverse Blader",
  "Piercye, Queen of Frost",
  "Inauspicious Puppeteer",
  "Erosive Annihilation",
  "Rejuvenating Resurrection",
  "Cryptid Keeper",
  "Adherent of Annihilation",
  "Fairy Healer",
  "Hermit of Unkilling",
  "Horned Beastie",
  "Bouquet Fairy",
  "Emerald Wildfox",
  "Wind Fairy",

  "Octrice, Hollow Usurpation",
  "Kagemitsu, Lost Samurai",
  "Ralmia, Astrowing",
  "Arsène Lupin",
  "Ultimate Hollow",
  "Supersonic Breakthrough",
  "Adherent of Hollowness",
  "Sword General",
  "Serration Wave",
  "Penguin Guardian",
  "Hermit of Usurpation",
  "Chivalrous Bandit",
  "Flying Messenger Squirrel",
  "Brave Buccaneer",

  "Raio, Truthful Elimination",
  "Lishenna, Melodious Destruction",
  "Kuon, Wuxing Master",
  "Acid Golem",
  "Melody's Return",
  "Secrets of Onmyodo",
  "Adherent of Elimination",
  "Adherent of Melody",
  "Elimination Unleashed",
  "Scroll Wizard",
  "Hermit of Truth",
  "Hermit of Destruction",
  "Crystal Witch",

  "Twinblade Mage",
  "Galmieux, Ardent Disdain",
  "Filene, Blizzardous Heart",
  "Celestial Dragoon",
  "Mermaid of Punishment",
  "Ardent Torch",
  "Whitefrost Blizzard",
  "Adherent of Ardor",
  "Windswept Dragonewt",
  "Tropical Mermaid",
  "Tiniest Dragon",
  "Hermit of Disdain",
  "Beginner Dragoon",
  "Orbed Cancer",

  "Whimsical Mermaid",
  "Valnareik, Lustful Desire",
  "Rulenye, Screaming Silence",
  "Ginsetsu, Terror Banquet",
  "Yuzuki, Bloodlord",
  "Spiteful Screams",
  "A Hellish Banquet",
  "Adherent of Desire",
  "Loathing Desire",
  "Crimson Virtue",
  "Adherent of Screams",
  "Hermit of Lust",
  "Hermit of Silence",
  "Krampus",

  "Astral Projection",
  "Marwynn, Repose of Despair",
  "Wilbert, Luminous Paladin",
  "Sarissa, Luxflash Spear",
  "Shiro, Cursed Wings",
  "Cyclical Fate",
  "Perpetual Despair",
  "Adherent of Despair",
  "Zeno, Paradoxical Shield",
  "Crusader's Rallying Cry",
  "Temple Healer",
  "Hermit of Repose",
  "Hardplume Warrior",
  "Caladrius",

  "Sacred Gavel",
  "Mjerrabaine, Great One",
  "Gilnelise, Ravenous Craving",
  "Arael",
  "Thunder God of the Tempest",
  "Resolve of the Fallen",
  "Mechanical Analyzer",
  "Messenger of the Skies",
  "Merciless Voiding",
  "Nomadic Conductor",
  "Mountain Gigas",
  "Fluffy Angel",
];

export const set14 = [
  "Hozumi, Enchanting Hostess",
  "Levon, Scentbound Sword",
  "Bastion of Seasons",
  "Spirit of the Spring",
  "Illusions of Comfort",
  "Elven Waitress",
  "Tinkering Shopkeeper",
  "Craftsman's Pride",
  "Karakuri Servant",
  "Fairylight Guide",
  "Woodland Pest Control",
  "Windswept Lancer",
  "Elven Craftsmanship",

  "Taketsumi, Aconite Paladin",
  "Mars, Belligerent Flame",
  "Jiemon, Thief Lord",
  "Bumpkin Recruit",
  "Hero of the Hunt",
  "Masterful Musician",
  "War Hero",
  "Noble Shieldmaiden",
  "Front Desk Frog",
  "Violent Soldier",
  "Hasty Axeman",
  "Night on the Town",
  "Haggler's Gambit",

  "Yukishima, Master Biographer",
  "Riley, Astral Shaman",
  "Bergent, Layered Sorceress",
  "Arctic Chimera",
  "Story of a Lifetime",
  "Orchestral Mage",
  "Tempestuous Alchemist",
  "Dream Come True",
  "Chakram Wizard",
  "Owl Receptionist",
  "Earthen Fist",
  "Magical Reserves",
  "Grand Spire",

  "Si Long, Draconic God-Queen",
  "Sacred Springs Dragon",
  "Frostbite Dragon",
  "Dragonskull Bludgeoner",
  "Soothing Dragonspring",
  "Dragonfolk Stoker",
  "Leviathan, the Furious",
  "March of the Dragonspring",
  "Dragon Breeder",
  "Dragon-Drawn Carriage",
  "Loyal Sea Serpent",
  "Mermaid Song",
  "Aquatic Authority",

  "Itsurugi, Eager Admirer",
  "Paracelise, Demon of Greed",
  "Anisage, Lost Forsaken",
  "Frigid Necromancer",
  "Eternal Contract",
  "Briared Vampire",
  "Room Service Demon",
  "Undying Resolve",
  "Silvernail Blaster",
  "Parkour Werewolf",
  "Bat Usher",
  "Creeping Malice",
  "Full Moon Leap",

  "All-Feeling Divine",
  "Shion, Immortal Aegis",
  "Nekhbet",
  "Impious Bishop",
  "Chamber of Cleansing",
  "Winged Gatekeeper",
  "Boomerang Sister",
  "Spiritual Blow",
  "Twinblade Featherfolk",
  "Fox of Fortune",
  "Pegasus Knight",
  "Al-mi'raj Defender",
  "White Eagle Baptism",

  "Magna Saber",
  "Flame and Glass, Duality",
  "Glistering Angel",
  "Angel's Blessing",
  "Magna Transformation",
  "Gunslinger Automaton",
  "Ogre Weaponmaster",
  "Stay in Paradise",
  "Brave Goblin",
  "Torchbearing Guide",
  "Goblin Assault",
];

export const setUMA2 = [
  "Hokko Tarumae",
  "Sakura Laurel",
  "Sounds of Earth",
  "Haru Urara [Sunny Passion ♪]",
  "Yamanin Zephyr",
  "Sakura Bakushin O",
  "Mihono Bourbon",
  "A MORE MARVELOUS WORLD! ☆",

  "Gentildonna",
  "Symboli Rudolf [Enchaînement]",
  "Sirius Symboli [Escorte Étoile]",
  "Aston Machan",
  "Symboli Kris S",
  "Tap Dance City",
  "Biwa Hayahide",
  "Teio-Oo-Oo!!!",

  "Cheval Grand",
  "Tanino Gimlet",
  "Narita Top Road [Peachy Silhouette]",
  "Verxina",
  "Vivlos",
  "Daitaku Helios",
  "Sweep Tosho",
  "Lucky Star in the Sky",

  "Neo Universe",
  "Mr. C.B.",
  "Katsuragi Ace",
  "Super Creek [Piece of Mind]",
  "Tsurumaru Tsuyoshi",
  "El Condor Pasa",
  "Nishino Flower",
  "Pious Flame, Heavens Scorcher",

  "Hishi Miracle",
  "Daiichi Ruby",
  "Duramente",
  "Matikanetannhauser [Machitan☆Adventure]",
  "K.S.Miracle",
  "Air Shakur",
  "Manhattan Cafe",
  "TT Ignition!",

  "Satono Crown",
  "Mejiro Ramonu",
  "Jungle Pocket",
  "Wonder Acute",
  "Mejiro Ardan [Hopeful Petals Dancing in the Night]",
  "Matikanefukukitaru",
  "Mejiro Palmer [Moonlit Devil ♪]",
  "Bring 'Em Home, Please!",

  "Progenitors and Guides",
  "Balliamo?",
  "Ryoka Tsurugi",
];

export const set13 = [
  "Sekka, Fatebound Fox",
  "Aria, Miasma Fairy",
  "Nelcha, Fashion Hazard",
  "Spinaria, Keeper of the End",
  "Resolve of the Nine-Tailed Fox",
  "Sunbright Elf",
  "Wildwood Warrior",
  "Tree of Wonders",
  "Fairy Slugger",
  "Edgy Elf",
  "Gazania Fox",
  "Tower Root Giant",
  "Feybolt Archer",

  "Albert, Thunderous Doom",
  "Magna Zero",
  "Sera, Maiden of the Dawn",
  "Homebound Infantryman",
  "Levin Justice",
  "Lounes, Levin Apprentice",
  "Jeno, Fanged Tyrant",
  "Cat Admiral",
  "Mina, Levin Vice Leader",
  "Mona, Levin Mage",
  "Mena, Levin Duelist",
  "Icyclone",
  "Meet the Levin Sisters!",

  "Anne, Mysterian Imperatrix",
  "Ghios, Sparkling Prism",
  "Mileka, Celestial Seer",
  "Grea, Scorching Fury",
  "Whims of Chaos",
  "Grimoire Sorcerer",
  "Hurricane Golem",
  "Riven Earth",
  "Magical Squirrel",
  "Art Society Magus",
  "Cat Summoner",
  "Arcane Duplication",
  "Sacrifice",

  "Drache, Fiery Dragonlord",
  "Forte, Sovereign Supreme",
  "Godfire Phoenix",
  "Roy, Dragonreaver",
  "Howling Conflagration",
  "Flame Pillar Dragonewt",
  "Empyreal Dragon",
  "Scalebound Plight",
  "Margarite Mermaid",
  "Earthen Dragonewt",
  "Twinblade Dragonfolk",
  "Coral Shark",
  "Beating of the Dragonwings",

  "Aluzard, Timeworn Vampire",
  "Laura, Crimson Strife",
  "Ceres, Bride of the Night",
  "Kagero, Swordbound Soul",
  "Chris, Beyond the Patch",
  "Liberté, Unchained Wolf",
  "Silversteel Blader",
  "Soulstrike",
  "Linkstaff Necromancer",
  "Noble Phantom",
  "Bandage Connoisseur",
  "Ghastly Banishment",
  "Sanguine Necklace",

  "Jeanne, Despair's Maiden",
  "Jatelant, God of Prosperity",
  "Lunerian Paladin",
  "Absolute Tolerance",
  "Westmuenster Abbey",
  "Pyne, Twisted Justice",
  "Thornclad Arbiter",
  "Gods' Loving Smite",
  "Charitable Al-mi'raj",
  "Prismawing Featherfolk",
  "Turquoise Sister",
  "Sacred Groundskeeper",
  "Sealed Tome",

  "Sahaquiel & Israfil",
  "Planetary Fracture",
  "Miriam, Mutinous Being",
  "Grimnir, Voidwrought Wind",
  "Frostfire",
  "Managrocer",
  "Goddess of Rebirth",
  "Dogged Detective",
  "Armored Goblin",
  "Fallen Harpist",
  "Retracing the Past",
];

export const set12 = [
  "Awakened Gaia",
  "Elf Queen of Abundant Life",
  "Carbuncle, Immortal Jewel",
  "Irene, Harvest Defender",
  "Intertwined Resolve",
  "Forest Defender",
  "Windfall Fay",
  "Aria's Whirlwind",
  "Forest Hatcheteer",
  "Springleaf Sprite",
  "Elven Pikeman",
  "Fairy Officer",
  "Fairy Menhir",

  "Patrick, Rhiceros Knight",
  "Lecia, Sky Saber",
  "Ironfist Beast Warrior",
  "Alwida, Pirate Queen",
  "Stroke of Conviction",
  "Nano, the Dawnblade",
  "Panther Scout",
  "King's Welcome",
  "Lilje, Butler of the Mists",
  "Sheena, Maid of the Mists",
  "Wolf Fang Swordsman",
  "Splendid Fencer",
  "Ivory Sword Dance",

  "Belphomet, Worldreaver",
  "Daria, Infinity Witch",
  "Regalore, Steel Chimera",
  "Melvie, Princess Witch",
  "Sorcery in Solidarity",
  "Chaos Wielder",
  "Rebel Against Fate",
  "Arcane Item Shop",
  "Gigahand Golem",
  "Device Diviner",
  "Mechabook Sorcerer",
  "Chain Lightning",
  "Mystic Absorption",

  "Shipsbane Plesiosaurus",
  "Jerva, Wyrm Transcendent",
  "Steelcap Pachycephalosaurus",
  "Giselle, Mermaid Healer",
  "Cursed Furor",
  "Assault Dragoon",
  "Petalspine Stegosaurus",
  "Phoenix Howl",
  "Dragoon Medic",
  "Rockback Ankylosaurus",
  "Ruinous Dragon",
  "Dragon Aficionado",
  "Overwhelming Crush",

  "Neun, Daybreak Vampire",
  "Gremory, Death Teller",
  "Jackshovel Gravedigger",
  "Medusa, Evil-Eyed Serpent",
  "Friends Forever",
  "Liberté, Werewolf Pup",
  "Hellfire Hound",
  "Garnet Waltz",
  "Bloodstained Berserker",
  "Roly-Poly Mk I",
  "Mechasaw Deathbringer",
  "Ghoul",
  "Viper Lash",

  "Rola, Inferno Dragoon",
  "Charaton, Iceflame Priest",
  "Gullias, Silverbeast Lord",
  "Robowhip Reverend",
  "Major Prayers",
  "Holylight Convert",
  "Smilecure Priest",
  "Salvation Ex Limonia",
  "Sol Sister",
  "Robowing Precant",
  "Fortune Fowl",
  "Pilgrims' Path",
  "Fiery Paean",

  "Natur Al'machinus",
  "Changewing Cherub",
  "Seraphic Blade",
  "Travelers' Respite",
  "Romantic Chanteuse",
  "Giving Gourmet",
  "Goblin Warpack",
  "Plucky Treasure Hunter",
  "Wayfaring Illustrator",
  "We've Got a Case!",
];

export const setSEA = [
  "Spinaria, Waveing Will",
  "Amelia, Sunny Paladin",
  "Falise, Innocent Sea Spray",
  "Sharon, Seaside Nymph",
  "Queen Vampire, Sultry Evening",
  "Zoe, Shore's Melody",
  "Alice, Golden Afternoon",
];

export const set11 = [
  "Loxis, Homestead Pioneer",
  "Shamu & Shama, Posh Felines",
  "Terrorformer",
  "Giant Pastures",
  "Fairy Flowering",
  "Varmint Hunter",
  "Stringmaster",
  "Corrosive Thorns",
  "Lookout Elf",
  "Cactus Cowboy",
  "Nature's Warden",
  "Hornet Strike",
  "Scavenge",

  "Nahtnaught, Cursed Queen",
  "Bunny & Baron, Specter Duo",
  "Reinhardt, the Deathless",
  "Radical Gunslinger",
  "Tyrant's Order",
  "Stalwart Slinger",
  "Outlaw Gunner",
  "Desperados' Shot",
  "Shinobi Tanuki",
  "Naht's Henchman",
  "Frontline Instructor",
  "Bandit Raid",
  "Dramatic Retreat",

  "Vincent, the Peacekeeper",
  "Maiser, Neighborhood Hero",
  "Magical Gunslinger",
  "Transcendent Simulacrum",
  "Words of Judgment",
  "Artistic Arcanist",
  "Golem Marshal",
  "Rapid Fire",
  "Crystal Fencer",
  "Rivaylian Deputy",
  "Mirror Witch",
  "Terra Nova",
  "Scorching Blast",

  "Reggie, Peerless Artisan",
  "Resplendent Phoenix",
  "Georgius",
  "Balefire Wrenchsmith",
  "Dragon-Devouring Dread",
  "Azureflame Dragonewt",
  "Dragonfolk Artificer",
  "Draconic Call",
  "Mermaid Guide",
  "Wyrmfire Engineer",
  "Pumpkin Dragon",
  "Wavecrest Angler",
  "Thunderous Roar",

  "Iceschillendrig, Gilded Autocrat",
  "Illganeau, Horror Astray",
  "Hazhan, Demonblade Knight",
  "Greatpick Corpse",
  "Dead to Rights",
  "Wretch",
  "Gold Mine Necromancer",
  "Wretched Tryst",
  "Redcap",
  "Skeleton Dreamer",
  "Fulminating Berserker",
  "Grudge Teller",
  "Spiderweb Array",

  "Selena, Sugarkiss Assassin",
  "Anvelt, Judgment's Cannon",
  "Vengeful Sniper",
  "Paladin of Clemency",
  "Holy Sanctuary",
  "Set",
  "Shady Priest",
  "Haven Fire",
  "Enchanted Knight",
  "Revolver Eagle",
  "Sacred Stone Apostle",
  "Benevolent Blight",
  "Pure Metamorphosis",

  "Sylvia, Grand Arbiter",
  "Quixotic Adventurer",
  "Goblin Queen",
  "Embodiment of Cocytus",
  "Wandering Chef",
  "Supercharged Guitarist",
  "Titanic Showdown",
  "Rivaylian Bandit",
  "Vagabond Lizard",
  "Spice Shower",
];

export const setVG = [
  "Alfred Early",
  "Blaster Blade",
  "Wingal",
  "Knight of Conviction, Bors",
  "Flash Shield, Iseult",
  "Knight of Silence, Gallatin",
  "Little Sage, Marron",
  "Lake Maiden, Lien",
  "Knight of Rose, Morgana",
  "Stardust Trumpeter",

  "Dragonic Overlord",
  "Dragon Monk, Goku",
  "Dragon Knight, Aleph",
  "Berserk Dragon",
  "Wyvern Guard, Barri",
  "Dragon Knight, Nehalem",
  "Embodiment of Armor, Bahr",
  "Chain-Attack Sutherland",
  "Follower, Reas",
  "Lizard Runner, Undeux",

  "Blue Storm Dragon, Maelstrom",
  "Storm Rider, Diamantes",
  "Storm Rider, Basil",
  "Marine General of the Restless Tides, Algos",
  "Hydro Hurricane Dragon",
  "Water General of Wave-Like Spirals, Benedict",
  "Tear Knight, Valeria",
  "Tear Knight, Lazarus",
  "Tear Knight, Theo",
  "Light Signals Penguin Soldier",
  "Tear Knight, Cyprus",
  "Emerald Shield, Paschal",
  "Battleship Intelligence",
  "Pyroxene Communications Sea Otter Soldier",
  "Dolphin Soldier of High Speed Raids",
  "Medical Officer of the Rainbow Elixir",
  "Coral Assault",
  "Battle Siren, Cynthia",
  "Officer Cadet, Erikk",

  "Majesty Lord Blaster",
  "Swordsman of the Explosive Flames, Palamedes",
  "Star Call Trumpeter",
  "High Dog Breeder, Akane",
  "Knight of Loyalty, Bedivere",
  "Solitary Knight, Gancelot",
  "Knight of Friendship, Kay",
  "Barcgal",
  "Miru Biru",
  "Young Pegasus Knight",
  "Toypugal",
  "Pongal",
  "Future Knight, Llew",
  "Margal",
  "Flogal",
  "Yggdrasil Maiden, Elaine",
  "Starlight Unicorn",
  "Knight of Truth, Gordon",
  "Wingal Brave",

  "Silver Thorn Dragon Tamer, Luquier",
  "Nightmare Doll, Alice",
  "Purple Trapezist",
  "Crimson Beast Tamer",
  "Mistress Hurricane",
  "Golden Beast Tamer",
  "Starlight Melody Tamer, Farah",
  "Turquoise Beast Tamer",
  "Dark Metal Bicorn",
  "Nitro Juggler",
  "Midnight Bunny",
  "Hades Hypnotist",
  "Dynamite Juggler",
  "Rainbow Magician",
  "Skyhigh Walker",
  "Candy Clown",
  "Jumping Jill",
  "Skull Juggler",
  "Girl Who Crossed the Gap",

  "Dragonic Overlord the End",
  "Seal Dragon, Blockade",
  "Burning Horn Dragon",
  "Blazing Core Dragon",
  "Dragonic Executioner",
  "Vortex Dragon",
  "Flame of Promise, Aermo",
  "Bellicosity Dragon",
  "Prowling Dragon, Striken",
  "Dragon Monk, Gojo",
  "Demonic Dragon Berserker, Yaksha",
  "Demonic Dragon Mage, Kimnara",
  "Embodiment of Spear, Tahr",
  "Gatling Claw Dragon",
  "Lizard Soldier, Ganlu",
  "Dragon Monk, Genjo",
  "Irontail Dragon",
  "Flame of Hope, Aermo",
  "Lizard Soldier, Conroe",

  "Phantom Blaster Overlord",
  "Phantom Blaster Dragon",
  "Blaster Dark",
  "Skull Witch, Nemain",
  "Knight of Nullity, Masquerade",
  "Darkness Maiden, Macha",
  "Cursed Lancer",
  "Knight of Darkness, Rugos",
  "Black Sage, Charon",
  "Doranbau",
  "Blaster Javelin",
  "Dark Shield, Mac Lir",
  "Grim Reaper",
  "Abyss Freezer",
  "Darkside Trumpeter",
  "Abyss Healer",
  "Witch of Nostrum, Arianrhod",
  "Gururubau",
  "Fullbau",

  "Goddess of the Full Moon, Tsukuyomi",
  "Goddess of the Half Moon, Tsukuyomi",
  "CEO Amaterasu",
  "Silent Tom",
  "Evil-eye Princess, Euryale",
  "Maiden of Libra",
  "Battle Sister, Cocoa",
  "Oracle Guardian, Wiseman",
  "White Hare of Inaba",
  "Goddess of the Crescent Moon, Tsukuyomi",
  "Dark Cat",
  "Battle Sister, Chocolat",
  "Oracle Guardian, Nike",
  "Dream Eater",
  "Emergency Alarmer",
  "Lozenge Magus",
  "Battle Maiden, Tagitsuhime",
  "Luck Bird",
  "Godhawk, Ichibyoshi",

  "Powers Converged",
];

export const set10 = [
  "XII. Wolfraud, The Hanged Man",
  "Lucille, Keeper of Relics",
  "Chipper Skipper",
  "Windflower Tiger",
  "Treacherous Reversal",
  "Salvia Panther",
  "Optimistic Beastmaster",
  "Lumbering Carapace",
  "Reclusive Ponderer",
  "Crocus Rat",
  "Blossoming Archer",
  "Deepwood Wolf",
  "Fairy Assault",

  "VII. Oluon, The Chariot",
  "Alyaska, War Hawker",
  "Prudent General",
  "Ilmisuna, Discord Hawker",
  "Aerial Slash",
  "Lightning Kicker",
  "Empress of Serenity",
  "Knight Neilan the Lazy",
  "Honorable Thief",
  "Windslasher",
  "Selfless Noble",
  "Ernesta, Weapons Hawker",
  "Pompous Summons",

  "0. Lhynkal, The Fool",
  "Runie, Resolute Diviner",
  "Imperator of Magic",
  "Checkmate",
  "Scourge of the Omniscient",
  "Juggling Moggy",
  "Gambit",
  "Rite of the Ignorant",
  "Piquant Potioneer",
  "Creative Conjurer",
  "Arcane Auteur",
  "Skewer",
  "Magical Augmentation",

  "XI. Erntz, Justice",
  "Aiela, Devoted Knight",
  "Slaughering Dragonewt",
  "Eternal Whale",
  "Dual Rage",
  "Swiftblade Dragonewt",
  "Heliodragon",
  "Dragon Impact",
  "Springwell Dragon Keeper",
  "Gallant Dragonewt",
  "Dragonclad Lancer",
  "Tropical Grouper",
  "Dragon Spawning",

  "VI. Milteo, The Lovers",
  "XIV. Luzen, Temperance",
  "Deathbringer",
  "Demonium, Clash Devil",
  "Sincere Soul",
  "Ghost Maid",
  "Insatiable Desire",
  "Unselfish Grace",
  "Moonrise Werewolf",
  "Spirit Curator",
  "Silverbolt Hunter",
  "Soul Box",
  "Colossal Grudge",

  "VIII. Sofina, Strength",
  "X. Slaus, Wheel of Fortune",
  "Reverend Adjudicator",
  "Tanzanite Convictor",
  "Somnolent Strength",
  "Topaz Swordian",
  "Puresong Priest",
  "Wheel of Misfortune",
  "Priestess of Foresight",
  "Azurite Maiden",
  "Prismaplume Bird",
  "Stalwart Featherfolk",
  "Holybright Altar",

  "XXI. Zelgenea, The World",
  "Starbright Deity",
  "Fieran, Havensent Wind God",
  "Fallen Shot",
  "One-Winged Traitor",
  "Mind Splitter",
  "Angelic Strike",
  "Pureshot Angel",
  "Corruption Guardian",
  "Winged Courier",
];

export const set9 = [
  "Yggdrasil",
  "White Vanara",
  "Paula, Icy Warmth",
  "Greenglen Axeman",
  "Wrath of Nature",
  "Storied Falconer",
  "Owl Man",
  "Blessings of Creation",
  "Grasshopper Conductor",
  "Elf General",
  "Lila, Arborist",
  "Substitution",
  "Flower of Fairies",

  "Celia, Sky Commander",
  "Spartacus",
  "Prim, Innocent Princess",
  "Nonja, Silent Maid",
  "Monochrome Duel",
  "Dario, Demon Count",
  "Queen Hemera the White",
  "Queen Magnus the Black",
  "Axe Princess",
  "Master Samurai",
  "Savage Swordsman",
  "Tycoon",
  "Frontline Ramparts",

  "Ceridwen, Eternity Hunter",
  "Faust, Truthseeker",
  "Anne, Mysterian Prodigy",
  "Grea, Mysterian Dragoness",
  "Mysterian Wyrmist",
  "Snowman King",
  "Owen, Knight of Mysteria",
  "Absolute Zeroblade",
  "Anne's Sorcery",
  "Grea's Ember",
  "Bergent, Onion Patchmaster",
  "Palla, Student Teacher",
  "Vayle, Mysterian Summoner",
  "Mysterian Knowledge",
  "Summoning Drills",
  "Witch of Foresight",
  "Beastfaced Mage",
  "Onion Patch",
  "Tico, Mysterian Spellnerd",
  "Mr. Bertrand, Magic Mentor",
  "Staff of Whirlwinds",

  "Jerva of Draconic Mail",
  "Zirnitra, Dragon's Flame",
  "Romelia, Lightning Striker",
  "Masamune, Raging Dragon",
  "Lindworm",
  "Dragonplate Warrior",
  "Poseidon",
  "Pure-Voiced Dragoon",
  "Force of the Dragonewt",
  "Waters of the Megalorca",
  "Roy, Dragoncleaver",
  "Galua of Two Breaths",
  "Katakura Kojuro",
  "Dragoon Scyther",
  "Gargouille",
  "Heroic Dragonslayer",
  "Dragonclad Blademaster",
  "Drakewing Assassin",
  "Coda, Twilight Dragoon",
  "Hypersonic Dragonewt",
  "Dragon's Handspur",

  "Vania, Nightshade Vampire",
  "Arcus, Spirited Manager",
  "Oldblood King",
  "Darkfeast Bat",
  "Gift for Bloodkin",
  "Big Soul Hunter",
  "Raven, Eventide Vampire",
  "Blood Moon",
  "Orator of the Bones",
  "Raven, Noontide Vampire",
  "Raven, Midnight Vampire",
  "Death the Nyctophile",
  "Poltergeist",

  "Jeanne, Beacon of Salvation",
  "Tutankhamun",
  "Ceryneian Hind",
  "Heavenly Knight",
  "Tenko's Shrine",
  "Jeweled Priestess",
  "Whitefang Temple",
  "Opposing Statues",
  "Lycaon",
  "Holy Fowl of Ivory",
  "Hexed Fowl of Ebon",
  "Deathscythe Nun",
  "Moriae Encomium",

  "Marduk",
  "Moon and Sun",
  "Paradise Vanguard",
  "Amaterasu",
  "Tsukuyomi",
  "Suttungr",
  "Oceanus",
  "Divine Retribution",
  "Valkyrie of Chaos",
  "Valkyrie of Order",
  "Fount of Angels",
];

export const set8 = [
  "Forest Oracle Pascale",
  "Orchis, Puppet Girl",
  "Zwei, Murderous Puppet",
  "Lycoris, Poisoner Princess",
  "Lina & Lena, Twin Souls",
  "Michelle, the Mind Reader",
  "Liam, Master of Puppets",
  "Heartless Battle",
  "Junk",
  "Insane Dark Elf",
  "Zealot of Unkilling",
  "Knower of History",
  "Ward of Unkilling",

  "Aether of the Warrior Wing",
  "Dionne, Dancing Blade",
  "Roland the Incorruptible",
  "Swordflash Panther",
  "Durandal the Incorruptible",
  "Azord, Duke of the Mists",
  "Madlance Centaur",
  "Dance of Usurpation",
  "Phantom Assassin",
  "Zealot of Usurpation",
  "Wardog",
  "Mana Pistol Merc",
  "Godsend Stride",

  "Sweet-Tooth Medusa",
  "Prophetless of Creation",
  "Unbodied Witch",
  "Lovely-Heart Monika",
  "Edict of Truth",
  "Elusa, Magic Wunderkind",
  "Morra, Monika's Familiar",
  "Veridic Discovery",
  "Moonshade Mage",
  "Zealot of Truth",
  "Rabbit Mage",
  "Zealot of Destruction",
  "Joy of Destruction",

  "Dragon Empress Otohime",
  "Azi Dahaka",
  "Annerose",
  "Ouroboros",
  "Powerforge",
  "Elios, Loyal Dragoon",
  "Dragonsoul Princess",
  "Vile Violet Dragon",
  "Zealot of Disdain",
  "Righteous Dragoon",
  "Geovore",
  "Draco Marionette",
  "Sneer of Disdain",

  "Crimson Rose Queen",
  "Nepthys",
  "Tartarus, the Tormentor",
  "Vuella, One-Winged Demon",
  "Sonata of Silence",
  "Chris Pumpkinhead",
  "Salome",
  "Kiss of Lust",
  "Arion",
  "Marian the Mummy",
  "Zealot of Silence",
  "Zealot of Lust",
  "Manifest Malice",

  "Holylord Eachtar",
  "Godsworn Alexiel",
  "Eidolon of Madness",
  "Sekhmet",
  "Vengeful Radiance",
  "Collete, Holy Gunner",
  "Battlefield Inquisitor",
  "Manifestation of Repose",
  "Malevolent Al-mi'raj",
  "Zealot of Repose",
  "Temple Windbear",
  "Angel of the Iron Steed",
  "Forgotten Sanctuary",

  "Alterplane Arbiter",
  "Sylvia, the Condemner",
  "Sahaquiel",
  "Tart Man",
  "Slash of the One",
  "Reina, Evolution's Herald",
  "Ephemera, Sword Angel",
  "Treasure Map",
  "Steelclad Minotaur",
  "High Enchantress",
  "Happy Pig",
];

export const set7 = [
  "Ladica, the Stoneclaw",
  "Cynthia, the Queen's Blade",
  "Primal Giant",
  "Setus, the Beastblade",
  "Send 'Em Packing",
  "Blossom Spirit",
  "Avatar of Fruition",
  "Divine Smithing",
  "Chesire Cat",
  "Ghastly Treant",
  "Forest Hermit",
  "Marvelously Mad Hatter",
  "Fertile Aether",

  "Bayleon, Sovereign Light",
  "Mistolina, Forest Princess",
  "Tsubaki of the Demon Blade",
  "Leod, the Crescent Blade",
  "King's Might",
  "Troya, Thunder of Hagelberg",
  "Valse, Champion Deadeye",
  "Princess's Strike",
  "Swift Tigress",
  "Lupine Axeman",
  "Dauntless Commander",
  "Tempered Aether",
  "Elegance in Action",

  "Tetra, Sapphire Rebel",
  "Belphomet, Lord of Aiolon",
  "Riley, Hydroshaman",
  "Eleanor, Cosmic Flower",
  "Delta Cannon",
  "Displacer Bot",
  "Mechanized Lifeform",
  "Splendid Conjury",
  "Mechastaff Sorcerer",
  "Prototype Warrior",
  "Magiblade Witch",
  "Presto Chango",
  "Sagacious Core",

  "Valdain, Cursed Shadow",
  "Neptune, Tidemistress",
  "Wildfire Tyrannosaur",
  "Marion, Elegant Dragonewt",
  "Shadow's Corrosion",
  "Bubbleborne Mermaid",
  "Hoarfrost Triceratops",
  "Whirlwind Pteranodon",
  "Dragonewt Needler",
  "Lightning Velociraptor",
  "Doting Dragoneer",
  "Boomfish",
  "Feral Aether",

  "Mono, Garnet Rebel",
  "Kudlak",
  "Aenea, Amethyst Rebel",
  "Doublame, Duke and Dame",
  "Alpha Drive",
  "Nicola, Forbidden Strength",
  "Hellblaze Demon",
  "Forbidden Art",
  "Robozombie",
  "Bone Drone",
  "Berserk Demon",
  "Ghostwriter",
  "Sanguine Core",

  "Limonia, Flawed Saint",
  "Lapis, Glorious Seraph",
  "Father Refinement",
  "Marione, Light of Balance",
  "Augmentation Bestowal",
  "Bunny-Eared Administrator",
  "Robofalcon",
  "Marcotte, Heretical Sister",
  "Ironknuckle Nun",
  "Dark Bishop",
  "Meowskers, Ruff-Tuff Major",
  "Saintly Core",
  "Meowskers Ambush!",

  "Technolord",
  "Viridia Magna",
  "Mechawing Angel",
  "Desert Pathfinder",
  "Maisha, Hero of Purgation",
  "Robogoblin",
  "Colorful Cook",
  "Purgation's Blade",
  "Aldis, Trendsetting Seraph",
  "Mechagun Wielder",
  "Extreme Carrot",
];

export const setIDOL = [
  "Uzuki Shimamura [P.C.S.]",
  "Kyoko Igarashi [P.C.S.]",
  "Miho Kohinata [P.C.S.]",
  "Chika Yokoyama",
  "Momoka Sakurai",
  "Akiha Ikebukuro",
  "Nene Kurihara",
  "Karin Domyoji",

  "Rin Shibuya [Triad Primus]",
  "Nao Kamiya [Over the Rainbow]",
  "Karen Hojo [Song for Life]",
  "Yasuha Okazaki",
  "Yukimi Sajo",
  "Kako Takafuji",
  "Chizuru Matsuo",
  "Seira Mizuki",

  "Mio Honda [Positive Passion]",
  "Aiko Takamori [Handmade Hapiness]",
  "Akane Hino [Positive Passion]",
  "Kaoru Ryuzaki",
  "Suzuho Ueda",
  "Miria Akagi",
  "Miu Yaguchi",
  "Kumiko Matsuyama",

  "Aiko Takamori",
  "Miku Maekawa",
  "Yuzu Kitami",
  "Anastasia",
  "Brand New Beat",
  "Shinobu Kudo",
  "Yumi Aiba",
  "Goddess by the Sunlit Sea",
  "Honoka Ayase",
  "Azuki Momoi",
  "Kana Imai",
  "Otaha Umeki",
  "A Single Vessel",

  "Kyoko Igarashi",
  "Nagi Hisakawa",
  "Rin Shibuya",
  "Mio Honda",
  "Uzuki Shimamura",
  "Anzu Futaba",
  "Karen Hojo",
  "Sparkling Days",
  "Nao Kamiya",
  "Mayu Sakuma",
  "Kirari Moroboshi",
  "Miho Kohinata",
  "Angelic Maid",

  "Mizuki Kawashima",
  "Shiki Ichinose",
  "Syuko Shiomi",
  "Kanade Hayami",
  "Center Street",
  "Hina Araki",
  "Frederica Miyamoto",
  "Precocious Little Devil",
  "Sarina Matsumoto",
  "Rika Jougasaki",
  "Sae Kobayakawa",
  "Tomoe Murakami",
  "Full Bloom Panorama",

  "Akari Tsujino",
  "Yui Ohtsuki",
  "Fumika Sagisawa",
  "Akira Sunazuka",
  "Tsukasa Kiryu",
  "Arisu Tachibana",
  "Yuka Nakano",
  "Unbound Emotion",
  "Tokiko Zaizen",
  "Noriko Shiina",
  "Yukari Mizumoto",
  "Noa Takamine",
  "Mode Estivale",

  "Ranko Kanzaki",
  "Sachiko Koshimizu",
  "Takumi Mukai",
  "Chitose Kurosaki",
  "Whispers of a Dream",
  "Chiyo Shirayuki",
  "Aki Yamato",
  "My Life, My Sounds",
  "Ryo Matsunaga",
  "Mirei Hayasaka",
  "Rina Fujimoto",
  "Syoko Hoshi",
  "Last Daylight",

  "Kaede Takagaki",
  "Shin Sato",
  "Nana Abe",
  "Akane Hino",
  "Classroom Lily",
  "Risa Matoba",
  "Haru Yuuki",
  "Psychic Maiden",
  "Natalia",
  "Shizuku Oikawa",
  "Layla",
  "Sanae Katagiri",
  "Winter Night Prayer",

  "New Generations",
  "New Wave",
  "Master Trainer",
  "Expert Trainer",
  "Trainer",
  "Rookie Trainer",
];

export const set6 = [
  "Lymaga, Forest Champion",
  "Amataz, Fairy Blader",
  "Greenbrier Elf",
  "Wildwood Matriarch",
  "Fairy Dragon",
  "Woodland Cleaver",
  "Assault Jaguar",
  "Spiritshine",
  "Greenwood Guardian",
  "Crossbow Sniper",
  "Mallet Monkey",
  "Elven Sentry",
  "Synchronized Slash",
  "Kagemitsu, Matchless Blade",
  "Ralmia, Sonic Racer",
  "Steadfast Samurai",
  "Hero of Antiquity",
  "Courtly Dance",
  "Quickdraw Maven",
  "Twinsword Master",
  "Grand Acquisition",
  "Samurai Outlaw",
  "Adept Thief",
  "Petalwink Paladin",
  "Levin Scholar",
  "Breakneck Draw",
  "Kuon, Founder of Onmyodo",
  "Mysteria, Magic Founder",
  "Curse Crafter",
  "Hulking Giant",
  "Shikigami Summons",
  "Demoncaller",
  "Traditional Sorcerer",
  "Crimson Meteor Storm",
  "Talisman Disciple",
  "Charming Gentlemouse",
  "Passionate Potioneer",
  "Golem's Rampage",
  "Mirror of Truth",
  "Garyu, Surpreme Dragonkin",
  "Filene, Whitefrost Dragonewt",
  "Phoenix Empress",
  "Wyrm God of the Skies",
  "Whitefrost Whisper",
  "Ice Dancing Dragonewt",
  "Jadelong Tactician",
  "Aquascale Stalwart",
  "Swordwhip Dragoon",
  "Dragonblader",
  "Trident Merman",
  "Dragon Chef",
  "Flamewinged Might",
  "Ginsetsu, Great Fox",
  "Aragavy the Berserker",
  "Shuten-Doji",
  "Bear Pelt Warrior",
  "Yuzuki, Righteous Demon",
  "Kasha",
  "Cougar Pelt Warrior",
  "Unleash the Nightmare",
  "Zashiki-Warashi",
  "Antelope Pelt Warrior",
  "Rookie Succubus",
  "Demonic Procession",
  "Berserker's Pelt",
  "Wilbert, Grand Knight",
  "Karula, Arts Master",
  "Saintly Leader",
  "Phantom Blade Wielder",
  "Manifest Devotion",
  "Holy Lancer",
  "Boost Kicker",
  "Feather Sanctuary",
  "Winged Staff Priestess",
  "Gravity Grappler",
  "Barrage Brawler",
  "Holy Counterattack",
  "Focus",
  "Mammoth God's Colosseum",
  "Badb Catha",
  "Mithra, Daybreak Diety",
  "Fall from Grace",
  "Colosseum on High",
  "Chaht, Ringside Announcer",
  "Clash of Heroes",
  "Biofrabrication",
  "Sweet-Tooth Sleuth",
  "Bazooka Goblins",
  "Sentry Gate",
];

export const set5 = [
  "Izudia, Omen of Unkilling",
  "Spinaria, Keeper of Enigmas",
  "Apostle of Unkilling",
  "Morton the Manipulator",
  "Fairy Torrent",
  "Disciple of Unkilling",
  "Noah, Vengeful Puppeteer",
  "Mark of the Unkilling",
  "Servant of Unkilling",
  "Mechanical Bowman",
  "Flower Doll",
  "Automaton Soldier",
  "Mark of the Six",

  "Octrice, Omen of Usurpation",
  "Magna Legacy",
  "Apostle of Usurpation",
  "Empyreal Swordsman",
  "Confront Adversity",
  "Disciple of Usurpation",
  "Fervent Maachine Soldier",
  "Geno, Machine Artisan",
  "Servant of Usurpation",
  "Captain Meteo",
  "Gravikinetic Warrior",
  "Usurping Spineblade",
  "Avaritia",

  "Raio, Omen of Truth",
  "Lishenna, Omen of Destruction",
  "Apostle of Truth",
  "Safira, Synthetic Beast",
  "Destructive Refrain",
  "Iron Staff Mechanic",
  "Truth's Adjudication",
  "Monochromatic Destruction",
  "Disciple of Truth",
  "Disciple of Destruction",
  "Servant of Destruction",
  "Honest Cohort",
  "Metaproduction",

  "Galmieux, Omen of Disdain",
  "Electromagical Rhino",
  "Apostle of Disdain",
  "God Bullet Golem",
  "Disdainful Rending",
  "Disciple of Disdain",
  "Cursed Stone",
  "Amethyst Giant",
  "Servant of Disdain",
  "Silver Automaton",
  "Airship Whale",
  "Colossal Construct",
  "Total Domination",

  "Valnareik, Omen of Lust",
  "Rulenye, Omen of Silence",
  "Apostle of Lust",
  "Apostle of Silence",
  "Disciple of Lust",
  "Masked Puppet",
  "Wings of Lust",
  "Silent Purge",
  "Servant of Lust",
  "Servant of Silence",
  "Hamelin",
  "Embracing Wings",
  "Thundering Roar",

  "Marwynn, Omen of Repose",
  "Deus Ex Machina",
  "Apostle of Repose",
  "Hakrabi",
  "Ancient Protector",
  "Disciple of Repose",
  "Unidentified Subject",
  "Silver Cog Spinner",
  "Servant of Repose",
  "Demon's Epitaph",
  "The Saviors",
  "Realm of Repose",
  "Ancient Amplifier",

  "Mjerrabaine, Omen of One",
  "Gilnelise, Omen of Craving",
  "Apostle of Craving",
  "Lyrial, Archer Throne",
  "Feena, Dynamite Daredevil",
  "Rosa, Mech Wing Maiden",
  "Enlightenment",
  "Craving's Splendor",
  "Cat Cannoneer",
  "Steel Demolitionist",
  "Gliesaray",
];

export const set4 = [
  "Cassiopeia",
  "C.C., Woodland Witch",
  "Deepwood Anomaly",
  "King Elephant",
  "Fashionista Nelcha",
  "Spring-Green Protection",
  "Inviolable Verdancy",
  "Sukuna, Brave and Small",
  "Dolorblade Demon",
  "Elf Song",
  "Starry Elf",
  "Fita the Gentle Elf",
  "Dryad",
  "Beetle Warrior",
  "Ivy Spellbomb",

  "Mars, Silent Flame General",
  "Gawain of the Round Table",
  "Barbarossa",
  "Perseus",
  "Cyclone Blade",
  "Chivalrous Charge",
  "Shrouded Assassin",
  "Lord General Romeo",
  "Round Table Assembly",
  "Princess Juliet",
  "Flail Knight",
  "Pollux",
  "Tristan of the Round Table",
  "Armor of the Stars",

  "Wordwielder Ginger",
  "Giant Chimera",
  "Star Reader Stella",
  "Europa",
  "Chain of Calling",
  "Noble Instruction",
  "Freshman Lou",
  "Magic Illusionist",
  "Concentration",
  "Show of Loyalty",
  "Dazzling Healer",
  "Mage of Nightfall",
  "Astrologist of the Mist",
  "Magic Owl",
  "Starseer's Telescope",

  "Sibyl of the Waterwyrm",
  "Kallen, Crimson Yaksha",
  "Python",
  "Prime Dragon Keeper",
  "Star Phoenix",
  "Lightning Blast",
  "Guren Revolt",
  "Venomous Pucewyrm",
  "Cetus",
  "Dragonewt Fist",
  "Divine Tiger",
  "Dragonrearer Matilda",
  "Aqua Nerid",
  "Hippocampus",
  "Scaled Berserker",
  "Dragon's Nest",

  "Venomfang Medusa",
  "Howling Demon",
  "Demonlord Eachtar",
  "Lelouch, Leader of the Black Knights",
  "Stheno",
  "Trial of the Gorgons",
  "Fenrir",
  "Euryale",
  "Grave Desecration",
  "Emperor's Command",
  "Demonic Drummer",
  "Castor",
  "Frogbat",
  "Scorpius",
  "Venomous Bite",

  "Aether of the White Wing",
  "Dark Jeanne",
  "Zoe, Princess of Goldenia",
  "Andromeda",
  "Globe of the Starways",
  "Dark Charisma",
  "Star Priestess",
  "Calydonian Boar",
  "Star Torrent",
  "Starchaser Sprite",
  "Sister of Punishment",
  "Mist Shaman",
  "Octobishop",
  "Candelabra of Prayers",

  "Zodiac Demon",
  "Israfil",
  "Grimnir, War Cyclone",
  "Arriet, Soothing Harpist",
  "Staircase to Paradise",
  "Purehearted Singer",
  "Goblin Princess",
  "Mystic Ring",
  "Owlcat",
  "Mr. Full Moon",
  "Night's Way",
];

export const set3 = [
  "Beauty and the Beast",
  "Cosmos Fang",
  "Magical Fairy, Lilac",
  "Slade Blossoming Wolf",
  "Elf Twins' Assault",
  "Abby the Axe Girl",
  "Gerbera Bear",
  "Wood of Brambles",
  "Flower Princess",
  "Fen Sprite",
  "Tweedle Dum, Tweedle Dee",
  "Floral Breeze",
  "Woodland Band",
  "Cinderella",
  "Valiant Fencer",
  "Maisy, Red Riding Hood",
  "Amerro, Spear Knight",
  "Castle in the Sky",
  "Young Ogrehunter Momo",
  "Mach Knight",
  "Kiss of the Princess",
  "Rabbit Ear Attendant",
  "Old Man and Old Woman",
  "Bladed Hedgehog",
  "Ironwrought Defender",
  "Heroic Entry",
  "Wizardess of Oz",
  "Witch of Calamity, Millie Parfait",
  "Mystic King",
  "Falise, Leonardian Mage",
  "Milady, Mystic Queen",
  "Check",
  "Mr. Heinlein, Shadow Mage",
  "Magical Knight",
  "Gingerbread House",
  "It's a Sweets Buffet!",
  "Witch of Sweets",
  "Magical Rook",
  "Magical Bishop",
  "Blitz",
  "Witch's Cauldron",
  "The Cauldron of Calamity",
  "Jabberwock U",
  "Lævateinn Dragon",
  "Red Ragewyrm",
  "Draconir, Knuckle Dragon",
  "Tilting at Windmills",
  "Master of Draconic Arts",
  "Hammer Dragonewt",
  "Draconic Smash",
  "Elder Tortoise",
  "Trinity Dragon",
  "Dragon Summoner",
  "Lance Lizard",
  "Armor Burst",
  "Dark Alice",
  "Masquerade Ghost",
  "Odile, Black Swan",
  "Demonium, Punk Devil",
  "Baccherus, Peppy Ghostie",
  "Demon Maestro",
  "Trombone Devil",
  "Furtive Fangs",
  "Pumpkin Necromancer",
  "Parade Raven",
  "Mischievous Zombie",
  "Devilish Flautist",
  "Infernal Orchestration",
  "Princess Snow White",
  "Diamond Master",
  "Odette, White Swan",
  "Wingy Chirpy Gemstone",
  "Alice's Adventure",
  "White Knight",
  "Ruby Falcon",
  "March Hare's Teatime",
  "Tin Soldier",
  "Pinion Prince",
  "Birdkeeping Disciple",
  "Amethyst Lion",
  "Bejeweled Shrine",
  "Alice, Wonderland Explorer",
  "Angel of Chaos",
  "Rapunzel",
  "Seraph of Sin",
  "Garuel, Seraphic Leo",
  "Actress Feria",
  "Humpty Dumpty",
  "Winged Inversion",
  "Angel of Darkness",
  "Harbringer of the Night",
  "Eggsplosion",
];

export const setUMA = [
  "Tazuna Hayakawa [Traccen Reception]",
  "Riko Kashimoto",
  "Aoi Kiryuin",
  "Silence Suzuka",
  "Smart Falcon",
  "Gold City",
  "Eat Fast! Yum Fast!",
  "Shinko Windy",
  "Eishin Flash",
  "Systematic Squats",
  "Marvelous Sunday",
  "Yukino Bijin",
  "Ines Fujin",
  "Taiki Shuttle",
  "Haru Urara",
  "Tokai Teio",
  "Narita Brian",
  "Winning Ticket",
  "Outrunning the Encroaching Heat",
  "Air Groove",
  "Hishi Amazon",
  "Trial Initiation",
  "Sirius Symboli",
  "Narita Taishin",
  "Symboli Rudolf",
  "Biko Pegasus",
  "Fuji Kiseki",
  "Agnes Tachyon",
  "Daiwa Scarlet",
  "Vodka",
  "Make! Some! NOISE!",
  "Zenno Rob Roy",
  "Agens Digital",
  "Lamplit Training of a Witch-to-Be",
  "Admire Vega",
  "Kawakami Princess",
  "Nakayama Festa",
  "Tosen Jordan",
  "Narita Top Road",
  "Special Week",
  "Oguri Cap",
  "Seiun Sky",
  "Champion's Passion",
  "King Halo",
  "Tamamo Cross",
  "Flowers for You",
  "Bamboo Memory",
  "Yaeno Muteki",
  "Grass Wonder",
  "Super Creek",
  "Hishi Akebono",
  "Maruzensky",
  "Rice Shower",
  "Nice Nature",
  "7 More Centimeters",
  "Fine Motion",
  "Mayano Top Gun",
  "My Solo Drawn to Raindrop Drums",
  "Curren Chan",
  "Twin Turbo",
  "Sakura Chiyono O",
  "Seeking the Pearl",
  "Matikanetannhauser",
  "Mejiro McQueen",
  "Gold Ship",
  "Ikuno Dictus",
  "The Will to Overtake",
  "Meisho Doto",
  "Mejiro Ryan",
  "Fate's Forecast",
  "Inari One",
  "Mejiro Dober",
  "Mejiro Ardan",
  "Mejiro Palmer",
  "T.M Opera O",
  "Riko Kashimoto [Planned Perfection]",
  "Close Knit Ambitions",
  "Take a Jab!",
  "Aoi Kiryuin [Trainers' Teamwork]",
  "Sasami Anshinzawa",
  "Tazuna Hayakawa",
];

export const set2 = [
  "Crystalia Tia",
  "White Wolf of Eldwood",
  "Elf Girl Liza",
  "Elf Knight Cynthia",
  "Grand Archer Seiwyn",
  "Crystalia Lily",
  "Baalt King of the Elves",
  "Elven Archery",
  "Dwarf Perfumer",
  "Elf Healer",
  "Forest Gigas",
  "Elf Bard",
  "Rose Deer",
  "Albert Levin Saber",
  "Alexander",
  "Amelia, Silver Paladin",
  "Leonidas",
  "White Paladin",
  "Jeno, Levin Vanguard",
  "Yurius, Levin Duke",
  "Whole-Souled Swing",
  "Swift Infiltrator",
  "Samurai",
  "Avant Blader",
  "Flame Soldier",
  "Gunner Maid Seria",
  "Daria Dimensional Witch",
  "Sun Oracle Pascale",
  "Anne, Belle of Mysteria",
  "Grea the Dragonborn",
  "Rimewind",
  "Remi & Rami, Witchy Duo",
  "Shadow Witch",
  "Multipart Expirement",
  "Craig, Wizard of Mysteria",
  "Grand Gargoyle",
  "Witchbolt",
  "Magical Strategy",
  "Red-Hot Ritual",
  "Imperial Dragoon",
  "Dragonsong Flute",
  "Neptune",
  "Draconic Fervor",
  "Polyphonic Roar",
  "Siegfried",
  "Transmogrified Wyrm",
  "Dracomancer's Rites",
  "Wildfang Dragonewt",
  "Mushussu",
  "Dragontamer",
  "Twin-Headed Dragon",
  "Draconic Armor",
  "Vania, Vampire Princess",
  "Soul Dealer",
  "Underworld Watchman Khawy",
  "Azazel",
  "Vampiric Fortress",
  "Veight, Vampire Noble",
  "Trick Dullahan",
  "Precious Bloodfangs",
  "Mini Soul Devil",
  "Moriana the Bejeweled",
  "Demonic Hedonist",
  "Bone Chimera",
  "Necrocarnival",
  "Heavenly Aegis",
  "Enstatued Seraph",
  "Kaguya",
  "Tribunal of Good and Evil",
  "Elana's Prayer",
  "Radiance Angel",
  "Saphire Priestess",
  "Beastcall Aria",
  "Frog Cleric",
  "Sky Sprite",
  "Soul Collector",
  "Sledgehammer Exorcist",
  "Emerald Maiden",
  "Dark Angel Olivia",
  "Bahamut",
  "Demonic Simulacrum",
  "Archangel Reina",
  "Surefire Bullet",
  "Unicorn Dancer Unicorn",
  "Gourmet Emperor Khaiza",
  "Call of Cocytus",
  "Hamsa",
  "Sektor",
  "Dance of Death",
];

export const set1 = [
  "Skullfane",
  "Hare of Illusions",
  "Priest of the Cudgel",
  "Acolyte's Light",
  "Dual Flames",
  "Ardent Nun",
  "Guardian Nun",
  "Pinion Prayer",
  "Beastly Vow",
  "Queen Vampire",
  "Alucard",
  "Playful Necromancer",
  "Midnight Vampire",
  "Night Horde",
  "Lesser Mummy",
  "Lilith",
  "Undying Resentment",
  "Summon Bloodkin",
  "Fafnir",
  "Dragon Oracle",
  "Dragon Warrior",
  "Dragonewt Princess",
  "Dragonguard",
  "Roc",
  "Glint Dragon",
  "Dragonrider",
  "Seabrand Dragon",
  "Mythril Golem",
  "Rune Blade Summoner",
  "Demonflame Mage",
  "Insight",
  "Fire Chain",
  "Penguin Wizard",
  "Sammy Wizard's Apprentice",
  "Magic Missle",
  "Conjure Golem",
  "Tsubasa",
  "Latham, Vanguard Captain",
  "Floral Fencer",
  "Moonlight Assassin",
  "White General",
  "Fencer",
  "Oathless Knight",
  "Quickblader",
  "Unbridled Fury",
  "Aria, Fairy Princess",
  "Titania's Sanctuary",
  "Rose Gardener",
  "Waltzing Fairy",
  "Fairy Caster",
  "Treant",
  "Water Fairy",
  "Elf Wanderer",
  "Sylvan Justice",
  "Rose Queen",
  "Ancient Elf",
  "Rhinoceroach",
  "Robin Hood",
  "Silver Bolt",
  "Homecoming",
  "Elven Princess Mage",
  "Blessed Fairy Dancer",
  "Elf Child May",
  "Fairy Beast",
  "Noble Fairy",
  "Nature's Guidance",
  "Harvest Festival",
  "Elf Metallurgist",
  "Archer",
  "Fairy Whisperer",
  "Okami",
  "Mana Elk",
  "Fairy Circle",
  "Woodkin Curse",
  "Woodland Refuge",
  "Sea Queen Otohime",
  "Aurelia, Regal Saber",
  "Shadowed Assassin",
  "Frontguard General",
  "Alwida's Command",
  "Royal Banner",
  "Maid Leader",
  "Gemstaff Commander",
  "Sage Commander",
  "Swordsman",
  "Pompous Princess",
  "Ninja Master",
  "Arthurian Light",
  "Ninja Trainee",
  "Fervid Soldier",
  "Luminous Knight",
  "Veteran Lancer",
  "Navy Lieutenant",
  "Novice Trooper",
  "Forge Weaponry",
  "Onslaught",
  "Arch Summoner Erasmus",
  "Merlin",
  "Ancient Alchemist",
  "Arcane Enlightenment",
  "Dimension Shift",
  "Juno's Secret Laboratory",
  "Spectral Wizard",
  "Flame Destroyer",
  "Dragonbond Mage",
  "Golem Protection",
  "Alchemical Lore",
  "Fate's Hand",
  "Price of Magic",
  "Runic Guardian",
  "Crafty Warlock",
  "Lightning Shooter",
  "Wind Blast",
  "Sorcery Cache",
  "Fiery Embrace",
  "Alchemist's Workshop",
  "Teachings of Creation",
  "Dark Dragoon Forte",
  "Zirnitra",
  "Aiela, Dragon Knight",
  "Genesis Dragon",
  "Shapeshifting Mage",
  "Phoenix Roost",
  "Wyvern Cavalier",
  "Dragonewt Scholar",
  "Shenlong",
  "Imprisoned Dragon",
  "Conflagration",
  "Serpent's Wrath",
  "Wyrm Spire",
  "Ivory Dragon",
  "Fire Lizard",
  "Ace Dragoon",
  "Mist Dragon",
  "Dread Dragon",
  "Blazing Breath",
  "Dragon Wings",
  "Dragon Emissary",
  "Cerberus",
  "Lord Atomy",
  "Medusa",
  "Righteous Devil",
  "Mordecai the Duelist",
  "Dire Bond",
  "Hell's Unleasher",
  "Crazed Executioner",
  "Dark Summoner",
  "Dark General",
  "Phantom Howl",
  "Death's Breath",
  "Soul Conversion",
  "Skeleton Fighter",
  "Ambling Wraith",
  "Spectre",
  "Spartoi Sergeant",
  "Rabbit Necromancer",
  "Wardrobe Raider",
  "Undead King",
  "Razory Claw",
  "Moon Al-mi'raj",
  "Jeanne d'Arc",
  "Arch Priestess Laelia",
  "Themis's Decree",
  "Chorus of Prayer",
  "Sacred Plea",
  "Temple Defender",
  "Prism Priestess",
  "Cleric Lancer",
  "Shrine Knight Maiden",
  "Blackened Scripture",
  "Dark Offering",
  "Holy Sentinel",
  "Cruel Priestess",
  "Sister Initiate",
  "Mainyu",
  "Snake Priestess",
  "Curate",
  "Hallowed Dogma",
  "Guardian Sun",
  "Death Sentence",
  "Gabriel",
  "Lucifer",
  "Flame and Glass",
  "Urd",
  "Wind God",
  "Gilgamesh",
  "Bellringer Angel",
  "Altered Fate",
  "Path to Purgatory",
  "Lizardman",
  "Goblinmount Demon",
  "Harnessed Flame",
  "Harnessed Glass",
  "Demonic Strike",
  "Execution",
  "Trail of Light",
  "Goblin",
  "Fighter",
  "Goliath",
  "Angelic Sword Maiden",
  "Healing Angel",
  "Angelic Snipe",
  "Angelic Barrage",
];

export const forest = [
  "* (Asterisk)",
  "Aiko Takamori [Handmade Happiness]",
  "Cheshire Cat",
  "Grand Archer Selwyn",
  "Minami Nitta [Water's Edge Bride]",
  "Otoha Umeki",
  "Yuki Himekawa [Full Swing☆Cheer]",
  "Aria, Lady of the Woods",
  "Orchis, Newfound Heart",
  "Nazuri, Bestial Innkeeper",
  "Glade, Fragrantwood Ward",
  "Lily, Crystalian Innocence",
  "Liam, Crazed Creator",
  "Aerin, Crystalian Frostward",
  "Bayle, Luxglaive Warrior",
  "Godwood Staff",
  "Fairy Tamer",
  "Good Fairy of the Pond",
  "Fay Twinkletoes",
  "Baby Carbuncle",
  "Fragrantwood Whispers",

  "Izudia, Unkilling Annihilation",
  "Amataz, Reverse Blader",
  "Piercye, Queen of Frost",
  "Inauspicious Puppeteer",
  "Erosive Annihilation",
  "Rejuvenating Resurrection",
  "Cryptid Keeper",
  "Adherent of Annihilation",
  "Fairy Healer",
  "Hermit of Unkilling",
  "Horned Beastie",
  "Bouquet Fairy",
  "Emerald Wildfox",
  "Wind Fairy",

  "Hozumi, Enchanting Hostess",
  "Levon, Scentbound Sword",
  "Bastion of Seasons",
  "Spirit of the Spring",
  "Illusions of Comfort",
  "Elven Waitress",
  "Tinkering Shopkeeper",
  "Craftsman's Pride",
  "Karakuri Servant",
  "Fairylight Guide",
  "Woodland Pest Control",
  "Windswept Lancer",
  "Elven Craftsmanship",

  "Hokko Tarumae",
  "Sakura Laurel",
  "Sounds of Earth",
  "Haru Urara [Sunny Passion ♪]",
  "Yamanin Zephyr",
  "Sakura Bakushin O",
  "Mihono Bourbon",
  "A MORE MARVELOUS WORLD! ☆",

  "Sekka, Fatebound Fox",
  "Aria, Miasma Fairy",
  "Nelcha, Fashion Hazard",
  "Spinaria, Keeper of the End",
  "Resolve of the Nine-Tailed Fox",
  "Sunbright Elf",
  "Wildwood Warrior",
  "Tree of Wonders",
  "Fairy Slugger",
  "Edgy Elf",
  "Gazania Fox",
  "Tower Root Giant",
  "Feybolt Archer",
  "Awakened Gaia",
  "Elf Queen of Abundant Life",
  "Carbuncle, Immortal Jewel",
  "Irene, Harvest Defender",
  "Intertwined Resolve",
  "Forest Defender",
  "Windfall Fay",
  "Aria's Whirlwind",
  "Forest Hatcheteer",
  "Springleaf Sprite",
  "Elven Pikeman",
  "Fairy Officer",
  "Fairy Menhir",

  "Spinaria, Waveing Will",

  "Loxis, Homestead Pioneer",
  "Shamu & Shama, Posh Felines",
  "Terrorformer",
  "Giant Pastures",
  "Fairy Flowering",
  "Varmint Hunter",
  "Stringmaster",
  "Corrosive Thorns",
  "Lookout Elf",
  "Cactus Cowboy",
  "Nature's Warden",
  "Hornet Strike",
  "Scavenge",

  "Blue Storm Dragon, Maelstrom",
  "Storm Rider, Diamantes",
  "Storm Rider, Basil",
  "Marine General of the Restless Tides, Algos",
  "Hydro Hurricane Dragon",
  "Water General of Wave-Like Spirals, Benedict",
  "Tear Knight, Valeria",
  "Tear Knight, Lazarus",
  "Tear Knight, Theo",
  "Light Signals Penguin Soldier",
  "Tear Knight, Cyprus",
  "Emerald Shield, Paschal",
  "Battleship Intelligence",
  "Pyroxene Communications Sea Otter Soldier",
  "Dolphin Soldier of High Speed Raids",
  "Medical Officer of the Rainbow Elixir",
  "Coral Assault",
  "Battle Siren, Cynthia",
  "Officer Cadet, Erikk",

  "XII. Wolfraud, The Hanged Man",
  "Lucille, Keeper of Relics",
  "Chipper Skipper",
  "Windflower Tiger",
  "Treacherous Reversal",
  "Salvia Panther",
  "Optimistic Beastmaster",
  "Lumbering Carapace",
  "Reclusive Ponderer",
  "Crocus Rat",
  "Blossoming Archer",
  "Deepwood Wolf",
  "Fairy Assault",

  "Yggdrasil",
  "White Vanara",
  "Paula, Icy Warmth",
  "Greenglen Axeman",
  "Wrath of Nature",
  "Storied Falconer",
  "Owl Man",
  "Blessings of Creation",
  "Grasshopper Conductor",
  "Elf General",
  "Lila, Arborist",
  "Substitution",
  "Flower of Fairies",

  "Forest Oracle Pascale",
  "Orchis, Puppet Girl",
  "Zwei, Murderous Puppet",
  "Lycoris, Poisoner Princess",
  "Lina & Lena, Twin Souls",
  "Michelle, the Mind Reader",
  "Liam, Master of Puppets",
  "Heartless Battle",
  "Junk",
  "Insane Dark Elf",
  "Zealot of Unkilling",
  "Knower of History",
  "Ward of Unkilling",

  "Ladica, the Stoneclaw",
  "Cynthia, the Queen's Blade",
  "Primal Giant",
  "Setus, the Beastblade",
  "Send 'Em Packing",
  "Blossom Spirit",
  "Avatar of Fruition",
  "Divine Smithing",
  "Chesire Cat",
  "Ghastly Treant",
  "Forest Hermit",
  "Marvelously Mad Hatter",
  "Fertile Aether",

  "Momoka Sakurai",
  "Aiko Takamori [Handmade Hapiness]",
  "Suzuho Ueda",
  "Aiko Takamori",
  "Miku Maekawa",
  "Yuzu Kitami",
  "Anastasia",
  "Brand New Beat",
  "Shinobu Kudo",
  "Yumi Aiba",
  "Goddess by the Sunlit Sea",
  "Honoka Ayase",
  "Azuki Momoi",
  "Kana Imai",
  "Otaha Umeki",
  "A Single Vessel",

  "Lymaga, Forest Champion",
  "Amataz, Fairy Blader",
  "Greenbrier Elf",
  "Wildwood Matriarch",
  "Fairy Dragon",
  "Woodland Cleaver",
  "Assault Jaguar",
  "Spiritshine",
  "Greenwood Guardian",
  "Crossbow Sniper",
  "Mallet Monkey",
  "Elven Sentry",
  "Synchronized Slash",

  "Izudia, Omen of Unkilling",
  "Spinaria, Keeper of Enigmas",
  "Apostle of Unkilling",
  "Morton the Manipulator",
  "Fairy Torrent",
  "Disciple of Unkilling",
  "Noah, Vengeful Puppeteer",
  "Mark of the Unkilling",
  "Servant of Unkilling",
  "Mechanical Bowman",
  "Flower Doll",
  "Automaton Soldier",
  "Mark of the Six",

  "Cassiopeia",
  "C.C., Woodland Witch",
  "Deepwood Anomaly",
  "King Elephant",
  "Fashionista Nelcha",
  "Spring-Green Protection",
  "Inviolable Verdancy",
  "Sukuna, Brave and Small",
  "Dolorblade Demon",
  "Elf Song",
  "Starry Elf",
  "Fita the Gentle Elf",
  "Dryad",
  "Beetle Warrior",
  "Ivy Spellbomb",
  "Beauty and the Beast",
  "Cosmos Fang",
  "Magical Fairy, Lilac",
  "Slade Blossoming Wolf",
  "Elf Twins' Assault",
  "Abby the Axe Girl",
  "Gerbera Bear",
  "Wood of Brambles",
  "Flower Princess",
  "Fen Sprite",
  "Tweedle Dum, Tweedle Dee",
  "Floral Breeze",
  "Woodland Band",
  "Silence Suzuka",
  "Smart Falcon",
  "Gold City",
  "Eat Fast! Yum Fast!",
  "Shinko Windy",
  "Eishin Flash",
  "Systematic Squats",
  "Marvelous Sunday",
  "Yukino Bijin",
  "Ines Fujin",
  "Taiki Shuttle",
  "Haru Urara",
  "Crystalia Tia",
  "White Wolf of Eldwood",
  "Elf Girl Liza",
  "Elf Knight Cynthia",
  "Grand Archer Seiwyn",
  "Crystalia Lily",
  "Baalt King of the Elves",
  "Elven Archery",
  "Dwarf Perfumer",
  "Elf Healer",
  "Forest Gigas",
  "Elf Bard",
  "Rose Deer",
  "Aria, Fairy Princess",
  "Titania's Sanctuary",
  "Rose Gardener",
  "Waltzing Fairy",
  "Fairy Caster",
  "Treant",
  "Water Fairy",
  "Elf Wanderer",
  "Sylvan Justice",
  "Rose Queen",
  "Ancient Elf",
  "Rhinoceroach",
  "Robin Hood",
  "Silver Bolt",
  "Homecoming",
  "Elven Princess Mage",
  "Blessed Fairy Dancer",
  "Elf Child May",
  "Fairy Beast",
  "Noble Fairy",
  "Nature's Guidance",
  "Harvest Festival",
  "Elf Metallurgist",
  "Archer",
  "Fairy Whisperer",
  "Okami",
  "Mana Elk",
  "Fairy Circle",
  "Woodkin Curse",
  "Woodland Refuge",

  "Arisa, Evergreen Arrow",
  "Ladica, Verdant Claw",
  "Setus, Sunlit Hero",
  "Lococo, Little Puppeteer",
  "Friendly Embrace",
  "Forest Guardian's Bow",
  "Beastfolk Harvester",
  "Heroic Resolve",
  "Inverted Manipulation",
  "Blossom Treant",
  "Sköll Lookout",
  "Elf Sorcerer",
  "Threadsnipper Puppet",
  "Heroic Fairy Champion",

  "Anastasia [Seize the Light]",
  "Hajime Fujiwara [Pink Blossom Dream]",
  "Minami Nitta [Goddess by the Sunlit Sea]",
  "Yuki Himekawa [Challengers' Cheer]",
  "Riina Tada [Wannabe Legend]",
  "Hinako Kita [True Dream]",
  "Miku Maekawa [Meownderful World]",
  "Blossoms' Advance",


  "Spinaria, Wavering Will",

  "Slade, Blossoming Wolf",


  "Baalt, King of the Elves",
  "Anastasia [All-Out Vacation]",
  "Miku Maekawa [Summer Cat Rendezvous]",
  "Summer Sea Breeze",

  "Rolo Rone, Verdant Purifier",
  "Kyou, Verdant Path Shepherd",
  "Tia, Crystalian Noble",
  "Verdant Authority Caretaker",
  "May, Eager Elf",
  "Sprouting Retribution",
  "Verdant City Pugilist",
  "Blossoming Lunerian",
  "Sowing Paradise",
  "Verdant Law Supplicant",
  "Milolo, Li'l Mountain Lass",
  "Rayne, Elf Smith",
  "Furious Mountain Deity",
  "Airbound Barrage",

  "Kokkoro",
  "Eris",
  "Nephi=Nela",
  "Shiori",
  "Anemone",
  "Makoto",
  "Rino",
  "Kururu",
  "Nea",
  "Lima",
  "Aoi",
  "Nebbia",
  "Suzuna",
  "Aurora Healing",

  "Magachiyo, Barbed Convict",
  "Wimael, Redolent Enforcer",
  "Zwei, Symphonic Heart",
  "Verdant Lieutenant",
  "Warden of Balms",
  "Synchronous Hearts",
  "Budding Initiate",
  "Leafshade Assassin",
  "Puppet Workout",
  "Beast Lancer",
  "Merchant of the Wood",
  "Rogue Puppeteer",
  "Support Troop Elf",
  "Galepierce",

  "Izudia, Annihilation Manifest",
  "Krulle, Heir to Unkilling",
  "Plumeria, Serene Goddess",
  "Windbloom Sylph",
  "Congregrant of Unkilling",
  "Eradicating Arrow",
  "Supplicant of Unkilling",
  "Greatwood Warrior",
  "Hamlet of Unkilling",
  "Bearer of the Fairy Blade",
  "Devotee of Unkilling",
  "Ageless Bystander",
  "Cutie Cat",
  "Bestial Swipe",

  "Castelle, Budding Mage",
  "Lyelth, Immaculate Idol",
  "Titania, Queen of Fairies",
  "Cleaver Cat",
  "Cynthia, Chivalrous Elf",
  "Dwarven Lumberjack",
  "Elven Farmhand",
  "Fauna Handler",
  "Fairy Funfact",
  "Bladebunny",
  "Vanguard Tigress",
  "Flying Mistletoe Squirrel",
  "Spiritelementalist",
  "Wild Profusion",

  "Nephi Nela",
  "Cleuru",
  "Kokkoro [Princess Form]",

  "Brilliant Fairy",
  "Noxious Elf",
  "Aerin, Forever Brilliant",
  "Flower Fox",
  "King of Vines",
  "Blast Fairy",
  "Wellspring Elf Princess",
  "Aqua Fairy",
  "Lily, Crystalian Conductor",
  "Coldhearted Dark Elf",
  "Fairy Bringer",
  "Wily Puck",
  "Dungeoncrawl Fairy",
  "Seed Barrage",
  "Haru Urara [I'll Win Someday!]",
];

export const sword = [
  "Rin Shibuya [Cinderella Girl]",
  "Uzuki Shimamura [Cinderella Girl]",
  "Amelia, Silver Captain",
  "Albert, Levin Stormsaber",
  "Ginne, Bewitching Courtesan",
  "Zirconia, Ironcrown Ward",
  "Amalia, Luxsteel Paladin",
  "Ravening Tentacles",
  "Luminous Commander",
  "Luminous Magus",
  "Rusty, Luxcard Trickster",
  "Jeno, Levin Axeraider",
  "Flashstep Quickblader",
  "Luminous Lancetrooper",
  "Lyrala, Luminous Potionwright",
  "Ignominious Samurai",
  "Ironcrown Majesty",

  "Octrice, Hollow Usurpation",
  "Kagemitsu, Lost Samurai",
  "Ralmia, Astrowing",
  "Arsène Lupin",
  "Ultimate Hollow",
  "Supersonic Breakthrough",
  "Adherent of Hollowness",
  "Sword General",
  "Serration Wave",
  "Penguin Guardian",
  "Hermit of Usurpation",
  "Chivalrous Bandit",
  "Flying Messenger Squirrel",
  "Brave Buccaneer",

  "Taketsumi, Aconite Paladin",
  "Mars, Belligerent Flame",
  "Jiemon, Thief Lord",
  "Bumpkin Recruit",
  "Hero of the Hunt",
  "Masterful Musician",
  "War Hero",
  "Noble Shieldmaiden",
  "Front Desk Frog",
  "Violent Soldier",
  "Hasty Axeman",
  "Night on the Town",
  "Haggler's Gambit",

  "Gentildonna",
  "Symboli Rudolf [Enchaînement]",
  "Sirius Symboli [Escorte Étoile]",
  "Aston Machan",
  "Symboli Kris S",
  "Tap Dance City",
  "Biwa Hayahide",
  "Teio-Oo-Oo!!!",

  "Albert, Thunderous Doom",
  "Magna Zero",
  "Sera, Maiden of the Dawn",
  "Homebound Infantryman",
  "Levin Justice",
  "Lounes, Levin Apprentice",
  "Jeno, Fanged Tyrant",
  "Cat Admiral",
  "Mina, Levin Vice Leader",
  "Mona, Levin Mage",
  "Mena, Levin Duelist",
  "Icyclone",
  "Meet the Levin Sisters!",

  "Patrick, Rhiceros Knight",
  "Lecia, Sky Saber",
  "Ironfist Beast Warrior",
  "Alwida, Pirate Queen",
  "Stroke of Conviction",
  "Nano, the Dawnblade",
  "Panther Scout",
  "King's Welcome",
  "Lilje, Butler of the Mists",
  "Sheena, Maid of the Mists",
  "Wolf Fang Swordsman",
  "Splendid Fencer",
  "Ivory Sword Dance",

  "Amelia, Sunny Paladin",

  "Nahtnaught, Cursed Queen",
  "Bunny & Baron, Specter Duo",
  "Reinhardt, the Deathless",
  "Radical Gunslinger",
  "Tyrant's Order",
  "Stalwart Slinger",
  "Outlaw Gunner",
  "Desperados' Shot",
  "Shinobi Tanuki",
  "Naht's Henchman",
  "Frontline Instructor",
  "Bandit Raid",
  "Dramatic Retreat",

  "Alfred Early",
  "Blaster Blade",
  "Wingal",
  "Knight of Conviction, Bors",
  "Flash Shield, Iseult",
  "Knight of Silence, Gallatin",
  "Little Sage, Marron",
  "Lake Maiden, Lien",
  "Knight of Rose, Morgana",
  "Stardust Trumpeter",

  "Majesty Lord Blaster",
  "Swordsman of the Explosive Flames, Palamedes",
  "Star Call Trumpeter",
  "High Dog Breeder, Akane",
  "Knight of Loyalty, Bedivere",
  "Solitary Knight, Gancelot",
  "Knight of Friendship, Kay",
  "Barcgal",
  "Miru Biru",
  "Young Pegasus Knight",
  "Toypugal",
  "Pongal",
  "Future Knight, Llew",
  "Margal",
  "Flogal",
  "Yggdrasil Maiden, Elaine",
  "Starlight Unicorn",
  "Knight of Truth, Gordon",
  "Wingal Brave",

  "VII. Oluon, The Chariot",
  "Alyaska, War Hawker",
  "Prudent General",
  "Ilmisuna, Discord Hawker",
  "Aerial Slash",
  "Lightning Kicker",
  "Empress of Serenity",
  "Knight Neilan the Lazy",
  "Honorable Thief",
  "Windslasher",
  "Selfless Noble",
  "Ernesta, Weapons Hawker",
  "Pompous Summons",

  "Celia, Sky Commander",
  "Spartacus",
  "Prim, Innocent Princess",
  "Nonja, Silent Maid",
  "Monochrome Duel",
  "Dario, Demon Count",
  "Queen Hemera the White",
  "Queen Magnus the Black",
  "Axe Princess",
  "Master Samurai",
  "Savage Swordsman",
  "Tycoon",
  "Frontline Ramparts",

  "Aether of the Warrior Wing",
  "Dionne, Dancing Blade",
  "Roland the Incorruptible",
  "Swordflash Panther",
  "Durandal the Incorruptible",
  "Azord, Duke of the Mists",
  "Madlance Centaur",
  "Dance of Usurpation",
  "Phantom Assassin",
  "Zealot of Usurpation",
  "Wardog",
  "Mana Pistol Merc",
  "Godsend Stride",

  "Bayleon, Sovereign Light",
  "Mistolina, Forest Princess",
  "Tsubaki of the Demon Blade",
  "Leod, the Crescent Blade",
  "King's Might",
  "Troya, Thunder of Hagelberg",
  "Valse, Champion Deadeye",
  "Princess's Strike",
  "Swift Tigress",
  "Lupine Axeman",
  "Dauntless Commander",
  "Tempered Aether",
  "Elegance in Action",

  "Uzuki Shimamura [P.C.S.]",
  "Kyoko Igarashi [P.C.S.]",
  "Miho Kohinata [P.C.S.]",
  "Rin Shibuya [Triad Primus]",
  "Nao Kamiya [Over the Rainbow]",
  "Karen Hojo [Song for Life]",
  "Chizuru Matsuo",
  "Mio Honda [Positive Passion]",
  "Miria Akagi",
  "Miu Yaguchi",
  "Kumiko Matsuyama",
  "Kyoko Igarashi",
  "Nagi Hisakawa",
  "Rin Shibuya",
  "Mio Honda",
  "Uzuki Shimamura",
  "Anzu Futaba",
  "Karen Hojo",
  "Sparkling Days",
  "Nao Kamiya",
  "Mayu Sakuma",
  "Kirari Moroboshi",
  "Miho Kohinata",
  "Angelic Maid",

  "Kagemitsu, Matchless Blade",
  "Ralmia, Sonic Racer",
  "Steadfast Samurai",
  "Hero of Antiquity",
  "Courtly Dance",
  "Quickdraw Maven",
  "Twinsword Master",
  "Grand Acquisition",
  "Samurai Outlaw",
  "Adept Thief",
  "Petalwink Paladin",
  "Levin Scholar",
  "Breakneck Draw",

  "Octrice, Omen of Usurpation",
  "Magna Legacy",
  "Apostle of Usurpation",
  "Empyreal Swordsman",
  "Confront Adversity",
  "Disciple of Usurpation",
  "Fervent Maachine Soldier",
  "Geno, Machine Artisan",
  "Servant of Usurpation",
  "Captain Meteo",
  "Gravikinetic Warrior",
  "Usurping Spineblade",
  "Avaritia",
  "Mars, Silent Flame General",
  "Gawain of the Round Table",
  "Barbarossa",
  "Perseus",
  "Cyclone Blade",
  "Chivalrous Charge",
  "Shrouded Assassin",
  "Lord General Romeo",
  "Round Table Assembly",
  "Princess Juliet",
  "Flail Knight",
  "Pollux",
  "Tristan of the Round Table",
  "Armor of the Stars",
  "Cinderella",
  "Valiant Fencer",
  "Maisy, Red Riding Hood",
  "Amerro, Spear Knight",
  "Castle in the Sky",
  "Young Ogrehunter Momo",
  "Mach Knight",
  "Kiss of the Princess",
  "Rabbit Ear Attendant",
  "Old Man and Old Woman",
  "Bladed Hedgehog",
  "Ironwrought Defender",
  "Heroic Entry",
  "Tokai Teio",
  "Narita Brian",
  "Winning Ticket",
  "Outrunning the Encroaching Heat",
  "Air Groove",
  "Hishi Amazon",
  "Trial Initiation",
  "Sirius Symboli",
  "Narita Taishin",
  "Symboli Rudolf",
  "Biko Pegasus",
  "Fuji Kiseki",
  "Albert Levin Saber",
  "Alexander",
  "Amelia, Silver Paladin",
  "Leonidas",
  "White Paladin",
  "Jeno, Levin Vanguard",
  "Yurius, Levin Duke",
  "Whole-Souled Swing",
  "Swift Infiltrator",
  "Samurai",
  "Avant Blader",
  "Flame Soldier",
  "Gunner Maid Seria",
  "Tsubasa",
  "Latham, Vanguard Captain",
  "Floral Fencer",
  "Moonlight Assassin",
  "White General",
  "Fencer",
  "Oathless Knight",
  "Quickblader",
  "Unbridled Fury",
  "Sea Queen Otohime",
  "Aurelia, Regal Saber",
  "Shadowed Assassin",
  "Frontguard General",
  "Alwida's Command",
  "Royal Banner",
  "Maid Leader",
  "Gemstaff Commander",
  "Sage Commander",
  "Swordsman",
  "Pompous Princess",
  "Ninja Master",
  "Arthurian Light",
  "Ninja Trainee",
  "Fervid Soldier",
  "Luminous Knight",
  "Veteran Lancer",
  "Navy Lieutenant",
  "Novice Trooper",
  "Forge Weaponry",
  "Onslaught",

  "Erika, Loyal Swordsavant",
  "Mistolina & Bayleon",
  "Leod, Moonlit Executioner",
  "Frenzied Corpsmaster",
  "Sunny Day Encounter",
  "Killer Instincts",
  "Valhorean Dealer",
  "Bladerights Lieutenant",
  "Shadowed Memories",
  "Fox Lancer",
  "Stone Merchant",
  "Victorious Grappler",
  "Countersolari Survivor",
  "Brothers United",

  "Rin & Mio",
  "Mio Honda [Cinderella Girl]",
  "Uzuki Shimamura [Magical New Me]",
  "Karen Hojo [Cinderella Girl]",
  "Airi Totoki [Cinderella Girl]",
  "Mayu Sakuma [Love-Laden Gift]",
  "Chieri Ogata [Happiness Tune]",
  "Nagi Hisakawa [Everyday Fairy Tale]",
  "Miho Kohinata [Youthful Romance]",
  "Dancing in the Rain",

  "Tsubaki",

  "Godsent Stride",

  "Regal Wildcat",

  "Albert, Levin Saber",
  "Fervent Machine Soldier",

  "Sparkling☆Days",
  "Airi Totoki [Anniversary Princess]",
  "Miho Kohinata [Summer Firsts]",
  "Mio Honda [Mermaid Star]",

  "Shinra, All-Discerning",
  "Gamma, Canine Mediator",
  "Gawain, Oath to Glory",
  "Bird's-Eye Investigator",
  "Darksaber Melissa",
  "Gigabyte Blade",
  "Cold Case Analyst",
  "Lucius, Sellsword",
  "Unorthodox Assistance",
  "Blind Spot Surveyor",
  "Monika, Cloudhall Admiral",
  "Princess Teena",
  "Holy Bear Knight",
  "Luminous Standard",

  "Pecorine",
  "Christina",
  "Labyrista",
  "Jun",
  "Riri",
  "Creditta",
  "Tomo",
  "Shizuru",
  "Ruka",
  "Tamaki",
  "Mitsuki",
  "Matsuri",
  "Ninon",
  "Princess Strike",

  "Barbaros, Briny Convict",
  "Radiel, Valorous Enforcer",
  "Gildaria, Anathema of Peace",
  "Warden of Honor",
  "Tidal Gunner",
  "Prim, Princess's Picnic",
  "Storm-Wracked First Mate",
  "Deep-Sea Scout",
  "Return from the Brink",
  "Felpurr Maid",
  "Knightly Thief",
  "Heavy Warrior",
  "Ninja Onslaught",
  "Cannon Volley",

  "Octrice, Hollowness Manifest",
  "Sinciro, Heir to Usurpation",
  "Aurelia, Glorious Saber",
  "Congregant of Usurpation",
  "Fearful Fighter",
  "Returning Slash",
  "Peppy Scout",
  "Supplicant of Usurpation",
  "Lair of Usurpation",
  "Comrade of the Swordmaster",
  "Devotee of Usurpation",
  "Mercurial Mercenary",
  "Palace Knight",
  "Shield Bash",

  "miroir",

  "Lecia & Nano, Twilight Trainees",
  "Galdr, Heroic Headmaster",
  "Yurius, Levin Authority",
  "Agile Twinblader",
  "Weiss, Discerning Professor",
  "Twilight and Silver",
  "Tony, Plucky Polliwog",
  "Deadeye Trainee",
  "Sharp Strategist",
  "Kitty Sergeant",
  "Fervent Fist-Fighter",
  "Levin Archer",
  "Aggressive Advance",
  "Lieutenant's Report",

  "Lily",
  "Pecorine [Princess Form]",

  "Victorious Blader",
  "Golden Warrior",
  "Armelize, Opulent Strategist",
  "Assault Knight",
  "Fangblade Slayer",
  "Claymore Master",
  "Axe Pirate",
  "Armed Butler",
  "Shield Phalanx",
  "Calculating Captain",
  "Suave Bandit",
  "Sword-Swinging Bandit",
  "Resplendent Knight",
  "Wandering Knight",
];

export const rune = [
  "Agnes Digital",
  "Daria, Dimensional Witch",
  "Hagoromo Komachi",
  "Mika Jougasaki [My★Style]",
  "Multipart Experiment",
  "Prophetess of Creation",
  "Yuuki Otokura [Together with Me]",
  "Anne & Grea, Mysterian Duo",
  "Lilanthim, Anathema of Edacity",
  "Zizdvend, Fate's Arbiter",
  "Edelweiss, Sagelight Ward",
  "Juno, Visionary Alchemist",
  "Homework Time!",
  "Penelope, Potions Prodigy",
  "Ms. Miranda, Adored Academic",
  "Snowman Army",
  "Starry-Eyed Penguin Wizard",
  "Emmylou, Witch of Wonder",
  "William, Mysterian Student",
  "Sagelight Teachings",
  "Truth Summons",

  "Raio, Truthful Elimination",
  "Lishenna, Melodious Destruction",
  "Kuon, Wuxing Master",
  "Acid Golem",
  "Melody's Return",
  "Secrets of Onmyodo",
  "Adherent of Elimination",
  "Adherent of Melody",
  "Elimination Unleashed",
  "Scroll Wizard",
  "Hermit of Truth",
  "Hermit of Destruction",
  "Crystal Witch",
  "Twinblade Mage",

  "Yukishima, Master Biographer",
  "Riley, Astral Shaman",
  "Bergent, Layered Sorceress",
  "Arctic Chimera",
  "Story of a Lifetime",
  "Orchestral Mage",
  "Tempestuous Alchemist",
  "Dream Come True",
  "Chakram Wizard",
  "Owl Receptionist",
  "Earthen Fist",
  "Magical Reserves",
  "Grand Spire",

  "Cheval Grand",
  "Tanino Gimlet",
  "Narita Top Road [Peachy Silhouette]",
  "Verxina",
  "Vivlos",
  "Daitaku Helios",
  "Sweep Tosho",
  "Lucky Star in the Sky",

  "Anne, Mysterian Imperatrix",
  "Ghios, Sparkling Prism",
  "Mileka, Celestial Seer",
  "Grea, Scorching Fury",
  "Whims of Chaos",
  "Grimoire Sorcerer",
  "Hurricane Golem",
  "Riven Earth",
  "Magical Squirrel",
  "Art Society Magus",
  "Cat Summoner",
  "Arcane Duplication",
  "Sacrifice",

  "Belphomet, Worldreaver",
  "Daria, Infinity Witch",
  "Regalore, Steel Chimera",
  "Melvie, Princess Witch",
  "Sorcery in Solidarity",
  "Chaos Wielder",
  "Rebel Against Fate",
  "Arcane Item Shop",
  "Gigahand Golem",
  "Device Diviner",
  "Mechabook Sorcerer",
  "Chain Lightning",
  "Mystic Absorption",

  "Falise, Innocent Sea Spray",

  "Vincent, the Peacekeeper",
  "Maiser, Neighborhood Hero",
  "Magical Gunslinger",
  "Transcendent Simulacrum",
  "Words of Judgment",
  "Artistic Arcanist",
  "Golem Marshal",
  "Rapid Fire",
  "Crystal Fencer",
  "Rivaylian Deputy",
  "Mirror Witch",
  "Terra Nova",
  "Scorching Blast",

  "Silver Thorn Dragon Tamer, Luquier",
  "Nightmare Doll, Alice",
  "Purple Trapezist",
  "Crimson Beast Tamer",
  "Mistress Hurricane",
  "Golden Beast Tamer",
  "Starlight Melody Tamer, Farah",
  "Turquoise Beast Tamer",
  "Dark Metal Bicorn",
  "Nitro Juggler",
  "Midnight Bunny",
  "Hades Hypnotist",
  "Dynamite Juggler",
  "Rainbow Magician",
  "Skyhigh Walker",
  "Candy Clown",
  "Jumping Jill",
  "Skull Juggler",
  "Girl Who Crossed the Gap",

  "0. Lhynkal, The Fool",
  "Runie, Resolute Diviner",
  "Imperator of Magic",
  "Checkmate",
  "Scourge of the Omniscient",
  "Juggling Moggy",
  "Gambit",
  "Rite of the Ignorant",
  "Piquant Potioneer",
  "Creative Conjurer",
  "Arcane Auteur",
  "Skewer",
  "Magical Augmentation",

  "Ceridwen, Eternity Hunter",
  "Faust, Truthseeker",
  "Anne, Mysterian Prodigy",
  "Grea, Mysterian Dragoness",
  "Mysterian Wyrmist",
  "Snowman King",
  "Owen, Knight of Mysteria",
  "Absolute Zeroblade",
  "Anne's Sorcery",
  "Grea's Ember",
  "Bergent, Onion Patchmaster",
  "Palla, Student Teacher",
  "Vayle, Mysterian Summoner",
  "Mysterian Knowledge",
  "Summoning Drills",
  "Witch of Foresight",
  "Beastfaced Mage",
  "Onion Patch",
  "Tico, Mysterian Spellnerd",
  "Mr. Bertrand, Magic Mentor",
  "Staff of Whirlwinds",

  "Sweet-Tooth Medusa",
  "Prophetless of Creation",
  "Unbodied Witch",
  "Lovely-Heart Monika",
  "Edict of Truth",
  "Elusa, Magic Wunderkind",
  "Morra, Monika's Familiar",
  "Veridic Discovery",
  "Moonshade Mage",
  "Zealot of Truth",
  "Rabbit Mage",
  "Zealot of Destruction",
  "Joy of Destruction",

  "Tetra, Sapphire Rebel",
  "Belphomet, Lord of Aiolon",
  "Riley, Hydroshaman",
  "Eleanor, Cosmic Flower",
  "Delta Cannon",
  "Displacer Bot",
  "Mechanized Lifeform",
  "Splendid Conjury",
  "Mechastaff Sorcerer",
  "Prototype Warrior",
  "Magiblade Witch",
  "Presto Chango",
  "Sagacious Core",

  "Chika Yokoyama",
  "Akiha Ikebukuro",
  "Yasuha Okazaki",
  "Seira Mizuki",
  "Mizuki Kawashima",
  "Shiki Ichinose",
  "Syuko Shiomi",
  "Kanade Hayami",
  "Center Street",
  "Hina Araki",
  "Frederica Miyamoto",
  "Precocious Little Devil",
  "Sarina Matsumoto",
  "Rika Jougasaki",
  "Sae Kobayakawa",
  "Tomoe Murakami",
  "Full Bloom Panorama",

  "Kuon, Founder of Onmyodo",
  "Mysteria, Magic Founder",
  "Curse Crafter",
  "Hulking Giant",
  "Shikigami Summons",
  "Demoncaller",
  "Traditional Sorcerer",
  "Crimson Meteor Storm",
  "Talisman Disciple",
  "Charming Gentlemouse",
  "Passionate Potioneer",
  "Golem's Rampage",
  "Mirror of Truth",

  "Raio, Omen of Truth",
  "Lishenna, Omen of Destruction",
  "Apostle of Truth",
  "Safira, Synthetic Beast",
  "Destructive Refrain",
  "Iron Staff Mechanic",
  "Truth's Adjudication",
  "Monochromatic Destruction",
  "Disciple of Truth",
  "Disciple of Destruction",
  "Servant of Destruction",
  "Honest Cohort",
  "Metaproduction",
  "Wordwielder Ginger",
  "Giant Chimera",
  "Star Reader Stella",
  "Europa",
  "Chain of Calling",
  "Noble Instruction",
  "Freshman Lou",
  "Magic Illusionist",
  "Concentration",
  "Show of Loyalty",
  "Dazzling Healer",
  "Mage of Nightfall",
  "Astrologist of the Mist",
  "Magic Owl",
  "Starseer's Telescope",
  "Wizardess of Oz",
  "Witch of Calamity, Millie Parfait",
  "Mystic King",
  "Falise, Leonardian Mage",
  "Milady, Mystic Queen",
  "Check",
  "Mr. Heinlein, Shadow Mage",
  "Magical Knight",
  "Gingerbread House",
  "It's a Sweets Buffet!",
  "Witch of Sweets",
  "Magical Rook",
  "Magical Bishop",
  "Blitz",
  "Witch's Cauldron",
  "The Cauldron of Calamity",
  "Agnes Tachyon",
  "Daiwa Scarlet",
  "Vodka",
  "Make! Some! NOISE!",
  "Zenno Rob Roy",
  "Agens Digital",
  "Lamplit Training of a Witch-to-Be",
  "Admire Vega",
  "Kawakami Princess",
  "Nakayama Festa",
  "Tosen Jordan",
  "Narita Top Road",
  "Daria Dimensional Witch",
  "Sun Oracle Pascale",
  "Anne, Belle of Mysteria",
  "Grea the Dragonborn",
  "Rimewind",
  "Remi & Rami, Witchy Duo",
  "Shadow Witch",
  "Multipart Expirement",
  "Craig, Wizard of Mysteria",
  "Grand Gargoyle",
  "Witchbolt",
  "Magical Strategy",
  "Red-Hot Ritual",
  "Mythril Golem",
  "Rune Blade Summoner",
  "Demonflame Mage",
  "Insight",
  "Fire Chain",
  "Penguin Wizard",
  "Sammy Wizard's Apprentice",
  "Magic Missle",
  "Conjure Golem",
  "Arch Summoner Erasmus",
  "Merlin",
  "Ancient Alchemist",
  "Arcane Enlightenment",
  "Dimension Shift",
  "Juno's Secret Laboratory",
  "Spectral Wizard",
  "Flame Destroyer",
  "Dragonbond Mage",
  "Golem Protection",
  "Alchemical Lore",
  "Fate's Hand",
  "Price of Magic",
  "Runic Guardian",
  "Crafty Warlock",
  "Lightning Shooter",
  "Wind Blast",
  "Sorcery Cache",
  "Fiery Embrace",
  "Alchemist's Workshop",
  "Teachings of Creation",

  "Isabelle, Intrepid Mage",
  "Eleanor, Glorious Flower",
  "Belphomet, Ultimate Creator",
  "Tetra, Serene Sapphire",
  "Mega Enforcer",
  "Nefarious Invasion",
  "Marie, Flowery Magician",
  "Enforcer",
  "Fruits of Wisdom",
  "Awakened Robot",
  "Covenant Mage",
  "Jetbroom Witch",
  "Panacea Alchemist",
  "Mysterian Wisdom",

  "Syuko Shiomi [Cinderella Girl]",
  "Mika & Rika",
  "Yuuki Otokura [Ripples of My Heart]",
  "Glitz & Glam☆Parade",
  "Sae Kobayakawa [Dancing Flowers]",
  "Hiromi Seki [Twinkle in My Eye]",
  "Shiki Ichinose [Mystic Elixir]",
  "Kanade Hayami [Faraway Reflection]",
  "Tomoe Murakami [Crimson Fighter]",

  "Sammy, Wizard's Apprentice",
  "Magic Missile",



  "Grand Summoning",

  "Beachside Memories",

  "Mana, Sterling Luster",
  "Francoise, Bejeweled Manager",
  "Ginger, Accursed Word",
  "Bejeweled Supermodel",
  "Aleister, Argenteum Astrum",
  "Brilliant Cut",
  "Bejeweled Advisor",
  "Mari, Card Conjurer",
  "Clandestine Dealings",
  "Bejeweled Bouncer",
  "Carbuncle of Mysteria",
  "Illusionist",
  "Enchanted Sword",
  "Authoring Tomorrow",

  "Karyl",
  "Yuni",
  "Neneka",
  "Maho",
  "Precia",
  "The Shared Illusion of Truth and Existence",
  "Kyoka",
  "Chieru",
  "Chloe",
  "Yuki",
  "Hatsune",
  "Nanaka",
  "Cheru Cheru☆Carnival",
  "Dark Eclipse",
  "Yuni, Chloe & Chieru",

  "Sephie, Depraved Convict",
  "Simael, Cleansing Enforcer",
  "Kyrzael, Killshot Enforcer",
  "Obsessive Scholar",
  "Warden of the Trigger",
  "Warden of the Arcane",
  "Devoted Researcher",
  "Volunteer Test Subject",
  "Astral Dancer",
  "Electrokitty",
  "Outdoorsmage",
  "Ultramarine Witch",
  "Feline Magic",
  "Meandering Bolt",

  "Lishenna, Melody Manifest",
  "Velharia, Heir to Truth",
  "Axia, Heir to Destruction",
  "Raio, Elimination Manifest",
  "Congregant of Destruction",
  "Devastating Soprano",
  "Congregant of Truth",
  "Supplicant of Destruction",
  "Illusory Conjuration",
  "Devotee of Destruction",
  "Supplicant of Truth",
  "Devotee of Truth",
  "Ascetic of Wuxing",
  "Wasteland of Destruction",

  "Amaryllis, the Princess",
  "Anne, Brilliant Mage",
  "Ceridwen, Eternal Duality",
  "Grea, Crimson Promise",
  "Mysterian Exchange Party",
  "Mystic Rune",
  "Gruinne, Leonardian Provost",
  "Leeds, Pining Witch",
  "Bell Witch",
  "Wolf Whisperer",
  "Evamia, Spinner of Threads",
  "Arcane Instruction",
  "Aqueous Sphere",
  "Binding Ritual",

  "Construct of Truth and Being",
  "Chellerific Carnival",
  "Karyl [Princess Form]",

  "Chrono Witch",
  "Pursuer Golem",
  "Levi, Wizard of Ages",
  "Witching Moggy",
  "Great Magician",
  "Lazuli, Gateway Homunculus",
  "Elina, Winged Evangelist",
  "Parasol Witch",
  "Carnelia, Servant of Darkness",
  "Blade Mage",
  "Frost Golem",
  "Iceshard Beast",
  "Golem Assault",
  "Mirrored Summoning",
];

export const dragon = [
  "Akari Tsujino [Twice as Lovely]",
  "Aqua Nereid",
  "BRIGHT:LIGHTS",
  "Garyu, Supreme Dragonkin",
  "Gattling Claw Dragon",
  "Iron Tail Dragon",
  "Riamu Yumemi [Party Night]",
  "Slaughtering Dragonewt",
  "Forte, Blackwing Dragoon",
  "Burnite, Anathema of Flame",
  "Nirle, Draconic Prodigy",
  "Liu Feng, Goldennote Ward",
  "Genesis Dragon Reborn",
  "Fan of Otohime",
  "Eyfa, Windrider",
  "Marion, Ravishing Dragonewt",
  "Kit, Luxfang Champion",
  "Zahar, Stormwave Dragoon",
  "Little Dragon Nanny",
  "Zell, Windreader",
  "Silvercloud Dragonrider",
  "Swordsnout Trencher",
  "Goldennote Melody",

  "Galmieux, Ardent Disdain",
  "Filene, Blizzardous Heart",
  "Celestial Dragoon",
  "Mermaid of Punishment",
  "Ardent Torch",
  "Whitefrost Blizzard",
  "Adherent of Ardor",
  "Windswept Dragonewt",
  "Tropical Mermaid",
  "Tiniest Dragon",
  "Hermit of Disdain",
  "Beginner Dragoon",
  "Orbed Cancer",
  "Whimsical Mermaid",

  "Si Long, Draconic God-Queen",
  "Sacred Springs Dragon",
  "Frostbite Dragon",
  "Dragonskull Bludgeoner",
  "Soothing Dragonspring",
  "Dragonfolk Stoker",
  "Leviathan, the Furious",
  "March of the Dragonspring",
  "Dragon Breeder",
  "Dragon-Drawn Carriage",
  "Loyal Sea Serpent",
  "Mermaid Song",
  "Aquatic Authority",

  "Neo Universe",
  "Mr. C.B.",
  "Katsuragi Ace",
  "Super Creek [Piece of Mind]",
  "Tsurumaru Tsuyoshi",
  "El Condor Pasa",
  "Nishino Flower",
  "Pious Flame, Heavens Scorcher",

  "Drache, Fiery Dragonlord",
  "Forte, Sovereign Supreme",
  "Godfire Phoenix",
  "Roy, Dragonreaver",
  "Howling Conflagration",
  "Flame Pillar Dragonewt",
  "Empyreal Dragon",
  "Scalebound Plight",
  "Margarite Mermaid",
  "Earthen Dragonewt",
  "Twinblade Dragonfolk",
  "Coral Shark",
  "Beating of the Dragonwings",

  "Shipsbane Plesiosaurus",
  "Jerva, Wyrm Transcendent",
  "Steelcap Pachycephalosaurus",
  "Giselle, Mermaid Healer",
  "Cursed Furor",
  "Assault Dragoon",
  "Petalspine Stegosaurus",
  "Phoenix Howl",
  "Dragoon Medic",
  "Rockback Ankylosaurus",
  "Ruinous Dragon",
  "Dragon Aficionado",
  "Overwhelming Crush",

  "Sharon, Seaside Nymph",

  "Reggie, Peerless Artisan",
  "Resplendent Phoenix",
  "Georgius",
  "Balefire Wrenchsmith",
  "Dragon-Devouring Dread",
  "Azureflame Dragonewt",
  "Dragonfolk Artificer",
  "Draconic Call",
  "Mermaid Guide",
  "Wyrmfire Engineer",
  "Pumpkin Dragon",
  "Wavecrest Angler",
  "Thunderous Roar",

  "Dragonic Overlord",
  "Dragon Monk, Goku",
  "Dragon Knight, Aleph",
  "Berserk Dragon",
  "Wyvern Guard, Barri",
  "Dragon Knight, Nehalem",
  "Embodiment of Armor, Bahr",
  "Chain-Attack Sutherland",
  "Follower, Reas",
  "Lizard Runner, Undeux",

  "Dragonic Overlord the End",
  "Seal Dragon, Blockade",
  "Burning Horn Dragon",
  "Blazing Core Dragon",
  "Dragonic Executioner",
  "Vortex Dragon",
  "Flame of Promise, Aermo",
  "Bellicosity Dragon",
  "Prowling Dragon, Striken",
  "Dragon Monk, Gojo",
  "Demonic Dragon Berserker, Yaksha",
  "Demonic Dragon Mage, Kimnara",
  "Embodiment of Spear, Tahr",
  "Gatling Claw Dragon",
  "Lizard Soldier, Ganlu",
  "Dragon Monk, Genjo",
  "Irontail Dragon",
  "Flame of Hope, Aermo",
  "Lizard Soldier, Conroe",

  "XI. Erntz, Justice",
  "Aiela, Devoted Knight",
  "Slaughering Dragonewt",
  "Eternal Whale",
  "Dual Rage",
  "Swiftblade Dragonewt",
  "Heliodragon",
  "Dragon Impact",
  "Springwell Dragon Keeper",
  "Gallant Dragonewt",
  "Dragonclad Lancer",
  "Tropical Grouper",
  "Dragon Spawning",

  "Jerva of Draconic Mail",
  "Zirnitra, Dragon's Flame",
  "Romelia, Lightning Striker",
  "Masamune, Raging Dragon",
  "Lindworm",
  "Dragonplate Warrior",
  "Poseidon",
  "Pure-Voiced Dragoon",
  "Force of the Dragonewt",
  "Waters of the Megalorca",
  "Roy, Dragoncleaver",
  "Galua of Two Breaths",
  "Katakura Kojuro",
  "Dragoon Scyther",
  "Gargouille",
  "Heroic Dragonslayer",
  "Dragonclad Blademaster",
  "Drakewing Assassin",
  "Coda, Twilight Dragoon",
  "Hypersonic Dragonewt",
  "Dragon's Handspur",

  "Dragon Empress Otohime",
  "Azi Dahaka",
  "Annerose",
  "Ouroboros",
  "Powerforge",
  "Elios, Loyal Dragoon",
  "Dragonsoul Princess",
  "Vile Violet Dragon",
  "Zealot of Disdain",
  "Righteous Dragoon",
  "Geovore",
  "Draco Marionette",
  "Sneer of Disdain",

  "Valdain, Cursed Shadow",
  "Neptune, Tidemistress",
  "Wildfire Tyrannosaur",
  "Marion, Elegant Dragonewt",
  "Shadow's Corrosion",
  "Bubbleborne Mermaid",
  "Hoarfrost Triceratops",
  "Whirlwind Pteranodon",
  "Dragonewt Needler",
  "Lightning Velociraptor",
  "Doting Dragoneer",
  "Boomfish",
  "Feral Aether",

  "Nene Kurihara",
  "Kaoru Ryuzaki",
  "Akari Tsujino",
  "Yui Ohtsuki",
  "Fumika Sagisawa",
  "Akira Sunazuka",
  "Tsukasa Kiryu",
  "Arisu Tachibana",
  "Yuka Nakano",
  "Unbound Emotion",
  "Tokiko Zaizen",
  "Noriko Shiina",
  "Yukari Mizumoto",
  "Noa Takamine",
  "Mode Estivale",

  "Garyu, Surpreme Dragonkin",
  "Filene, Whitefrost Dragonewt",
  "Phoenix Empress",
  "Wyrm God of the Skies",
  "Whitefrost Whisper",
  "Ice Dancing Dragonewt",
  "Jadelong Tactician",
  "Aquascale Stalwart",
  "Swordwhip Dragoon",
  "Dragonblader",
  "Trident Merman",
  "Dragon Chef",
  "Flamewinged Might",

  "Galmieux, Omen of Disdain",
  "Electromagical Rhino",
  "Apostle of Disdain",
  "God Bullet Golem",
  "Disdainful Rending",
  "Disciple of Disdain",
  "Cursed Stone",
  "Amethyst Giant",
  "Servant of Disdain",
  "Silver Automaton",
  "Airship Whale",
  "Colossal Construct",
  "Total Domination",
  "Sibyl of the Waterwyrm",
  "Kallen, Crimson Yaksha",
  "Python",
  "Prime Dragon Keeper",
  "Star Phoenix",
  "Lightning Blast",
  "Guren Revolt",
  "Venomous Pucewyrm",
  "Cetus",
  "Dragonewt Fist",
  "Divine Tiger",
  "Dragonrearer Matilda",
  "Aqua Nerid",
  "Hippocampus",
  "Scaled Berserker",
  "Dragon's Nest",
  "Jabberwock U",
  "Lævateinn Dragon",
  "Red Ragewyrm",
  "Draconir, Knuckle Dragon",
  "Tilting at Windmills",
  "Master of Draconic Arts",
  "Hammer Dragonewt",
  "Draconic Smash",
  "Elder Tortoise",
  "Trinity Dragon",
  "Dragon Summoner",
  "Lance Lizard",
  "Armor Burst",
  "Special Week",
  "Oguri Cap",
  "Seiun Sky",
  "Champion's Passion",
  "King Halo",
  "Tamamo Cross",
  "Flowers for You",
  "Bamboo Memory",
  "Yaeno Muteki",
  "Grass Wonder",
  "Super Creek",
  "Hishi Akebono",
  "Imperial Dragoon",
  "Dragonsong Flute",
  "Neptune",
  "Draconic Fervor",
  "Polyphonic Roar",
  "Siegfried",
  "Transmogrified Wyrm",
  "Dracomancer's Rites",
  "Wildfang Dragonewt",
  "Mushussu",
  "Dragontamer",
  "Twin-Headed Dragon",
  "Draconic Armor",
  "Fafnir",
  "Dragon Oracle",
  "Dragon Warrior",
  "Dragonewt Princess",
  "Dragonguard",
  "Roc",
  "Glint Dragon",
  "Dragonrider",
  "Seabrand Dragon",
  "Dark Dragoon Forte",
  "Zirnitra",
  "Aiela, Dragon Knight",
  "Genesis Dragon",
  "Shapeshifting Mage",
  "Phoenix Roost",
  "Wyvern Cavalier",
  "Dragonewt Scholar",
  "Shenlong",
  "Imprisoned Dragon",
  "Conflagration",
  "Serpent's Wrath",
  "Wyrm Spire",
  "Ivory Dragon",
  "Fire Lizard",
  "Ace Dragoon",
  "Mist Dragon",
  "Dread Dragon",
  "Blazing Breath",
  "Dragon Wings",
  "Dragon Emissary",

  "Rowen, Dragon Lance",
  "Valdain, Forest Shadow",
  "Disrestan, Ocean Harbinger",
  "Djeana, the Stouthearted",
  "Verdant Rebirth",
  "Dragonslayer Spear",
  "Forestclaw Sentinel",
  "Rock Whale",
  "Newfound Allies",
  "Shark Warrior",
  "Poisonous Dilophosaurus",
  "Mánagarmr Scout",
  "Mermaid Archer",
  "Touching Thoughts",

  "Fumika Sagisawa [Cinderella Girl]",
  "Akira Sunazuka [Online Life]",
  "Akari & Akira",
  "Riamu Yumemi [Shout It to the World]",
  "Yui Ohtsuki [Lollipop Darling]",
  "Hotaru Shiragiku [Unbreakable]",
  "Star of the Show",



  "Serpent Wrath",

  "Jabberwock",
  "Dragonrend Quake",

  "Riamu's Reverie",

  "El, Destructive Dragon",
  "Tenka, Hot-Blooded Vice-Prez",
  "Fafnir, Cunning Wyrm",
  "Dragon-Eyed Secretary",
  "Prophetic Dragon",
  "After-School Break",
  "Neon-Tailed Prefect",
  "Ian, Dragon Buster",
  "Red-Winged Admissions Gift",
  "Lightning-Clawed Loafer",
  "Serpent Drake",
  "Draconic Mercenary",
  "Estrella Beast",
  "Orca Run",

  "Sheffy",
  "Homare",
  "Muimi",
  "Kaya",
  "Hiyori",
  "Someday, We'll Meet Again in the Future",
  "Inori",
  "Lind",
  "Wyrm",
  "Mifuyu",
  "Kaori",
  "Ayane",
  "Dragon's End Fist",
  "Prank Declaration",

  "Antemaria, Huntress Convict",
  "Drazael, Ravening Enforcer",
  "Masamune, One-Eyed Dragon",
  "Scorched-Earth Tyrant",
  "Neptune, Arbiter of Tides",
  "Warden of the Adamant Claw",
  "Hotheaded Marauder",
  "Razor-Clawed Thief",
  "Seasoned Merman",
  "Dancing Crab",
  "Mermaid Songstress",
  "Dark Mermaid",
  "Dragonewt's Might",
  "Call of the Megalorca",

  "Galmieux, Ardor Manifest",
  "Azurifrit, Heir to Disdain",
  "Dagon, Lord of the Seas",
  "Spoiled Mermanager",
  "Congregant of Disdain",
  "Ferocious Flame",
  "Supplicant of Disdain",
  "Encounter from the Deep",
  "Nation of Disdain",
  "Snowstorm Dragonewt",
  "Devotee of Disdain",
  "Militant Mermaid",
  "Ocean Rider",
  "Raging Lightning",

  "Lilium, the Wyrmwitch",
  "Coach Joe, Fiery Counselor",
  "Lumiore, Prestigious Gold",
  "Grand Slam Tamer",
  "Dion, Scarlet Scion",
  "Argente, Purest Silver",
  "Dragonborn Striker",
  "Gunbein, Lofty Dragonewt",
  "Charlotte, Dragonewt",
  "Ipupiara",
  "Megalorca Rider",
  "Augite Wyrm",
  "Stormscale",
  "Dragon Hunt",

  "Until We Meet Again",
  "Prank Proclamation",
  "Sheffy [Princess Form]",
  "Hiyori [Princess Form]",

  "Ignis Dragon",
  "Brutal Dragonewt",
  "Giselle, Ocean Star",
  "Noir & Blanc, Brothers",
  "Bejeweled Dragon",
  "Ethica, Firebrand Claw",
  "Coral Spirit",
  "Shield Dragon",
  "Piercing Roar",
  "Hailwyrm",
  "Ironscale Serpent Drake",
  "Electrodrake",
  "Breath of the Salamander",
  "Canyon of the Dragons",
  "Oguri Cap [Surging Beast]",
];

export const abyss = [
  "Asuka Ninomiya [Sweet & Charming]",
  "Lelouch, Righteous Emperor",
  "Nephthys",
  "Ranko Kanzaki [Cinderella Girl]",
  "Silvernail Markswoman",
  "Cerberus, Hellfire Unleashed",
  "Aragavy, Eternal Hunter",
  "Gold Rush Ghost",
  "Mukan, Shadowcrypt Ward",
  "Balto, Dusk Bounty Hunter",
  "Ceres, Blue Rose Maiden",
  "Orthrus, Hellhound Blader",
  "Yuna, Occult Hunter",
  "Soul Predation",
  "Vlad, Impaler",
  "Aryll, Moonstruck Vampire",
  "Mino, Shrewd Reaper",
  "Beryl, Nightmare Incarnate",
  "Shadowcrypt Memorial",

  "Valnareik, Lustful Desire",
  "Rulenye, Screaming Silence",
  "Ginsetsu, Terror Banquet",
  "Yuzuki, Bloodlord",
  "Spiteful Screams",
  "A Hellish Banquet",
  "Adherent of Desire",
  "Loathing Desire",
  "Crimson Virtue",
  "Adherent of Screams",
  "Hermit of Lust",
  "Hermit of Silence",
  "Krampus",
  "Astral Projection",

  "Itsurugi, Eager Admirer",
  "Paracelise, Demon of Greed",
  "Anisage, Lost Forsaken",
  "Frigid Necromancer",
  "Eternal Contract",
  "Briared Vampire",
  "Room Service Demon",
  "Undying Resolve",
  "Silvernail Blaster",
  "Parkour Werewolf",
  "Bat Usher",
  "Creeping Malice",
  "Full Moon Leap",

  "Hishi Miracle",
  "Daiichi Ruby",
  "Duramente",
  "Matikanetannhauser [Machitan☆Adventure]",
  "K.S.Miracle",
  "Air Shakur",
  "Manhattan Cafe",
  "TT Ignition!",

  "Aluzard, Timeworn Vampire",
  "Laura, Crimson Strife",
  "Ceres, Bride of the Night",
  "Kagero, Swordbound Soul",
  "Chris, Beyond the Patch",
  "Liberté, Unchained Wolf",
  "Silversteel Blader",
  "Soulstrike",
  "Linkstaff Necromancer",
  "Noble Phantom",
  "Bandage Connoisseur",
  "Ghastly Banishment",
  "Sanguine Necklace",

  "Neun, Daybreak Vampire",
  "Gremory, Death Teller",
  "Jackshovel Gravedigger",
  "Medusa, Evil-Eyed Serpent",
  "Friends Forever",
  "Liberté, Werewolf Pup",
  "Hellfire Hound",
  "Garnet Waltz",
  "Bloodstained Berserker",
  "Roly-Poly Mk I",
  "Mechasaw Deathbringer",
  "Ghoul",
  "Viper Lash",

  "Queen Vampire, Sultry Evening",

  "Iceschillendrig, Gilded Autocrat",
  "Illganeau, Horror Astray",
  "Hazhan, Demonblade Knight",
  "Greatpick Corpse",
  "Dead to Rights",
  "Wretch",
  "Gold Mine Necromancer",
  "Wretched Tryst",
  "Redcap",
  "Skeleton Dreamer",
  "Fulminating Berserker",
  "Grudge Teller",
  "Spiderweb Array",

  "Phantom Blaster Overlord",
  "Phantom Blaster Dragon",
  "Blaster Dark",
  "Skull Witch, Nemain",
  "Knight of Nullity, Masquerade",
  "Darkness Maiden, Macha",
  "Cursed Lancer",
  "Knight of Darkness, Rugos",
  "Black Sage, Charon",
  "Doranbau",
  "Blaster Javelin",
  "Dark Shield, Mac Lir",
  "Grim Reaper",
  "Abyss Freezer",
  "Darkside Trumpeter",
  "Abyss Healer",
  "Witch of Nostrum, Arianrhod",
  "Gururubau",
  "Fullbau",

  "VI. Milteo, The Lovers",
  "XIV. Luzen, Temperance",
  "Deathbringer",
  "Demonium, Clash Devil",
  "Sincere Soul",
  "Ghost Maid",
  "Insatiable Desire",
  "Unselfish Grace",
  "Moonrise Werewolf",
  "Spirit Curator",
  "Silverbolt Hunter",
  "Soul Box",
  "Colossal Grudge",

  "Vania, Nightshade Vampire",
  "Arcus, Spirited Manager",
  "Oldblood King",
  "Darkfeast Bat",
  "Gift for Bloodkin",
  "Big Soul Hunter",
  "Raven, Eventide Vampire",
  "Blood Moon",
  "Orator of the Bones",
  "Raven, Noontide Vampire",
  "Raven, Midnight Vampire",
  "Death the Nyctophile",
  "Poltergeist",

  "Crimson Rose Queen",
  "Nepthys",
  "Tartarus, the Tormentor",
  "Vuella, One-Winged Demon",
  "Sonata of Silence",
  "Chris Pumpkinhead",
  "Salome",
  "Kiss of Lust",
  "Arion",
  "Marian the Mummy",
  "Zealot of Silence",
  "Zealot of Lust",
  "Manifest Malice",

  "Mono, Garnet Rebel",
  "Kudlak",
  "Aenea, Amethyst Rebel",
  "Doublame, Duke and Dame",
  "Alpha Drive",
  "Nicola, Forbidden Strength",
  "Hellblaze Demon",
  "Forbidden Art",
  "Robozombie",
  "Bone Drone",
  "Berserk Demon",
  "Ghostwriter",
  "Sanguine Core",

  "Yukimi Sajo",
  "Ranko Kanzaki",
  "Sachiko Koshimizu",
  "Takumi Mukai",
  "Chitose Kurosaki",
  "Whispers of a Dream",
  "Chiyo Shirayuki",
  "Aki Yamato",
  "My Life, My Sounds",
  "Ryo Matsunaga",
  "Mirei Hayasaka",
  "Rina Fujimoto",
  "Syoko Hoshi",
  "Last Daylight",

  "Ginsetsu, Great Fox",
  "Aragavy the Berserker",
  "Shuten-Doji",
  "Bear Pelt Warrior",
  "Yuzuki, Righteous Demon",
  "Kasha",
  "Cougar Pelt Warrior",
  "Unleash the Nightmare",
  "Zashiki-Warashi",
  "Antelope Pelt Warrior",
  "Rookie Succubus",
  "Demonic Procession",
  "Berserker's Pelt",

  "Valnareik, Omen of Lust",
  "Rulenye, Omen of Silence",
  "Apostle of Lust",
  "Apostle of Silence",
  "Disciple of Lust",
  "Masked Puppet",
  "Wings of Lust",
  "Silent Purge",
  "Servant of Lust",
  "Servant of Silence",
  "Hamelin",
  "Embracing Wings",
  "Thundering Roar",
  "Venomfang Medusa",
  "Howling Demon",
  "Demonlord Eachtar",
  "Lelouch, Leader of the Black Knights",
  "Stheno",
  "Trial of the Gorgons",
  "Fenrir",
  "Euryale",
  "Grave Desecration",
  "Emperor's Command",
  "Demonic Drummer",
  "Castor",
  "Frogbat",
  "Scorpius",
  "Venomous Bite",
  "Dark Alice",
  "Masquerade Ghost",
  "Odile, Black Swan",
  "Demonium, Punk Devil",
  "Baccherus, Peppy Ghostie",
  "Demon Maestro",
  "Trombone Devil",
  "Furtive Fangs",
  "Pumpkin Necromancer",
  "Parade Raven",
  "Mischievous Zombie",
  "Devilish Flautist",
  "Infernal Orchestration",
  "Maruzensky",
  "Rice Shower",
  "Nice Nature",
  "7 More Centimeters",
  "Fine Motion",
  "Mayano Top Gun",
  "My Solo Drawn to Raindrop Drums",
  "Curren Chan",
  "Twin Turbo",
  "Sakura Chiyono O",
  "Seeking the Pearl",
  "Matikanetannhauser",
  "Vania, Vampire Princess",
  "Soul Dealer",
  "Underworld Watchman Khawy",
  "Azazel",
  "Vampiric Fortress",
  "Veight, Vampire Noble",
  "Trick Dullahan",
  "Precious Bloodfangs",
  "Mini Soul Devil",
  "Moriana the Bejeweled",
  "Demonic Hedonist",
  "Bone Chimera",
  "Necrocarnival",
  "Queen Vampire",
  "Alucard",
  "Playful Necromancer",
  "Midnight Vampire",
  "Night Horde",
  "Lesser Mummy",
  "Lilith",
  "Undying Resentment",
  "Summon Bloodkin",
  "Cerberus",
  "Lord Atomy",
  "Medusa",
  "Righteous Devil",
  "Mordecai the Duelist",
  "Dire Bond",
  "Hell's Unleasher",
  "Crazed Executioner",
  "Dark Summoner",
  "Dark General",
  "Phantom Howl",
  "Death's Breath",
  "Soul Conversion",
  "Skeleton Fighter",
  "Ambling Wraith",
  "Spectre",
  "Spartoi Sergeant",
  "Rabbit Necromancer",
  "Wardrobe Raider",
  "Undead King",
  "Razory Claw",

  "Luna, Soul Keeper",
  "Urias, Final Vampire",
  "Mono, Immortal Garnet",
  "Aenea, Creative Amethyst",
  "Nicola, Enduring Steward",
  "Steeled Hopes",
  "Amy, Psychopomp Guide",
  "Roly-Poly Mk II",
  "Allure of Shadows",
  "Rouge Vampire",
  "Vampiric Bloodbinder",
  "Trampling Terror",
  "Soul Commander",
  "Midnight Gossip",

  "Ranko Kanzaki [Princess in White]",
  "Syoko Hoshi [individuals]",
  "Mirei Hayasaka [individuals]",
  "Nono Morikubo [individuals]",
  "Asuka Ninomiya [Gentle Evening]",
  "Chitose Kurosaki [Memento Mori]",
  "Natsuki Kimura [Scarlet Love Song]",
  "Takumi Mukai [No One Can Stop Me]",
  "Koume Shirasaka [Haunted Gown]",
  "Self-Proclaimed Fan Favorite",





  "New Year's Soul Devil",
  "Sweet Sentiments",
  "Summer Encounter",

  "Ilze & Urze, Centennial Reapers",
  "Vedd, Burial Wolf",
  "Vania, Crimson Majesty",
  "Covetous Serpent",
  "Veight, Twilit Highborn",
  "Crescent Moon of Centennial Death",
  "Exhumation Crow",
  "Full Moon of Centennial Demise",
  "Vampire Queen's Castle",
  "Gnawing Rat",
  "Beryl, Dreameater",
  "Prince Catacomb",
  "Bloodthirsty Hamster",
  "Nightscreech",

  "Illya",
  "Ranpha",
  "Violet",
  "Shinobu",
  "Grace",
  "Rei",
  "Yori",
  "Akari",
  "Miyako",
  "Misaki",
  "Kuuka",
  "Io",
  "Eriko",
  "Infinite Break - Code: Null",
  "Ranpha & Misora",

  "Istyndet, Soul Convict",
  "Garodeth, Insurgent Convict",
  "Zeronua, Demon of Domination",
  "Abyssal Colonel",
  "Myroel, Death Enforcer",
  "Genomuel, Wyrm Enforcer",
  "Underworld Lieutenant",
  "Warden of Corpses",
  "Raging Commander",
  "Vicious Blitzer",
  "Fallen Sergeant",
  "Steamrolling Tank",
  "Howling Scream",
  "Prison of Pain",

  "Rulenye & Valnareik",
  "Sham-Nacha, Heir to Entwining",
  "Diabolus Hedone",
  "Congregant of Entwining",
  "Hervör",
  "Screaming and Loathing",
  "Spirited Gravekeeper",
  "Supplicant of Entwining",
  "Castle of Entwining",
  "Ephemeral Demon Princess",
  "Devotee of Entwining",
  "Wicked Collector",
  "Nemean Lion",
  "March of the Brutes",

  "Cornelius, the Corpse King",
  "Galom, Empress Fist",
  "Vulgus, Infernal Headmistress",
  "Arka, Sin Spinner",
  "Exella, Nocturnal General",
  "Bad-Girl Life",
  "Mach-Speed Maron",
  "Demon-Eyed Gangster",
  "Noble Demoness",
  "Bonebreaker Bladesman",
  "Denan, Big Bad Boss",
  "Malicious Blader",
  "Serenading Succubus",
  "Spirit Invasion",

  "Kuka",
  "Demonic Salvation: Infinity",
  "Rei [Princess Form]",

  "Skeleton Raider",
  "Dark Emperor",
  "Cernunnos",
  "Suzy, Hexcaster",
  "Dog of the Dead",
  "Goblin Reaper",
  "Scarlet Vampire",
  "Deathcat Reaper",
  "Huginn & Muninn",
  "Thunderbolt Fiend",
  "Lurching Corpse",
  "Goblin Zombie",
  "Bubbly Reaper",
  "Undead Stampede",
];

export const haven = [
  "Eve Santaclaus [Cinderella Girl]",
  "Evil-Eye Princess, Euryale",
  "Marlone, Light of Balance",
  "Miyu Mifune [Rouge Couture]",
  "Psychic☆Maiden",
  "Sapphire Priestess",
  "T. M. Opera O",
  "Lapis, Shining Seraph",
  "Rodeo, Anathema of Judgment",
  "Rana, Dual Cannon Abbess",
  "Ronavero, Darkhaven Ward",
  "Salefa, Guardian of Water",
  "Pact of the Beast Princess",
  "Angelic Prism Priestess",
  "Reno, Luxwing Featherfolk",
  "Serene Sanctuary",
  "Ironfist Priest",
  "Maeve, Guardian of Earth",
  "Holy Shieldmaiden",
  "Mainyu, Darkdweller",
  "Darkhaven Grace",

  "Marwynn, Repose of Despair",
  "Wilbert, Luminous Paladin",
  "Sarissa, Luxflash Spear",
  "Shiro, Cursed Wings",
  "Cyclical Fate",
  "Perpetual Despair",
  "Adherent of Despair",
  "Zeno, Paradoxical Shield",
  "Crusader's Rallying Cry",
  "Temple Healer",
  "Hermit of Repose",
  "Hardplume Warrior",
  "Caladrius",
  "Sacred Gavel",

  "All-Feeling Divine",
  "Shion, Immortal Aegis",
  "Nekhbet",
  "Impious Bishop",
  "Chamber of Cleansing",
  "Winged Gatekeeper",
  "Boomerang Sister",
  "Spiritual Blow",
  "Twinblade Featherfolk",
  "Fox of Fortune",
  "Pegasus Knight",
  "Al-mi'raj Defender",
  "White Eagle Baptism",

  "Satono Crown",
  "Mejiro Ramonu",
  "Jungle Pocket",
  "Wonder Acute",
  "Mejiro Ardan [Hopeful Petals Dancing in the Night]",
  "Matikanefukukitaru",
  "Mejiro Palmer [Moonlit Devil ♪]",
  "Bring 'Em Home, Please!",

  "Jeanne, Despair's Maiden",
  "Jatelant, God of Prosperity",
  "Lunerian Paladin",
  "Absolute Tolerance",
  "Westmuenster Abbey",
  "Pyne, Twisted Justice",
  "Thornclad Arbiter",
  "Gods' Loving Smite",
  "Charitable Al-mi'raj",
  "Prismawing Featherfolk",
  "Turquoise Sister",
  "Sacred Groundskeeper",
  "Sealed Tome",

  "Rola, Inferno Dragoon",
  "Charaton, Iceflame Priest",
  "Gullias, Silverbeast Lord",
  "Robowhip Reverend",
  "Major Prayers",
  "Holylight Convert",
  "Smilecure Priest",
  "Salvation Ex Limonia",
  "Sol Sister",
  "Robowing Precant",
  "Fortune Fowl",
  "Pilgrims' Path",
  "Fiery Paean",

  "Zoe, Shore's Melody",

  "Selena, Sugarkiss Assassin",
  "Anvelt, Judgment's Cannon",
  "Vengeful Sniper",
  "Paladin of Clemency",
  "Holy Sanctuary",
  "Set",
  "Shady Priest",
  "Haven Fire",
  "Enchanted Knight",
  "Revolver Eagle",
  "Sacred Stone Apostle",
  "Benevolent Blight",
  "Pure Metamorphosis",

  "Goddess of the Full Moon, Tsukuyomi",
  "Goddess of the Half Moon, Tsukuyomi",
  "CEO Amaterasu",
  "Silent Tom",
  "Evil-eye Princess, Euryale",
  "Maiden of Libra",
  "Battle Sister, Cocoa",
  "Oracle Guardian, Wiseman",
  "White Hare of Inaba",
  "Goddess of the Crescent Moon, Tsukuyomi",
  "Dark Cat",
  "Battle Sister, Chocolat",
  "Oracle Guardian, Nike",
  "Dream Eater",
  "Emergency Alarmer",
  "Lozenge Magus",
  "Battle Maiden, Tagitsuhime",
  "Luck Bird",
  "Godhawk, Ichibyoshi",

  "VIII. Sofina, Strength",
  "X. Slaus, Wheel of Fortune",
  "Reverend Adjudicator",
  "Tanzanite Convictor",
  "Somnolent Strength",
  "Topaz Swordian",
  "Puresong Priest",
  "Wheel of Misfortune",
  "Priestess of Foresight",
  "Azurite Maiden",
  "Prismaplume Bird",
  "Stalwart Featherfolk",
  "Holybright Altar",

  "Jeanne, Beacon of Salvation",
  "Tutankhamun",
  "Ceryneian Hind",
  "Heavenly Knight",
  "Tenko's Shrine",
  "Jeweled Priestess",
  "Whitefang Temple",
  "Opposing Statues",
  "Lycaon",
  "Holy Fowl of Ivory",
  "Hexed Fowl of Ebon",
  "Deathscythe Nun",
  "Moriae Encomium",

  "Holylord Eachtar",
  "Godsworn Alexiel",
  "Eidolon of Madness",
  "Sekhmet",
  "Vengeful Radiance",
  "Collete, Holy Gunner",
  "Battlefield Inquisitor",
  "Manifestation of Repose",
  "Malevolent Al-mi'raj",
  "Zealot of Repose",
  "Temple Windbear",
  "Angel of the Iron Steed",
  "Forgotten Sanctuary",

  "Limonia, Flawed Saint",
  "Lapis, Glorious Seraph",
  "Father Refinement",
  "Marione, Light of Balance",
  "Augmentation Bestowal",
  "Bunny-Eared Administrator",
  "Robofalcon",
  "Marcotte, Heretical Sister",
  "Ironknuckle Nun",
  "Dark Bishop",
  "Meowskers, Ruff-Tuff Major",
  "Saintly Core",
  "Meowskers Ambush!",

  "Karin Domyoji",
  "Kako Takafuji",
  "Akane Hino [Positive Passion]",
  "Kaede Takagaki",
  "Shin Sato",
  "Nana Abe",
  "Akane Hino",
  "Classroom Lily",
  "Risa Matoba",
  "Haru Yuuki",
  "Psychic Maiden",
  "Natalia",
  "Shizuku Oikawa",
  "Layla",
  "Sanae Katagiri",
  "Winter Night Prayer",

  "Wilbert, Grand Knight",
  "Karula, Arts Master",
  "Saintly Leader",
  "Phantom Blade Wielder",
  "Manifest Devotion",
  "Holy Lancer",
  "Boost Kicker",
  "Feather Sanctuary",
  "Winged Staff Priestess",
  "Gravity Grappler",
  "Barrage Brawler",
  "Holy Counterattack",
  "Focus",

  "Marwynn, Omen of Repose",
  "Deus Ex Machina",
  "Apostle of Repose",
  "Hakrabi",
  "Ancient Protector",
  "Disciple of Repose",
  "Unidentified Subject",
  "Silver Cog Spinner",
  "Servant of Repose",
  "Demon's Epitaph",
  "The Saviors",
  "Realm of Repose",
  "Ancient Amplifier",
  "Aether of the White Wing",
  "Dark Jeanne",
  "Zoe, Princess of Goldenia",
  "Andromeda",
  "Globe of the Starways",
  "Dark Charisma",
  "Star Priestess",
  "Calydonian Boar",
  "Star Torrent",
  "Starchaser Sprite",
  "Sister of Punishment",
  "Mist Shaman",
  "Octobishop",
  "Candelabra of Prayers",
  "Princess Snow White",
  "Diamond Master",
  "Odette, White Swan",
  "Wingy Chirpy Gemstone",
  "Alice's Adventure",
  "White Knight",
  "Ruby Falcon",
  "March Hare's Teatime",
  "Tin Soldier",
  "Pinion Prince",
  "Birdkeeping Disciple",
  "Amethyst Lion",
  "Bejeweled Shrine",
  "Mejiro McQueen",
  "Gold Ship",
  "Ikuno Dictus",
  "The Will to Overtake",
  "Meisho Doto",
  "Mejiro Ryan",
  "Fate's Forecast",
  "Inari One",
  "Mejiro Dober",
  "Mejiro Ardan",
  "Mejiro Palmer",
  "T.M Opera O",
  "Heavenly Aegis",
  "Enstatued Seraph",
  "Kaguya",
  "Tribunal of Good and Evil",
  "Elana's Prayer",
  "Radiance Angel",
  "Saphire Priestess",
  "Beastcall Aria",
  "Frog Cleric",
  "Sky Sprite",
  "Soul Collector",
  "Sledgehammer Exorcist",
  "Emerald Maiden",
  "Skullfane",
  "Hare of Illusions",
  "Priest of the Cudgel",
  "Acolyte's Light",
  "Dual Flames",
  "Ardent Nun",
  "Guardian Nun",
  "Pinion Prayer",
  "Beastly Vow",
  "Moon Al-mi'raj",
  "Jeanne d'Arc",
  "Arch Priestess Laelia",
  "Themis's Decree",
  "Chorus of Prayer",
  "Sacred Plea",
  "Temple Defender",
  "Prism Priestess",
  "Cleric Lancer",
  "Shrine Knight Maiden",
  "Blackened Scripture",
  "Dark Offering",
  "Holy Sentinel",
  "Cruel Priestess",
  "Sister Initiate",
  "Mainyu",
  "Snake Priestess",
  "Curate",
  "Hallowed Dogma",
  "Guardian Sun",
  "Death Sentence",

  "Eris, Atoned Priestess",
  "Yuwan, Dimensional Avenger",
  "Meowskers, Fluffy Consul",
  "Marlone, Peace Advocate",
  "Vice, Death Grip",
  "Automachina Maiden",
  "Aerial Craft",
  "Balance and Obliteration",
  "Unlikely Fellowship",
  "Steelwing",
  "Technomancer",
  "Android Artisan",
  "Mark Unleashed",
  "Unicorn Altar",

  "Nana Abe [Cinderella Girl]",
  "Kaede Takagaki [Cinderella Girl]",
  "Eve Santaclaus [Holy Night Miracle]",
  "Miyu Mifune [Parfum Géranium]",
  "Kako Takafuji [Lady Luck]",
  "Kotoka Saionji [Pure Euphoria]",
  "Haru Yuuki [Secret Blue Rose]",
  "Natalia [One Thousand and One Nights]",
  "A Sweet Romantic Summer",




  "Colette, Holy Gunner",

  "Wingy, Chirpy Gemstone",

  "Seishiro, Admonishing Faith",
  "Tenmei, Insatiable Adjudicator",
  "Elana, Purest Prayer",
  "Conferrer of Vows",
  "Imina, Mad Eidolon",
  "Unshakable Prayer",
  "Deliverer of Punishment",
  "Lorena, Iron-Willed Priest",
  "Guiding Words",
  "Votary of Contemplation",
  "Mugnier, Purifying Light",
  "Armed Al-mi'raj",
  "Heavenly Hound",
  "Golden Bell",

  "Saren",
  "Nozomi",
  "Akino",
  "Yui",
  "Quria",
  "Yukari",
  "Chika",
  "Misato",
  "Capture String",
  "Mimi",
  "Suzume",
  "Mahiru",
  "Kurumi",
  "Donguri Charge",
  "Nozomi, Chika & Tsumugi",

  "Erralde, Troth Convict",
  "Uneriel, Winged Enforcer",
  "Zoe, Queen of Hope",
  "Warden of the Wings",
  "Executor of the Oath",
  "Meus Gourmand",
  "Agent of the Commandments",
  "Follower of the Precepts",
  "Sacrosanct Temple",
  "Sacred Tiger",
  "Avaricious Altruist",
  "Sword Al-mi'raj",
  "Luminescent Gem",
  "Holybeast Ruins",

  "Marwynn, Despair Manifest",
  "Himeka, Heir to Repose",
  "Holy Serpent's Blessing",
  "Congregant of Repose",
  "Sacred Sheep",
  "Shining Disenchantment",
  "Supplicant of Repose",
  "Temple of Repose",
  "Winged Lion Statue",
  "Knight of the Holy Order",
  "Devotee of Repose",
  "Featherfolk Courier",
  "Peckish Al-mi'raj",
  "Blinding Faith",

  "Verdilia, Rogue Professor",
  "Elluvia, Graceful Lady",
  "Wilbert, Desolate Paladin",
  "Lou, Lady-in-Training",
  "Kira, Resilient Maiden",
  "Orchid's Examination Hall",
  "Pureflame Lady",
  "Kyrie, Fragment of Hope",
  "Pureflower Maiden",
  "Zlatorog",
  "Aqua Priestess",
  "Holy Armored Cheetah",
  "Hierophant's Implements",
  "Sublime Talisman",

  "Clear",
  "Threading Snare",
  "Amped on Acorns",
  "Yui [Princess Form]",

  "God of Curses",
  "Holy Saber",
  "Aether, Guardian of Light",
  "Sacred Lion",
  "Cursed Maiden",
  "Garuda, Winged Sentinel",
  "Carmia, Miracle Optimist",
  "Ascended Prism Priestess",
  "Sonia, Protector of Hope",
  "Holy Kitty",
  "Sacred Ice-Crusher",
  "Tender Rabbit Healer",
  "Khonsu",
  "Forbidden Ritual",
];

export const neutral = [
  "#UNICUS",
  "Close-Knit Ambitions",
  "Drive Point",
  "Harbinger of the Night",
  "Ms. Tart Man",
  "Tazuna Hayakawa [Tracen Reception]",
  "Olivia, Heroic Dark Angel",
  "Ruler of Cocytus",
  "Phildau, Lionheart Ward",
  "Alouette, Doomwright Ward",
  "Leah, Bellringer Angel",
  "Apollo, Heaven's Envoy",
  "Divine Thunder",
  "Doomwright Resurgence",

  "Mjerrabaine, Great One",
  "Gilnelise, Ravenous Craving",
  "Arael",
  "Thunder God of the Tempest",
  "Resolve of the Fallen",
  "Mechanical Analyzer",
  "Messenger of the Skies",
  "Merciless Voiding",
  "Nomadic Conductor",
  "Mountain Gigas",
  "Fluffy Angel",

  "Magna Saber",
  "Flame and Glass, Duality",
  "Glistering Angel",
  "Angel's Blessing",
  "Magna Transformation",
  "Gunslinger Automaton",
  "Ogre Weaponmaster",
  "Stay in Paradise",
  "Brave Goblin",
  "Torchbearing Guide",
  "Goblin Assault",

  "Progenitors and Guides",
  "Balliamo?",
  "Ryoka Tsurugi",

  "Sahaquiel & Israfil",
  "Planetary Fracture",
  "Miriam, Mutinous Being",
  "Grimnir, Voidwrought Wind",
  "Frostfire",
  "Managrocer",
  "Goddess of Rebirth",
  "Dogged Detective",
  "Armored Goblin",
  "Fallen Harpist",
  "Retracing the Past",

  "Natur Al'machinus",
  "Changewing Cherub",
  "Seraphic Blade",
  "Travelers' Respite",
  "Romantic Chanteuse",
  "Giving Gourmet",
  "Goblin Warpack",
  "Plucky Treasure Hunter",
  "Wayfaring Illustrator",
  "We've Got a Case!",

  "Alice, Golden Afternoon",

  "Sylvia, Grand Arbiter",
  "Quixotic Adventurer",
  "Goblin Queen",
  "Embodiment of Cocytus",
  "Wandering Chef",
  "Supercharged Guitarist",
  "Titanic Showdown",
  "Rivaylian Bandit",
  "Vagabond Lizard",
  "Spice Shower",

  "Powers Converged",

  "XXI. Zelgenea, The World",
  "Starbright Deity",
  "Fieran, Havensent Wind God",
  "Fallen Shot",
  "One-Winged Traitor",
  "Mind Splitter",
  "Angelic Strike",
  "Pureshot Angel",
  "Corruption Guardian",
  "Winged Courier",

  "Marduk",
  "Moon and Sun",
  "Paradise Vanguard",
  "Amaterasu",
  "Tsukuyomi",
  "Suttungr",
  "Oceanus",
  "Divine Retribution",
  "Valkyrie of Chaos",
  "Valkyrie of Order",
  "Fount of Angels",

  "Alterplane Arbiter",
  "Sylvia, the Condemner",
  "Sahaquiel",
  "Tart Man",
  "Slash of the One",
  "Reina, Evolution's Herald",
  "Ephemera, Sword Angel",
  "Treasure Map",
  "Steelclad Minotaur",
  "High Enchantress",
  "Happy Pig",

  "Technolord",
  "Viridia Magna",
  "Mechawing Angel",
  "Desert Pathfinder",
  "Maisha, Hero of Purgation",
  "Robogoblin",
  "Colorful Cook",
  "Purgation's Blade",
  "Aldis, Trendsetting Seraph",
  "Mechagun Wielder",
  "Extreme Carrot",

  "New Generations",
  "New Wave",
  "Master Trainer",
  "Expert Trainer",
  "Trainer",
  "Rookie Trainer",

  "Mammoth God's Colosseum",
  "Badb Catha",
  "Mithra, Daybreak Diety",
  "Fall from Grace",
  "Colosseum on High",
  "Chaht, Ringside Announcer",
  "Clash of Heroes",
  "Biofrabrication",
  "Sweet-Tooth Sleuth",
  "Bazooka Goblins",
  "Sentry Gate",

  "Mjerrabaine, Omen of One",
  "Gilnelise, Omen of Craving",
  "Apostle of Craving",
  "Lyrial, Archer Throne",
  "Feena, Dynamite Daredevil",
  "Rosa, Mech Wing Maiden",
  "Enlightenment",
  "Craving's Splendor",
  "Cat Cannoneer",
  "Steel Demolitionist",
  "Gliesaray",
  "Zodiac Demon",
  "Israfil",
  "Grimnir, War Cyclone",
  "Arriet, Soothing Harpist",
  "Staircase to Paradise",
  "Purehearted Singer",
  "Goblin Princess",
  "Mystic Ring",
  "Owlcat",
  "Mr. Full Moon",
  "Night's Way",
  "Alice, Wonderland Explorer",
  "Angel of Chaos",
  "Rapunzel",
  "Seraph of Sin",
  "Garuel, Seraphic Leo",
  "Actress Feria",
  "Humpty Dumpty",
  "Winged Inversion",
  "Angel of Darkness",
  "Harbringer of the Night",
  "Eggsplosion",
  "Tazuna Hayakawa [Traccen Reception]",
  "Riko Kashimoto",
  "Aoi Kiryuin",
  "Riko Kashimoto [Planned Perfection]",
  "Close Knit Ambitions",
  "Take a Jab!",
  "Aoi Kiryuin [Trainers' Teamwork]",
  "Sasami Anshinzawa",
  "Tazuna Hayakawa",
  "Dark Angel Olivia",
  "Bahamut",
  "Demonic Simulacrum",
  "Archangel Reina",
  "Surefire Bullet",
  "Unicorn Dancer Unicorn",
  "Gourmet Emperor Khaiza",
  "Call of Cocytus",
  "Hamsa",
  "Sektor",
  "Dance of Death",
  "Gabriel",
  "Lucifer",
  "Flame and Glass",
  "Urd",
  "Wind God",
  "Gilgamesh",
  "Bellringer Angel",
  "Altered Fate",
  "Path to Purgatory",
  "Lizardman",
  "Goblinmount Demon",
  "Harnessed Flame",
  "Harnessed Glass",
  "Demonic Strike",
  "Execution",
  "Trail of Light",
  "Goblin",
  "Fighter",
  "Goliath",
  "Angelic Sword Maiden",
  "Healing Angel",
  "Angelic Snipe",
  "Angelic Barrage",

  "Maisha, Purgation's Vessel",
  "Great Mother's Embrace",
  "Hoverboard Mercenary",
  "Cosmic Angel",
  "Guild Assembly",
  "Naterra's Future",
  "Unnamed Determination",
  "Aiolon's Remains",

  "Curtain Call of Smiles",

  "Biofabrication",

  "Mithra, Daybreak Deity",

  "Genesis of Legend",
  "Unicorn Dancer Unica",

  "Pulsefire Assault",

  "Bansai Suzuki, Deacon Shinobi",
  "Saito, Mao Ward Officer",
  "Warped Progress",
  "Togh Keyoh, Neometropolis",
  "Stunfist Assassin",
  "A-Class Pyromancy",
  "Cyberglasses Criminal",
  "Third-Class Officer",

  "Omniscient Kaiser",
  "Misora",
  "Lailael",
  "Ameth",
  "Croce",
  "Kasumi",
  "Call of the Guild",
  "Ayumi",

  "Cutthroat, Discord Convict",
  "Eudie, Maiden Reborn",
  "Zerael, Regent of Rebirth",
  "Ironforged Right Hand",
  "Azvaldt",
  "Smeltwork Bodyguard",
  "Warden of Recurrence",
  "Blackrust Underling",

  "Mjerrabaine, Great Manifest",
  "Gilnelise, Voracity Manifest",
  "Dogged One",
  "Inspirational One",
  "Tablet of Tribulations",
  "Apostle of Voracity",
  "Greatness Ascended",

  "Princess Knight",

  "Lucius, Travelled Trainer",
  "Gretina, Champion Fighter",
  "Arriet, Luxvoice Learner",
  "Lainecrest Academy",
  "Goblin Genius",
  "Goblin's Gratitude",

  "Lyrael",

  "Goblin Emperor",
  "Advent of Peace",
  "Feena, Super Cute Hunter",
  "Goblin Leader",
  "Goblin Mage",
];

export const setSD01 = [
  "Aria, Fairy Princess",
  "Titania's Sanctuary",
  "Rose Gardener",
  "Waltzing Fairy",
  "Fairy Caster",
  "Elf Metallurgist",
  "Okami",
  "Treant",
  "Water Fairy",
  "Elf Wanderer",
  "Fairy Circle",
  "Woodland Refuge",
  "Sylvan Justice",
  "Goblin",
  "Angelic Snipe",
  "Angelic Barrage",
];

export const setPR = [
  "Bahamut",
  "Kagemitsu, Matchless Blade",
  "New Year's Soul Devil",
  "Fighter",
  "Harvest Festival",
  "Floral Fencer",
  "Fate's Hand",
  "Conflagration",
  "Phantom Howl",
  "Dark Offering",
  "Alchemist's Workshop",
  "Quickblader",
  "Shapeshifting Mage",
  "Path to Purgatory",
  "Aria, Fairy Princess",
  "Angelic Snipe",
  "Angelic Barrage",
  "Demonic Strike",
  "Trail of Light",
  "Eishin Flash",
  "Trial Initiation",
  "Lamplit Training of a Witch-to-Be",
  "Tamamo Cross",
  "My Solo Drawn to Raindrop Drums",
  "Fate's Forecast",
  "Baalt, King of the Elves",
  "Gunner Maid Seria",
  "Witchbolt",
  "Wildfang Dragonewt",
  "Precious Bloodfangs",
  "Beastcall Aria",
  "Archangel Reina",
  "Vampiric Fortress",
  "Leonidas",
  "Bellringer Angel",
  "Crystalia Tia",
  "Humpty Dumpty",
  "Witch of Calamity, Millie Parfait",
  "Surefire Bullet",
  "Silver Bolt",
  "Elf Bard",
  "Fiery Embrace",
  "Mini Soul Devil",
  "Guardian Sun",
  "Nature's Guidance",
  "Insight",
  "Transmogrified Wyrm",
  "Death's Breath",
  "Execution",
  "Demonium, Punk Devil",
  "Flower Princess",
  "Heroic Entry",
  "Magical Bishop",
  "Skeleton Fighter",
  "Tin Soldier",
  "Eggsplosion",
  "Woodland Band",
  "Unbridled Fury",
  "Red-Hot Ritual",
  "Ambling Wraith",
  "Birdkeeping Disciple",
  "Soul Conversion",
  "Winged Inversion",
  "Falise, Leonardian Mage",
  "Maisy, Red Riding Hood",
  "Sacred Plea",
  "Lucifer",
  "Bladed Hedgehog",
  "Magical Rook",
  "Trinity Dragon",
  "Moriana the Bejeweled",
  "Sledgehammer Exorcist",
  "Elf Song",
  "Gemstaff Commander",
  "Flame Destroyer",
  "Serpent Wrath",
  "Spartoi Sergeant",
  "Frog Cleric",
  "Purehearted Singer",
  "Star Phoenix",
  "Zoe, Princess of Goldenia",
  "Dark Alice",
  "Blessed Fairy Dancer",
  "Fairy Torrent",
  "Round Table Assembly",
  "Magic Owl",
  "Dragon's Nest",
  "Razory Claw",
  "Andromeda",
  "Steel Demolitionist",
  "Safira, Synthetic Beast",
  "Feena, Dynamite Daredevil",
  "Ginsetsu, Great Fox",
  "Fashionista Nelcha",
  "Blazing Breath",
  "Gilnelise, Omen of Craving",
  "Greenwood Guardian",
  "Adept Thief",
  "Shikigami Summons",
  "Whitefrost Whisper",
  "Kasha",
  "Boost Kicker",
  "Acolyte's Light",
  "Kuon, Founder of Onmyodo",
  "Genesis of Legend",
  "Dragonrend Quake",
  "Heavenly Aegis",
  "Cerberus",
  "Shinobu Kudo",
  "Anzu Futaba",
  "Sparkling☆Days",
  "Sae Kobayakawa",
  "Precocious Little Devil",
  "Riamu's Reverie",
  "Sweet Sentiments",
  "Risa Matoba",
  "Natalia",
  "Miku Maekawa",
  "Nagi Hisakawa",
  "Fumika Sagisawa",
  "Assault Jaguar",
  "Grand Acquisition",
  "Golem's Rampage",
  "Mirror of Truth",
  "Seabrand Dragon",
  "Antelope Pelt Warrior",
  "Berserker's Pelt",
  "Gravity Grappler",
  "Fall from Grace",
  "Hulking Giant",
  "Yuzuki, Righteous Demon",
  "Genesis Dragon",
  "Swordsman",
  "Spinaria, Keeper of Enigmas",
  "Dimension Shift",
  "Aenea, Amethyst Rebel",
  "Fairy Dragon",
  "Themis's Decree",
  "Badb Catha",
  "Ghastly Treant",
  "Swift Tigress",
  "Mechanized Lifeform",
  "Whirlwind Pteranodon",
  "Bone Drone",
  "Ironknuckle Nun",
  "Colorful Cook",
  "Mechagun Wielder",
  "Desert Pathfinder",
  "Mechawing Angel",
  "Sekhmet",
  "Ephemera, Sword Angel",
  "Heartless Battle",
  "Swordflash Panther",
  "Summoning Drills",
  "Zealot of Disdain",
  "Gift for Bloodkin",
  "Vengeful Radiance",
  "Summon Bloodkin",
  "Grand Summoning",
  "Colosseum on High",
  "Beastfaced Mage",
  "Monochrome Duel",
  "Happy Pig",
  "Valkyrie of Chaos",
  "Junk",
  "Lupine Axeman",
  "Veridic Discovery",
  "Ouroboros",
  "Unleash the Nightmare",
  "Zealot of Repose",
  "Dragon Oracle",
  "Substitution",
  "Savage Swordsman",
  "Absolute Zeroblade",
  "Dragonclad Blademaster",
  "Salome",
  "Moriae Encomium",
  "Paradise Vanguard",
  "Nonja, Silent Maid",
  "Windflower Tiger",
  "Pompous Summons",
  "Creative Conjurer",
  "Tico, Mysterian Spellnerd",
  "Gallant Dragonewt",
  "Armor Burst",
  "Spirit Curator",
  "Azurite Maiden",
  "Fallen Shot",
  "Runie, Resolute Diviner",
  "Prim, Innocent Princess",
  "Demonium, Clash Devil",
  "Vuella, One-Winged Demon",
  "Tenko's Shrine",
  "Tempered Aether",
  "Dual Rage",
  "Celia, Sky Commander",
  "Magical Augmentation",
  "Stringmaster",
  "Outlaw Gunner",
  "Rivaylian Deputy",
  "Balefire Wrenchsmith",
  "Hazhan, Demonblade Knight",
  "Revolver Eagle",
  "Goblin Queen",
  "Quixotic Adventurer",
  "Greatpick Corpse",
  "Radical Gunslinger",
  "Oldblood King",
  "Michelle, the Mind Reader",
  "Wildfire Tyrannosaur",
  "Dire Bond",
  "Teachings of Creation",
  "Bunny & Baron, Specter Duo",
  "Lucille, Keeper of Relics",
  "Giant Pastures",
  "Chain of Calling",
  "Galua of Two Breaths",
  "Paladin of Clemency",
  "Vagabond Lizard",
  "Primal Giant",
  "Tear Knight, Theo",
  "Tear Knight, Cyprus",
  "Solitary Knight, Gancelot",
  "Barcgal",
  "Jumping Jill",
  "Flame of Promise, Aermo",
  "Flame of Hope, Aermo",
  "Darkness Maiden, Macha",
  "Dark Cat",
  "Purple Trapezist",
  "Blaster Dark",
  "Battle Sister, Cocoa",
  "Leod, the Crescent Blade",
  "Wings of Lust",
  "Mistolina, Forest Princess",
  "Augmentation Bestowal",
  "Oceanus",
  "Fairy Slugger",
  "Resolve of the Nine-Tailed Fox",
  "King's Welcome",
  "Jeno, Fanged Tyrant",
  "Riven Earth",
  "Rockback Ankylosaurus",
  "Howling Conflagration",
  "Mechasaw Deathbringer",
  "Sealed Tome",
  "Lyrial, Archer Throne",
  "Seraphic Blade",
  "Changewing Cherub",
  "Kagero, Swordbound Soul",
  "Send 'Em Packing",
  "Lina & Lena, Twin Souls",
  "Outrunning the Encroaching Heat",
  "Special Week",
  "Fluffy Angel",
  "Piercye, Queen of Frost",
  "Fairy Healer",
  "Hero of the Hunt",
  "Night on the Town",
  "Hermit of Truth",
  "March of the Dragonspring",
  "Undying Resolve",
  "Full Moon Leap",
  "Chamber of Cleansing",
  "Angel's Blessing",
  "Hozumi, Enchanting Hostess",
  "Melvie, Princess Witch",
  "Stay in Paradise",
  "Ardent Torch",
  "Evolution Point",
  "Super-Evolution Point",
  "Leah, Bellringer Angel",
  "Phildau, Lionheart Ward",
  "Apollo, Heaven's Envoy",
  "Lily, Crystalian Innocence",
  "Luminous Lancetrooper",
  "Ms. Miranda, Adored Academic",
  "Marion, Ravishing Dragonewt",
  "Soul Predation",
  "Pact of the Beast Princess",
  "Ceres, Blue Rose Maiden",
  "Serene Sanctuary",
  "Amalia, Luxsteel Paladin",
  "Feybolt Archer",
  "Bumpkin Recruit",
  "Chain Lightning",
  "Whitefrost Blizzard",
  "Sanguine Necklace",
  "Lunerian Paladin",
  "Vodka",
  "Mayano Top Gun",
  "Aiela, Devoted Knight",
  "Lishenna, Melodious Destruction",
  "Aerin, Crystalian Frostward",
  "Juno, Visionary Alchemist",
  "Fan of Otohime",
  "Salefa, Guardian of Water",
  "Acid Golem",
  "Regal Wildcat",
  "Baby Carbuncle",
  "Crystalia Lily",
  "Resolve of the Fallen",
  "Fieran, Havensent Wind God",
  "Total Domination",
  "Aenea, Creative Amethyst",
  "Forte, Blackwing Dragoon",
  "Airi Totoki [Anniversary Princess]",
  "Anastasia [All-Out Vacation]",
  "Miku Maekawa [Summer Cat Rendezvous]",
  "Summer Sea Breeze",
  "Miho Kohinata [Summer Firsts]",
  "Mio Honda [Mermaid Star]",
  "Beachside Memories",
  "Summer Encounter",
  "Heroic Resolve",
  "Sunny Day Encounter",
  "Fruits of Wisdom",
  "Newfound Allies",
  "Steeled Hopes",
  "Unlikely Fellowship",
  "Amy, Psychopomp Guide",
  "Friendly Embrace",
  "Bladerights Lieutenant",
  "Roly-Poly Mk II",
];

export const setSS02 = [
  "Fafnir",
  "Dragon Oracle",
  "Dragon Warrior",
  "Dragonewt Princess",
  "Dragonguard",
  "Fire Lizard",
  "Dread Dragon",
  "Roc",
  "Glint Dragon",
  "Dragonrider",
  "Seabrand Dragon",
  "Blazing Breath",
  "Dragon Wings",
  "Goliath",
  "Angelic Sword Maiden",
  "Angelic Snipe",
  "Force of the Dragonewt",
  "Conflagration",
  "Serpent Wrath",
  "Dragon's Nest",
  "Dragon's Handspur",
  "Pulsefire Assault",
];

export const setSS01 = [
  "Tsubaki",
  "Latham, Vanguard Captain",
  "Floral Fencer",
  "Moonlight Assassin",
  "White General",
  "Ninja Trainee",
  "Veteran Lancer",
  "Fencer",
  "Oathless Knight",
  "Quickblader",
  "Forge Weaponry",
  "Onslaught",
  "Unbridled Fury",
  "Goblin",
  "Fighter",
  "Angelic Sword Maiden",
  "Monochrome Duel",
  "Queen Hemera the White",
  "Queen Magnus the Black",
  "Savage Swordsman",
  "Novice Trooper",
  "Pulsefire Assault",
];

export const setGFB01 = [
  "Aurelia, Regal Saber",
  "Albert, Levin Saber",
  "Alexander",
  "Gawain of the Round Table",
  "Gabriel",
  "Dark Angel Olivia",
  "Genesis of Legend",
  "Latham, Vanguard Captain",
  "Amelia, Silver Paladin",
  "Leonidas",
  "Cyclone Blade",
  "Confront Adversity",
  "Wingy, Chirpy Gemstone",
  "Archangel Reina",
  "Lyrial, Archer Throne",
  "Dolorblade Demon",
  "Floral Fencer",
  "Maid Leader",
  "Gemstaff Commander",
  "Swordsman",
  "Disciple of Usurpation",
  "Fervent Machine Soldier",
  "Whole-Souled Swing",
  "Round Table Assembly",
  "Freshman Lou",
  "Soul Conversion",
  "Acolyte's Light",
  "Unicorn Dancer Unica",
  "Purehearted Singer",
  "Rosa, Mech Wing Maiden",
  "Archer",
  "Fita the Gentle Elf",
  "Quickblader",
  "Swift Infiltrator",
  "Gunner Maid Seria",
  "Bladed Hedgehog",
  "Tristan of the Round Table",
  "Craig, Wizard of Mysteria",
  "Mini Soul Devil",
  "Demon's Epitaph",
  "Deepwood Anomaly",
  "Wordwielder Ginger",
  "Jabberwock",
  "Dark Alice",
  "Bahamut",
  "Zodiac Demon",
  "Grand Summoning",
  "Dragonrend Quake",
  "Robin Hood",
  "Frontguard General",
  "Barbarossa",
  "Aiela, Dragon Knight",
  "Genesis Dragon",
  "Phoenix Roost",
  "Tilting at Windmills",
  "Surefire Bullet",
  "Geno, Machine Artisan",
  "Demonflame Mage",
  "Wyvern Cavalier",
  "Master of Draconic Arts",
  "Cetus",
  "Amethyst Giant",
  "Serpent Wrath",
  "Death's Breath",
  "Prism Priestess",
  "Silver Cog Spinner",
  "Goblinmount Demon",
  "Execution",
  "Starry Elf",
  "Mark of the Six",
  "Pollux",
  "Armor of the Stars",
  "Hippocampus",
  "Scaled Berserker",
  "Curate",
  "Mist Shaman",
  "Realm of Repose",
  "Merlin",
  "Giant Chimera",
  "Cerberus",
  "Venomfang Medusa",
  "Flame and Glass",
  "Israfil",
  "Star Reader Stella",
  "Rimewind",
  "Dragon Oracle",
  "Medusa",
  "Azazel",
  "Odile, Black Swan",
  "Zoe, Princess of Goldenia",
  "Bellringer Angel",
  "Mr. Heinlein, Shadow Mage",
  "Insight",
  "Fate's Hand",
  "Truth's Adjudication",
  "Shenlong",
  "Hell's Unleasher",
  "Dark Offering",
  "Harnessed Flame",
  "Harnessed Glass",
  "Trail of Light",
  "Call of Cocytus",
  "Penguin Wizard",
  "Wind Blast",
  "Sorcery Cache",
  "Fiery Embrace",
  "Witchbolt",
  "Spartoi Sergeant",
  "Undead King",
  "Bone Chimera",
  "Undying Resentment",
  "Imperial Dragoon",
  "Jeanne d'Arc",
  "Heavenly Aegis",
  "Princess Snow White",
  "Aether of the White Wing",
  "Lucifer",
  "Odette, White Swan",
  "Apostle of Repose",
  "Hakrabi",
  "Themis's Decree",
  "Sacred Plea",
  "Globe of the Starways",
  "Ancient Protector",
  "Path to Purgatory",
  "Iron Staff Mechanic",
  "Priest of the Cudgel",
  "Radiance Angel",
  "Disciple of Repose",
  "Blackened Scripture",
  "Beastcall Aria",
  "Blazing Breath",
  "Dragon's Nest",
  "Snake Priestess",
  "Servant of Repose",
  "Death Sentence",
];

export const setGFD02 = [
  "Kagemitsu, Matchless Blade",
  "Sweet-Tooth Medusa",
  "Azi Dahaka",
  "Karula, Arts Master",
  "Dark Angel Olivia",
  "Badb Catha",
  "Regal Wildcat",
  "Ouroboros",
  "Dragon Oracle",
  "Lightning Blast",
  "Underworld Watchman Khawy",
  "Bellringer Angel",
  "Mithra, Daybreak Deity",
  "Tart Man",
  "Fall from Grace",
  "Maid Leader",
  "Veridic Discovery",
  "Vile Violet Dragon",
  "Roy, Dragoncleaver",
  "Shenlong",
  "Conflagration",
  "Serpent Wrath",
  "Dragonewt Fist",
  "Boost Kicker",
  "Marcotte, Heretical Sister",
  "Colette, Holy Gunner",
  "Battlefield Inquisitor",
  "Acolyte's Light",
  "Purehearted Singer",
  "Execution",
  "Fita the Gentle Elf",
  "Armor of the Stars",
  "Witch of Sweets",
  "Witchbolt",
  "Presto Chango",
  "Silver Automaton",
  "Geovore",
  "Blazing Breath",
  "Frogbat",
  "Realm of Repose",
];

export const setGFD01 = [
  "Ancient Elf",
  "Cosmos Fang",
  "Spinaria, Keeper of Enigmas",
  "Forest Oracle Pascale",
  "Lucifer",
  "Sylvia, the Condemner",
  "Rhinoceroach",
  "Slade, Blossoming Wolf",
  "Setus, the Beastblade",
  "Homecoming",
  "Spring-Green Protection",
  "Hare of Illusions",
  "Sacred Plea",
  "Globe of the Starways",
  "Elven Princess Mage",
  "Gerbera Bear",
  "Michelle, the Mind Reader",
  "Nature's Guidance",
  "Blessings of Creation",
  "Harvest Festival",
  "Maid Leader",
  "Freshman Lou",
  "Insight",
  "Soul Conversion",
  "Prism Priestess",
  "Dark Offering",
  "Rosa, Mech Wing Maiden",
  "Mystic Ring",
  "Biofabrication",
  "Elf Bard",
  "Tweedle Dum, Tweedle Dee",
  "Starry Elf",
  "Floral Breeze",
  "Flower of Fairies",
  "Elegance in Action",
  "Craig, Wizard of Mysteria",
  "Blazing Breath",
  "Dragon's Nest",
  "Hallowed Dogma",
];

export const setSDD06 = [
  "Godsworn Alexiel",
  "Zoe, Shore's Melody",
  "Sekhmet",
  "Themis's Decree",
  "Vengeful Radiance",
  "Sacred Plea",
  "Globe of the Starways",
  "Prism Priestess",
  "Dark Offering",
  "Candelabra of Prayers",
  "Moriae Encomium",
  "Sacred Gavel",
  "XXI. Zelgenea, The World",
  "Paradise Vanguard",
];

export const setSDD05 = [
  "VI. Milteo, The Lovers",
  "Iceschillendrig, Gilded Autocrat",
  "Illganeau, Horror Astray",
  "Demonlord Eachtar",
  "Doublame, Duke and Dame",
  "Greatpick Corpse",
  "Kagero, Swordbound Soul",
  "Chris, Beyond the Patch",
  "Dead to Rights",
  "Wretch",
  "Wretched Tryst",
  "Soulstrike",
  "Grave Desecration",
  "Skeleton Dreamer",
  "Wandering Chef",
];

export const setSDD04 = [
  "Filene, Whitefrost Dragonewt",
  "XI. Erntz, Justice",
  "Jerva, Wyrm Transcendent",
  "Wildfire Tyrannosaur",
  "Dragon-Devouring Dread",
  "Frostbite Dragon",
  "Dragon Oracle",
  "Whitefrost Whisper",
  "Whitefrost Blizzard",
  "Roy, Dragoncleaver",
  "Azureflame Dragonewt",
  "Pumpkin Dragon",
  "Orbed Cancer",
  "Thunderous Roar",
];

export const setSDD03 = [
  "Sweet-Tooth Medusa",
  "Ceridwen, Eternity Hunter",
  "Faust, Truthseeker",
  "Ancient Alchemist",
  "Riley, Hydroshaman",
  "Acid Golem",
  "Artistic Arcanist",
  "Price of Magic",
  "Gingerbread House",
  "Summoning Drills",
  "Rabbit Mage",
  "Beastfaced Mage",
  "Teachings of Creation",
  "Red-Hot Ritual",
  "Witch's Cauldron",
  "Mirror of Truth",
  "Grand Spire",
];

export const setSDD02 = [
  "Ralmia, Sonic Racer",
  "Nahtnaught, Cursed Queen",
  "Bunny & Baron, Specter Duo",
  "Leod, the Crescent Blade",
  "Prudent General",
  "Radical Gunslinger",
  "Tyrant's Order",
  "Outlaw Gunner",
  "Desperados' Shot",
  "Naht's Henchman",
  "Godsent Stride",
  "Quixotic Adventurer",
  "Rivaylian Bandit",
  "Vagabond Lizard",
];

export const setSDD01 = [
  "Amataz, Fairy Blader",
  "Cynthia, the Queen's Blade",
  "Spinaria, Wavering Will",
  "Aria, Miasma Fairy",
  "Fashionista Nelcha",
  "Titania's Sanctuary",
  "Blessed Fairy Dancer",
  "Sukuna, Brave and Small",
  "Sunbright Elf",
  "Nature's Guidance",
  "Elf Song",
  "Spiritshine",
  "Tree of Wonders",
  "Fairy Slugger",
  "Feybolt Archer",
  "Fairy Circle",
];

export const setSD06 = [
  "Skullfane",
  "Hare of Illusions",
  "Priest of the Cudgel",
  "Acolyte's Light",
  "Dual Flames",
  "Cruel Priestess",
  "Snake Priestess",
  "Ardent Nun",
  "Guardian Nun",
  "Hallowed Dogma",
  "Death Sentence",
  "Pinion Prayer",
  "Beastly Vow",
  "Angelic Sword Maiden",
  "Healing Angel",
  "Angelic Snipe",
];

export const setSD05 = [
  "Queen Vampire",
  "Alucard",
  "Playful Necromancer",
  "Midnight Vampire",
  "Night Horde",
  "Spectre",
  "Spartoi Sergeant",
  "Undead King",
  "Lesser Mummy",
  "Lilith",
  "Razory Claw",
  "Undying Resentment",
  "Summon Bloodkin",
  "Fighter",
  "Goliath",
  "Angelic Sword Maiden",
];

export const setSD04 = [
  "Fafnir",
  "Dragon Oracle",
  "Dragon Warrior",
  "Dragonewt Princess",
  "Dragonguard",
  "Fire Lizard",
  "Dread Dragon",
  "Roc",
  "Glint Dragon",
  "Dragonrider",
  "Seabrand Dragon",
  "Blazing Breath",
  "Dragon Wings",
  "Goliath",
  "Angelic Sword Maiden",
  "Angelic Snipe",
];

export const setSD03 = [
  "Mythril Golem",
  "Rune Blade Summoner",
  "Demonflame Mage",
  "Insight",
  "Fire Chain",
  "Lightning Shooter",
  "Penguin Wizard",
  "Sammy, Wizard's Apprentice",
  "Wind Blast",
  "Sorcery Cache",
  "Fiery Embrace",
  "Magic Missile",
  "Conjure Golem",
  "Healing Angel",
  "Angelic Snipe",
  "Angelic Barrage",
];

export const setSD02 = [
  "Tsubaki",
  "Latham, Vanguard Captain",
  "Floral Fencer",
  "Moonlight Assassin",
  "White General",
  "Ninja Trainee",
  "Veteran Lancer",
  "Fencer",
  "Oathless Knight",
  "Quickblader",
  "Forge Weaponry",
  "Onslaught",
  "Unbridled Fury",
  "Goblin",
  "Fighter",
  "Angelic Sword Maiden",
];

export const set18 = [
  "Rolo Rone, Verdant Purifier",
  "Kyou, Verdant Path Shepherd",
  "Tia, Crystalian Noble",
  "Verdant Authority Caretaker",
  "May, Eager Elf",
  "Sprouting Retribution",
  "Verdant City Pugilist",
  "Blossoming Lunerian",
  "Sowing Paradise",
  "Verdant Law Supplicant",
  "Milolo, Li'l Mountain Lass",
  "Rayne, Elf Smith",
  "Furious Mountain Deity",
  "Airbound Barrage",
  "Shinra, All-Discerning",
  "Gamma, Canine Mediator",
  "Gawain, Oath to Glory",
  "Bird's-Eye Investigator",
  "Darksaber Melissa",
  "Gigabyte Blade",
  "Cold Case Analyst",
  "Lucius, Sellsword",
  "Unorthodox Assistance",
  "Blind Spot Surveyor",
  "Monika, Cloudhall Admiral",
  "Princess Teena",
  "Holy Bear Knight",
  "Luminous Standard",
  "Mana, Sterling Luster",
  "Francoise, Bejeweled Manager",
  "Ginger, Accursed Word",
  "Bejeweled Supermodel",
  "Aleister, Argenteum Astrum",
  "Brilliant Cut",
  "Bejeweled Advisor",
  "Mari, Card Conjurer",
  "Clandestine Dealings",
  "Bejeweled Bouncer",
  "Carbuncle of Mysteria",
  "Illusionist",
  "Enchanted Sword",
  "Authoring Tomorrow",
  "El, Destructive Dragon",
  "Tenka, Hot-Blooded Vice-Prez",
  "Fafnir, Cunning Wyrm",
  "Dragon-Eyed Secretary",
  "Prophetic Dragon",
  "After-School Break",
  "Neon-Tailed Prefect",
  "Ian, Dragon Buster",
  "Red-Winged Admissions Gift",
  "Lightning-Clawed Loafer",
  "Serpent Drake",
  "Draconic Mercenary",
  "Estrella Beast",
  "Orca Run",
  "Ilze & Urze, Centennial Reapers",
  "Vedd, Burial Wolf",
  "Vania, Crimson Majesty",
  "Covetous Serpent",
  "Veight, Twilit Highborn",
  "Crescent Moon of Centennial Death",
  "Exhumation Crow",
  "Full Moon of Centennial Demise",
  "Vampire Queen's Castle",
  "Gnawing Rat",
  "Beryl, Dreameater",
  "Prince Catacomb",
  "Bloodthirsty Hamster",
  "Nightscreech",
  "Seishiro, Admonishing Faith",
  "Tenmei, Insatiable Adjudicator",
  "Elana, Purest Prayer",
  "Conferrer of Vows",
  "Imina, Mad Eidolon",
  "Unshakable Prayer",
  "Deliverer of Punishment",
  "Lorena, Iron-Willed Priest",
  "Guiding Words",
  "Votary of Contemplation",
  "Mugnier, Purifying Light",
  "Armed Al-mi'raj",
  "Heavenly Hound",
  "Golden Bell",
  "Bansai Suzuki, Deacon Shinobi",
  "Saito, Mao Ward Officer",
  "Warped Progress",
  "Togh Keyoh, Neometropolis",
  "Stunfist Assassin",
  "A-Class Pyromancy",
  "Cyberglasses Criminal",
  "Third-Class Officer",
];

export const set04 = [
  "Kokkoro",
  "Eris",
  "Nephi=Nela",
  "Shiori",
  "Anemone",
  "Makoto",
  "Rino",
  "Kururu",
  "Nea",
  "Lima",
  "Aoi",
  "Nebbia",
  "Suzuna",
  "Aurora Healing",
  "Pecorine",
  "Christina",
  "Labyrista",
  "Jun",
  "Riri",
  "Creditta",
  "Tomo",
  "Shizuru",
  "Ruka",
  "Tamaki",
  "Mitsuki",
  "Matsuri",
  "Ninon",
  "Princess Strike",
  "Karyl",
  "Yuni",
  "Neneka",
  "Maho",
  "Precia",
  "The Shared Illusion of Truth and Existence",
  "Kyoka",
  "Chieru",
  "Chloe",
  "Yuki",
  "Hatsune",
  "Nanaka",
  "Cheru Cheru☆Carnival",
  "Dark Eclipse",
  "Sheffy",
  "Homare",
  "Muimi",
  "Kaya",
  "Hiyori",
  "Someday, We'll Meet Again in the Future",
  "Inori",
  "Lind",
  "Wyrm",
  "Mifuyu",
  "Kaori",
  "Ayane",
  "Dragon's End Fist",
  "Prank Declaration",
  "Illya",
  "Ranpha",
  "Violet",
  "Shinobu",
  "Grace",
  "Rei",
  "Yori",
  "Akari",
  "Miyako",
  "Misaki",
  "Kuuka",
  "Io",
  "Eriko",
  "Infinite Break - Code: Null",
  "Saren",
  "Nozomi",
  "Akino",
  "Yui",
  "Quria",
  "Yukari",
  "Chika",
  "Misato",
  "Capture String",
  "Mimi",
  "Suzume",
  "Mahiru",
  "Kurumi",
  "Donguri Charge",
  "Omniscient Kaiser",
  "Misora",
  "Lailael",
  "Ameth",
  "Croce",
  "Kasumi",
  "Call of the Guild",
  "Ayumi",
  "Yuni, Chloe & Chieru",
  "Ranpha & Misora",
  "Nozomi, Chika & Tsumugi",
];

export const set20 = [
  "Izudia, Annihilation Manifest",
  "Krulle, Heir to Unkilling",
  "Plumeria, Serene Goddess",
  "Windbloom Sylph",
  "Congregrant of Unkilling",
  "Eradicating Arrow",
  "Supplicant of Unkilling",
  "Greatwood Warrior",
  "Hamlet of Unkilling",
  "Bearer of the Fairy Blade",
  "Devotee of Unkilling",
  "Ageless Bystander",
  "Cutie Cat",
  "Bestial Swipe",
  "Octrice, Hollowness Manifest",
  "Sinciro, Heir to Usurpation",
  "Aurelia, Glorious Saber",
  "Congregant of Usurpation",
  "Fearful Fighter",
  "Returning Slash",
  "Peppy Scout",
  "Supplicant of Usurpation",
  "Lair of Usurpation",
  "Comrade of the Swordmaster",
  "Devotee of Usurpation",
  "Mercurial Mercenary",
  "Palace Knight",
  "Shield Bash",
  "Lishenna, Melody Manifest",
  "Velharia, Heir to Truth",
  "Axia, Heir to Destruction",
  "Raio, Elimination Manifest",
  "Congregant of Destruction",
  "Devastating Soprano",
  "Congregant of Truth",
  "Supplicant of Destruction",
  "Illusory Conjuration",
  "Devotee of Destruction",
  "Supplicant of Truth",
  "Devotee of Truth",
  "Ascetic of Wuxing",
  "Wasteland of Destruction",
  "Galmieux, Ardor Manifest",
  "Azurifrit, Heir to Disdain",
  "Dagon, Lord of the Seas",
  "Spoiled Mermanager",
  "Congregant of Disdain",
  "Ferocious Flame",
  "Supplicant of Disdain",
  "Encounter from the Deep",
  "Nation of Disdain",
  "Snowstorm Dragonewt",
  "Devotee of Disdain",
  "Militant Mermaid",
  "Ocean Rider",
  "Raging Lightning",
  "Rulenye & Valnareik",
  "Sham-Nacha, Heir to Entwining",
  "Diabolus Hedone",
  "Congregant of Entwining",
  "Hervör",
  "Screaming and Loathing",
  "Spirited Gravekeeper",
  "Supplicant of Entwining",
  "Castle of Entwining",
  "Ephemeral Demon Princess",
  "Devotee of Entwining",
  "Wicked Collector",
  "Nemean Lion",
  "March of the Brutes",
  "Marwynn, Despair Manifest",
  "Himeka, Heir to Repose",
  "Holy Serpent's Blessing",
  "Congregant of Repose",
  "Sacred Sheep",
  "Shining Disenchantment",
  "Supplicant of Repose",
  "Temple of Repose",
  "Winged Lion Statue",
  "Knight of the Holy Order",
  "Devotee of Repose",
  "Featherfolk Courier",
  "Peckish Al-mi'raj",
  "Blinding Faith",
  "Mjerrabaine, Great Manifest",
  "Gilnelise, Voracity Manifest",
  "Dogged One",
  "Inspirational One",
  "Tablet of Tribulations",
  "Apostle of Voracity",
  "Greatness Ascended",
  "Lishenna, Omen of Destruction",
];

export const set19 = [
  "Magachiyo, Barbed Convict",
  "Wimael, Redolent Enforcer",
  "Zwei, Symphonic Heart",
  "Verdant Lieutenant",
  "Warden of Balms",
  "Synchronous Hearts",
  "Budding Initiate",
  "Leafshade Assassin",
  "Puppet Workout",
  "Beast Lancer",
  "Merchant of the Wood",
  "Rogue Puppeteer",
  "Support Troop Elf",
  "Galepierce",
  "Barbaros, Briny Convict",
  "Radiel, Valorous Enforcer",
  "Gildaria, Anathema of Peace",
  "Warden of Honor",
  "Tidal Gunner",
  "Prim, Princess's Picnic",
  "Storm-Wracked First Mate",
  "Deep-Sea Scout",
  "Return from the Brink",
  "Felpurr Maid",
  "Knightly Thief",
  "Heavy Warrior",
  "Ninja Onslaught",
  "Cannon Volley",
  "Sephie, Depraved Convict",
  "Simael, Cleansing Enforcer",
  "Kyrzael, Killshot Enforcer",
  "Obsessive Scholar",
  "Warden of the Trigger",
  "Warden of the Arcane",
  "Devoted Researcher",
  "Volunteer Test Subject",
  "Astral Dancer",
  "Electrokitty",
  "Outdoorsmage",
  "Ultramarine Witch",
  "Feline Magic",
  "Meandering Bolt",
  "Antemaria, Huntress Convict",
  "Drazael, Ravening Enforcer",
  "Masamune, One-Eyed Dragon",
  "Scorched-Earth Tyrant",
  "Neptune, Arbiter of Tides",
  "Warden of the Adamant Claw",
  "Hotheaded Marauder",
  "Razor-Clawed Thief",
  "Seasoned Merman",
  "Dancing Crab",
  "Mermaid Songstress",
  "Dark Mermaid",
  "Dragonewt's Might",
  "Call of the Megalorca",
  "Istyndet, Soul Convict",
  "Garodeth, Insurgent Convict",
  "Zeronua, Demon of Domination",
  "Abyssal Colonel",
  "Myroel, Death Enforcer",
  "Genomuel, Wyrm Enforcer",
  "Underworld Lieutenant",
  "Warden of Corpses",
  "Raging Commander",
  "Vicious Blitzer",
  "Fallen Sergeant",
  "Steamrolling Tank",
  "Howling Scream",
  "Prison of Pain",
  "Erralde, Troth Convict",
  "Uneriel, Winged Enforcer",
  "Zoe, Queen of Hope",
  "Warden of the Wings",
  "Executor of the Oath",
  "Meus Gourmand",
  "Agent of the Commandments",
  "Follower of the Precepts",
  "Sacrosanct Temple",
  "Sacred Tiger",
  "Avaricious Altruist",
  "Sword Al-mi'raj",
  "Luminescent Gem",
  "Holybeast Ruins",
  "Cutthroat, Discord Convict",
  "Eudie, Maiden Reborn",
  "Zerael, Regent of Rebirth",
  "Ironforged Right Hand",
  "Azvaldt",
  "Smeltwork Bodyguard",
  "Warden of Recurrence",
  "Blackrust Underling",
];

export const set01 = [
  "Anne, Mysterian Prodigy",
  "Grea, Mysterian Dragoness",
  "Mysteria, Magic Founder",
  "Owen, Knight of Mysteria",
  "Star Reader Stella",
  "Anne's Sorcery",
  "Grea's Ember",
  "Vayle, Mysterian Summoner",
  "Palla, Student Teacher",
  "Freshman Lou",
  "Mysterian Knowledge",
  "Mr. Bertrand, Magic Mentor",
  "Craig, Wizard of Mysteria",
  "Tico, Mysterian Spellnerd",
];

export const set21 = [
  "Castelle, Budding Mage",
  "Lyelth, Immaculate Idol",
  "Titania, Queen of Fairies",
  "Cleaver Cat",
  "Cynthia, Chivalrous Elf",
  "Dwarven Lumberjack",
  "Elven Farmhand",
  "Fauna Handler",
  "Fairy Funfact",
  "Bladebunny",
  "Vanguard Tigress",
  "Flying Mistletoe Squirrel",
  "Spiritelementalist",
  "Wild Profusion",
  "Lecia & Nano, Twilight Trainees",
  "Galdr, Heroic Headmaster",
  "Yurius, Levin Authority",
  "Agile Twinblader",
  "Weiss, Discerning Professor",
  "Twilight and Silver",
  "Tony, Plucky Polliwog",
  "Deadeye Trainee",
  "Sharp Strategist",
  "Kitty Sergeant",
  "Fervent Fist-Fighter",
  "Levin Archer",
  "Aggressive Advance",
  "Lieutenant's Report",
  "Amaryllis, the Princess",
  "Anne, Brilliant Mage",
  "Ceridwen, Eternal Duality",
  "Grea, Crimson Promise",
  "Mysterian Exchange Party",
  "Mystic Rune",
  "Gruinne, Leonardian Provost",
  "Leeds, Pining Witch",
  "Bell Witch",
  "Wolf Whisperer",
  "Evamia, Spinner of Threads",
  "Arcane Instruction",
  "Aqueous Sphere",
  "Binding Ritual",
  "Lilium, the Wyrmwitch",
  "Coach Joe, Fiery Counselor",
  "Lumiore, Prestigious Gold",
  "Grand Slam Tamer",
  "Dion, Scarlet Scion",
  "Argente, Purest Silver",
  "Dragonborn Striker",
  "Gunbein, Lofty Dragonewt",
  "Charlotte, Dragonewt",
  "Ipupiara",
  "Megalorca Rider",
  "Augite Wyrm",
  "Stormscale",
  "Dragon Hunt",
  "Cornelius, the Corpse King",
  "Galom, Empress Fist",
  "Vulgus, Infernal Headmistress",
  "Arka, Sin Spinner",
  "Exella, Nocturnal General",
  "Bad-Girl Life",
  "Mach-Speed Maron",
  "Demon-Eyed Gangster",
  "Noble Demoness",
  "Bonebreaker Bladesman",
  "Denan, Big Bad Boss",
  "Malicious Blader",
  "Serenading Succubus",
  "Spirit Invasion",
  "Verdilia, Rogue Professor",
  "Elluvia, Graceful Lady",
  "Wilbert, Desolate Paladin",
  "Lou, Lady-in-Training",
  "Kira, Resilient Maiden",
  "Orchid's Examination Hall",
  "Pureflame Lady",
  "Kyrie, Fragment of Hope",
  "Pureflower Maiden",
  "Zlatorog",
  "Aqua Priestess",
  "Holy Armored Cheetah",
  "Hierophant's Implements",
  "Sublime Talisman",
  "Lucius, Travelled Trainer",
  "Gretina, Champion Fighter",
  "Arriet, Luxvoice Learner",
  "Lainecrest Academy",
  "Goblin Genius",
  "Goblin's Gratitude",
];

export const set03 = [
  "Cerberus, Hellfire Unleashed",
  "Gold Rush Ghost",
  "Rulenye, Screaming Silence",
  "Gremory, Death Teller",
  "Iceschillendrig, Gilded Autocrat",
  "Illganeau, Horror Astray",
  "Kagero, Swordbound Soul",
  "Chris, Beyond the Patch",
  "Odile, Black Swan",
  "Dead to Rights",
  "Wretch",
  "Soulstrike",
  "Wretched Tryst",
  "Grave Desecration",
  "Wandering Chef",
  "Adherent of Screams",
];

export const set02 = [
  "Yukishima, Master Biographer",
  "Daria, Infinity Witch",
  "Falise, Innocent Sea Spray",
  "Merlin",
  "Story of a Lifetime",
  "Dimension Shift",
  "Grimoire Sorcerer",
  "Chaos Wielder",
  "Riven Earth",
  "Truth's Adjudication",
  "Concentration",
  "Fire Chain",
  "Crystal Fencer",
  "Beastfaced Mage",
  "Chain Lightning",
  "Mystic Absorption",
];

export const set08 = [
  "Forte, Blackwing Dragoon",
  "Forte, Sovereign Supreme",
  "XI. Erntz, Justice",
  "Jerva, Wyrm Transcendent",
  "XXI. Zelgenea, The World",
  "Liu Feng, Goldennote Ward",
  "Dragon-Devouring Dread",
  "Dragon Oracle",
  "Zahar, Stormwave Dragoon",
  "Azureflame Dragonewt",
  "Roy, Dragoncleaver",
  "Draconic Call",
  "Orbed Cancer",
  "Pumpkin Dragon",
  "Blazing Breath",
  "Dragon's Nest",
];

export const set07 = [
  "Albert, Levin Stormsaber",
  "Albert, Thunderous Doom",
  "Nahtnaught, Cursed Queen",
  "Aether of the Warrior Wing",
  "Albert, Levin Saber",
  "Zirconia, Ironcrown Ward",
  "Tsubaki of the Demon Blade",
  "Levin Justice",
  "Jeno, Levin Axeraider",
  "Lounes, Levin Apprentice",
  "Jeno, Fanged Tyrant",
  "Yurius, Levin Duke",
  "Mina, Levin Vice Leader",
  "Mona, Levin Mage",
  "Mena, Levin Duelist",
  "Meet the Levin Sisters!",
];

export const set22 = [
  "Brilliant Fairy",
  "Noxious Elf",
  "Aerin, Forever Brilliant",
  "Flower Fox",
  "King of Vines",
  "Blast Fairy",
  "Wellspring Elf Princess",
  "Aqua Fairy",
  "Lily, Crystalian Conductor",
  "Coldhearted Dark Elf",
  "Fairy Bringer",
  "Wily Puck",
  "Dungeoncrawl Fairy",
  "Seed Barrage",
  "Victorious Blader",
  "Golden Warrior",
  "Armelize, Opulent Strategist",
  "Assault Knight",
  "Fangblade Slayer",
  "Claymore Master",
  "Axe Pirate",
  "Armed Butler",
  "Shield Phalanx",
  "Calculating Captain",
  "Suave Bandit",
  "Sword-Swinging Bandit",
  "Resplendent Knight",
  "Wandering Knight",
  "Chrono Witch",
  "Pursuer Golem",
  "Levi, Wizard of Ages",
  "Witching Moggy",
  "Great Magician",
  "Lazuli, Gateway Homunculus",
  "Elina, Winged Evangelist",
  "Parasol Witch",
  "Carnelia, Servant of Darkness",
  "Blade Mage",
  "Frost Golem",
  "Iceshard Beast",
  "Golem Assault",
  "Mirrored Summoning",
  "Ignis Dragon",
  "Brutal Dragonewt",
  "Giselle, Ocean Star",
  "Noir & Blanc, Brothers",
  "Bejeweled Dragon",
  "Ethica, Firebrand Claw",
  "Coral Spirit",
  "Shield Dragon",
  "Piercing Roar",
  "Hailwyrm",
  "Ironscale Serpent Drake",
  "Electrodrake",
  "Breath of the Salamander",
  "Canyon of the Dragons",
  "Skeleton Raider",
  "Dark Emperor",
  "Cernunnos",
  "Suzy, Hexcaster",
  "Dog of the Dead",
  "Goblin Reaper",
  "Scarlet Vampire",
  "Deathcat Reaper",
  "Huginn & Muninn",
  "Thunderbolt Fiend",
  "Lurching Corpse",
  "Goblin Zombie",
  "Bubbly Reaper",
  "Undead Stampede",
  "God of Curses",
  "Holy Saber",
  "Aether, Guardian of Light",
  "Sacred Lion",
  "Cursed Maiden",
  "Garuda, Winged Sentinel",
  "Carmia, Miracle Optimist",
  "Ascended Prism Priestess",
  "Sonia, Protector of Hope",
  "Holy Kitty",
  "Sacred Ice-Crusher",
  "Tender Rabbit Healer",
  "Khonsu",
  "Forbidden Ritual",
  "Goblin Emperor",
  "Advent of Peace",
  "Feena, Super Cute Hunter",
  "Goblin Leader",
  "Goblin Mage",
  "Haru Urara [I'll Win Someday!]",
  "Oguri Cap [Surging Beast]",
];
